const basePath = process.env.BASE_URL || '/'

export const usaStates = [
  { value: null, text: 'State', disabled: true },
  { text: 'AL', value: 'AL' },
  { text: 'AK', value: 'AK' },
  { text: 'AZ', value: 'AZ' },
  { text: 'AR', value: 'AR' },
  { text: 'CA', value: 'CA' },
  { text: 'CO', value: 'CO' },
  { text: 'CT', value: 'CT' },
  { text: 'DE', value: 'DE' },
  { text: 'DC', value: 'DC' },
  { text: 'FL', value: 'FL' },
  { text: 'GA', value: 'GA' },
  { text: 'GU', value: 'GU' },
  { text: 'HI', value: 'HI' },
  { text: 'ID', value: 'ID' },
  { text: 'IL', value: 'IL' },
  { text: 'IN', value: 'IN' },
  { text: 'IA', value: 'IA' },
  { text: 'KS', value: 'KS' },
  { text: 'KY', value: 'KY' },
  { text: 'LA', value: 'LA' },
  { text: 'ME', value: 'ME' },
  { text: 'MD', value: 'MD' },
  { text: 'MA', value: 'MA' },
  { text: 'MI', value: 'MI' },
  { text: 'MN', value: 'MN' },
  { text: 'MS', value: 'MS' },
  { text: 'MO', value: 'MO' },
  { text: 'MT', value: 'MT' },
  { text: 'NE', value: 'NE' },
  { text: 'NV', value: 'NV' },
  { text: 'NH', value: 'NH' },
  { text: 'NJ', value: 'NJ' },
  { text: 'NM', value: 'NM' },
  { text: 'NY', value: 'NY' },
  { text: 'NC', value: 'NC' },
  { text: 'ND', value: 'ND' },
  { text: 'OH', value: 'OH' },
  { text: 'OK', value: 'OK' },
  { text: 'OR', value: 'OR' },
  { text: 'PA', value: 'PA' },
  { text: 'PR', value: 'PR' },
  { text: 'RI', value: 'RI' },
  { text: 'SC', value: 'SC' },
  { text: 'SD', value: 'SD' },
  { text: 'TN', value: 'TN' },
  { text: 'TX', value: 'TX' },
  { text: 'UT', value: 'UT' },
  { text: 'VT', value: 'VT' },
  { text: 'VI', value: 'VI' },
  { text: 'VA', value: 'VA' },
  { text: 'WA', value: 'WA' },
  { text: 'WV', value: 'WV' },
  { text: 'WI', value: 'WI' },
  { text: 'WY', value: 'WY' },
]

export const usaCanStates = [
  { value: null, text: 'Select', disabled: true },
  { text: 'AL', value: 'AL' },
  { text: 'AK', value: 'AK' },
  { text: 'AZ', value: 'AZ' },
  { text: 'AR', value: 'AR' },
  { text: 'CA', value: 'CA' },
  { text: 'CO', value: 'CO' },
  { text: 'CT', value: 'CT' },
  { text: 'DE', value: 'DE' },
  { text: 'DC', value: 'DC' },
  { text: 'FL', value: 'FL' },
  { text: 'GA', value: 'GA' },
  { text: 'GU', value: 'GU' },
  { text: 'HI', value: 'HI' },
  { text: 'ID', value: 'ID' },
  { text: 'IL', value: 'IL' },
  { text: 'IN', value: 'IN' },
  { text: 'IA', value: 'IA' },
  { text: 'KS', value: 'KS' },
  { text: 'KY', value: 'KY' },
  { text: 'LA', value: 'LA' },
  { text: 'ME', value: 'ME' },
  { text: 'MD', value: 'MD' },
  { text: 'MA', value: 'MA' },
  { text: 'MI', value: 'MI' },
  { text: 'MN', value: 'MN' },
  { text: 'MS', value: 'MS' },
  { text: 'MO', value: 'MO' },
  { text: 'MT', value: 'MT' },
  { text: 'NE', value: 'NE' },
  { text: 'NV', value: 'NV' },
  { text: 'NH', value: 'NH' },
  { text: 'NJ', value: 'NJ' },
  { text: 'NM', value: 'NM' },
  { text: 'NY', value: 'NY' },
  { text: 'NC', value: 'NC' },
  { text: 'ND', value: 'ND' },
  { text: 'OH', value: 'OH' },
  { text: 'OK', value: 'OK' },
  { text: 'OR', value: 'OR' },
  { text: 'PA', value: 'PA' },
  { text: 'PR', value: 'PR' },
  { text: 'RI', value: 'RI' },
  { text: 'SC', value: 'SC' },
  { text: 'SD', value: 'SD' },
  { text: 'TN', value: 'TN' },
  { text: 'TX', value: 'TX' },
  { text: 'UT', value: 'UT' },
  { text: 'VT', value: 'VT' },
  { text: 'VI', value: 'VI' },
  { text: 'VA', value: 'VA' },
  { text: 'WA', value: 'WA' },
  { text: 'WV', value: 'WV' },
  { text: 'WI', value: 'WI' },
  { text: 'WY', value: 'WY' },
  // // Begin Canadian Values
  // { text: 'AB', value: 'AB' },
  // { text: 'BC', value: 'BC' },
  // { text: 'MB', value: 'MB' },
  // { text: 'NB', value: 'NB' },
  // { text: 'NL', value: 'NL' },
  // { text: 'NT', value: 'NT' },
  // { text: 'NS', value: 'NS' },
  // { text: 'NU', value: 'NU' },
  // { text: 'ON', value: 'ON' },
  // { text: 'PE', value: 'PE' },
  // { text: 'QC', value: 'QC' },
  // { text: 'SK', value: 'SK' },
  // { text: 'YT', value: 'YT' },
]

export const canadianValues = [
  'AB',
  'BC',
  'MB',
  'NB',
  'NL',
  'NT',
  'NS',
  'NU',
  'ON',
  'PE',
  'QC',
  'SK',
  'YT',
]

export const monthsInYear = [
  { text: 'Month', value: null, disabled: true },
  { text: '01 - January', value: '01' },
  { text: '02 - February', value: '02' },
  { text: '03 - March', value: '03' },
  { text: '04 - April', value: '04' },
  { text: '05 - May', value: '05' },
  { text: '06 - June', value: '06' },
  { text: '07 - July', value: '07' },
  { text: '08 - August', value: '08' },
  { text: '09 - September', value: '09' },
  { text: '10 - October', value: '10' },
  { text: '11 - November', value: '11' },
  { text: '12 - December', value: '12' },
]

export const buybackMonths = [
  { text: 'Month', value: null, disabled: true },
  { text: 'January', value: '1' },
  { text: 'February', value: '2' },
  { text: 'March', value: '3' },
  { text: 'April', value: '4' },
  { text: 'May', value: '5' },
  { text: 'June', value: '6' },
  { text: 'July', value: '7' },
  { text: 'August', value: '8' },
  { text: 'September', value: '9' },
  { text: 'October', value: '10' },
  { text: 'November', value: '11' },
  { text: 'December', value: '12' },
]

export const imageClassValues = [
  {
    types: [
      'Alt Power - Electric Car',
      'Alt Power - Hybrid Car',
      'Alt Power - Hybrid Truck',
      'Alt Power - Natural Gas',
    ],
    value: 'Alt-Power',
  },
  {
    types: ['CUV - Entry Level', 'CUV - Mid Range', 'CUV - Premium'],
    value: 'CUV',
  },
  {
    types: [
      'Mid Range Car - Lower',
      'Mid Range Car - Premium',
      'Mid Range Car - Standard',
    ],
    value: 'Mid-Sized',
  },
  {
    types: ['Other'],
    value: 'Other',
  },
  {
    types: ['Pickup - Full Sized', 'Pickup - Small'],
    value: 'Pickup',
  },
  {
    types: ['Small Car - Budget'],
    value: 'Compact',
  },
  {
    types: ['Small Car - Economy'],
    value: 'Subcompact',
  },
  {
    types: [
      'Sport Car - Premium',
      'Sport Car - Touring',
      'Sport Car - Ultra Luxury',
      'Sport Car - Upper Premium',
    ],
    value: 'Sporty',
  },
  {
    types: [
      'SUV - Entry Level',
      'SUV - Large',
      'SUV - Lower Mid Range',
      'SUV - Pickup',
      'SUV - Premium Large',
      'SUV - Upper Mid Range',
    ],
    value: 'SUV',
  },
  {
    types: ['Traditional Car'],
    value: 'Mid-Sized',
  },
  {
    types: [
      'Upscale - Luxury',
      'Upscale - Near Luxury',
      'Upscale - Premium',
      'Upscale - Ultra',
    ],
    value: 'Luxury',
  },
  {
    types: ['Van - Full Sized', 'Van - Mini'],
    value: 'Van',
  },
]

export const defaultMenu = [
  {
    route: {
      name: 'reports-list',
      title: 'Order Vehicle History Reports',
    },
    items: [
      {
        name: 'reports-list',
        title: 'Order Vehicle History Reports',
      },
      {
        name: 'sample-report',
        title: 'See a Sample Vehicle History Report',
      },
    ],
  },
  {
    route: {
      name: 'vehicle-listing',
      title: 'Finding Vehicles',
    },
    items: [
      /* {
        name: 'vehicle-listings',
        title: 'Shop Used Car Listings',
      }, */
      {
        name: 'vehicle-listing',
        title: 'Vehicle Listings',
      },
      {
        name: 'autoshoppers-guide',
        title: 'How to Buy a Used Car',
      },
    ],
  },
  {
    route: {
      name: 'autocheck-vs-carfax',
      title: 'The AutoCheck Difference',
    },
    items: [
      {
        name: 'backed-by-experian',
        title: 'Data Backed by Experian',
      },
      {
        name: 'autocheck-score',
        title: 'The Patented AutoCheck Score',
      },
      {
        name: 'vehicle-buyback-protection',
        title: 'Vehicle Buyback Protection',
      },
      {
        name: 'subscription-benefits',
        title: 'VIN Checks for Subscribers',
      },
      {
        name: 'flood-risk',
        title: 'Flood Risk Check',
      },
    ],
  },
]

export const defaultMenuNoListing = [
  {
    route: {
      name: 'reports-list',
      title: 'Order Vehicle History Reports',
    },
    items: [
      {
        name: 'reports-list',
        title: 'Order Vehicle History Reports',
      },
      {
        name: 'sample-report',
        title: 'See a Sample Vehicle History Report',
      },
    ],
  },
  {
    route: {
      name: 'vehicle-listing',
      title: 'Finding Vehicles',
    },
    items: [
      {
        name: 'vehicle-listing',
        title: 'Vehicle Listings',
      },
      {
        name: 'autoshoppers-guide',
        title: 'How to Buy a Used Car',
      },
    ],
  },
  {
    route: {
      name: 'autocheck-vs-carfax',
      title: 'The AutoCheck Difference',
    },
    items: [
      {
        name: 'backed-by-experian',
        title: 'Data Backed by Experian',
      },
      {
        name: 'autocheck-score',
        title: 'The Patented AutoCheck Score',
      },
      {
        name: 'vehicle-buyback-protection',
        title: 'Vehicle Buyback Protection',
      },
      {
        name: 'subscription-benefits',
        title: 'VIN Checks for Subscribers',
      },
    ],
  },
]

export const recaptchaActions = {
  vinSearch: 'VinSearch',
  plateSearch: 'PlateSearch',
  floodRiskCheck: 'FloodRiskCheck',
  recallCheck: 'RecallCheck',
  loadAnalytics: 'LoadAnalytics',
}

// id is the partner id
// can be found in tc_consumer_partner
export const partnerDisplay = [
  {
    // Autocheck
    id: '0',
    menu: defaultMenu,
    headerPanel: undefined,
  },
  {
    // AutoTrader.com - siteId 7100-7300
    id: '26',
    menu: defaultMenuNoListing,
    headerPanel: {
      logo: basePath + 'images/AutoTrader.jpg',
      title: 'Proud to be Partnered with AutoTrader',
    },
  },
  {
    // autobytel.com - siteId 1800-1875
    id: '29',
    menu: defaultMenu,
    headerPanel: undefined,
  },
  {
    // Bank of America - siteId 192
    id: '32',
    menu: defaultMenu,
    headerPanel: undefined,
  },
  {
    // cargurus.com - siteId 3812-3816
    id: '43',
    menu: defaultMenuNoListing,
    headerPanel: {
      logo: basePath + 'images/CarGurus.png',
      title: 'Proud to be Partnered with CarGurus.com Discount',
    },
  },
  {
    // cargurus.com - siteId 3812-3816
    id: '44',
    menu: defaultMenuNoListing,
    headerPanel: {
      logo: basePath + 'images/CarGurus.png',
      title: 'Proud to be Partnered with CarGurus.com Discount',
    },
  },
  {
    // carbuyingtips.com - siteId 1311-1339
    id: '48',
    menu: defaultMenu,
    headerPanel: undefined,
  },
  {
    // cars.com - siteId 7070-7089
    id: '52',
    menu: defaultMenuNoListing,
    headerPanel: {
      logo: basePath + 'images/Cars-Com-Logo.png',
      title: 'Proud to be Partnered with Cars.com',
    },
  },
  {
    // Voucher enabled - siteId 7062-7064
    id: '64',
    menu: defaultMenu,
    headerPanel: undefined,
  },
  {
    // Savings.com- siteId 4000
    id: '65',
    menu: defaultMenu,
    headerPanel: undefined,
  },
  {
    // Ford Direct - siteId 3590-3597
    id: '77',
    menu: defaultMenu,
    headerPanel: undefined,
  },
  {
    // Ebay - siteId 201-239
    id: '90',
    menu: defaultMenuNoListing,
    headerPanel: {
      logo: basePath + 'images/ebay.png',
      title: 'Proud to be Partnered with eBay',
    },
  },
  {
    // Edmunds.com - siteId 6000-6300
    id: '93',
    menu: defaultMenuNoListing,
    headerPanel: {
      logo: basePath + 'images/edmunds-logo.png',
      title: 'Proud to be Partnered with Edmunds',
    },
  },
  {
    // Autocheck - siteId 189
    id: '97',
    menu: defaultMenu,
    headerPanel: undefined,
  },
  {
    // KBB - siteId 5000-5999
    id: '123',
    menu: defaultMenuNoListing,
    headerPanel: {
      logo: basePath + 'images/ribbonLogo-KBB.png',
      title: 'Proud to be Partnered with Kelley Blue Book',
    },
  },
  {
    // Google - siteId 1250-1288
    id: '128',
    menu: defaultMenu,
    headerPanel: undefined,
  },
  {
    // MSI BJ's Club - siteId 280-289
    id: '133',
    menu: defaultMenu,
    headerPanel: undefined,
  },
  {
    // MSI Sams Club - siteId 260-269
    id: '134',
    menu: defaultMenu,
    headerPanel: undefined,
  },
  {
    // MSN - siteId 2600-3339
    id: '135',
    menu: defaultMenu,
    headerPanel: undefined,
  },
  {
    // Military.com - siteId 240-249
    id: '137',
    menu: defaultMenu,
    headerPanel: undefined,
  },
  {
    // MACU - siteId 3690-3694
    id: '142',
    menu: defaultMenu,
    headerPanel: {
      logo: basePath + 'images/ribbonLogo-MACU.png',
      title: 'Proud to be Partnered with Mountain America Credit Union',
    },
  },
  {
    // NADAguides.com - JD Power - siteId 330-399
    id: '147',
    menu: defaultMenu,
    headerPanel: {
      logo: basePath + 'images/J.D.-Power.png',
      title: 'Proud to collaborate with J.D. Power',
    },
  },
  {
    // NADAguides.com - JD Power - siteId 1290-1300
    id: '151',
    menu: defaultMenu,
    headerPanel: {
      logo: basePath + 'images/J.D.-Power.png',
      title: 'Proud to collaborate with J.D. Power',
    },
  },
  {
    // Overture - siteId 800-890
    id: '159',
    menu: defaultMenu,
    headerPanel: {
      logo: basePath + 'images/J.D.-Power.png',
      title: 'Proud to collaborate with J.D. Power',
    },
  },
  {
    // Progressive.com - siteId 3807-3811
    id: '162',
    menu: defaultMenu,
    headerPanel: undefined,
  },
  {
    // WFS Financial - siteId 660-663
    id: '191',
    menu: defaultMenu,
    headerPanel: undefined,
  },
  {
    // Carsoup.com - siteId 1950-1978
    id: '203',
    menu: defaultMenu,
    headerPanel: undefined,
  },
  {
    // truecar.com - siteId 8900
    id: '209',
    menu: defaultMenuNoListing,
    headerPanel: {
      logo: basePath + 'images/TrueCar.png',
      title: 'Proud to be Partnered with TrueCar',
    },
  },
  {
    // MyPlace4parts - siteId 7500-7546
    id: '210',
    menu: defaultMenuNoListing,
    headerPanel: {
      logo: basePath + 'images/MyPlace4parts.png',
      title: 'Proud to be Partnered with MyPlace4Parts Discount',
    },
  },
  // commenting this section as per Tony's instructions as the fix was a short term one as stg and production were out of sync that time
  /* {
    // truecar.com - siteId 8900
    // This id section is only for staging
    // Because staging and productoni tc_partner_code is
    // out of sync.  So; until it's fixed leaving 212 for staging
    id: '212',
    menu: defaultMenuNoListing,
    headerPanel: {
      logo: basePath + 'images/TrueCar.png',
      title: 'Proud to be Partnered with TrueCar Discount',
    },
  }, */
]

export const liveChatHours = {
  saturday: 6,
  sunday: 0,
  openHour: 8,
  closeHour: 19,
}

export const carMakeModels = [
  {
    MAKE_CODE: 'ACURA',
    MAKE_DISPLAY: 'Acura',
    MODEL_CODE: 'INTEG',
    MODEL_DISPLAY: 'Integra',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ACURA',
    MAKE_DISPLAY: 'Acura',
    MODEL_CODE: 'LEGEND',
    MODEL_DISPLAY: 'Legend',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ACURA',
    MAKE_DISPLAY: 'Acura',
    MODEL_CODE: 'NSX',
    MODEL_DISPLAY: 'NSX',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ACURA',
    MAKE_DISPLAY: 'Acura',
    MODEL_CODE: 'SLX',
    MODEL_DISPLAY: 'SLX',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ACURA',
    MAKE_DISPLAY: 'Acura',
    MODEL_CODE: 'VIGOR',
    MODEL_DISPLAY: 'Vigor',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ACURA',
    MAKE_DISPLAY: 'Acura',
    MODEL_CODE: 'TSX',
    MODEL_DISPLAY: 'TSX',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ACURA',
    MAKE_DISPLAY: 'Acura',
    MODEL_CODE: 'ACUTLX',
    MODEL_DISPLAY: 'TLX',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ACURA',
    MAKE_DISPLAY: 'Acura',
    MODEL_CODE: 'TL',
    MODEL_DISPLAY: 'TL',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ACURA',
    MAKE_DISPLAY: 'Acura',
    MODEL_CODE: 'RL',
    MODEL_DISPLAY: 'RL',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ACURA',
    MAKE_DISPLAY: 'Acura',
    MODEL_CODE: 'RDX',
    MODEL_DISPLAY: 'RDX',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ACURA',
    MAKE_DISPLAY: 'Acura',
    MODEL_CODE: 'ILX',
    MODEL_DISPLAY: 'ILX',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ACURA',
    MAKE_DISPLAY: 'Acura',
    MODEL_CODE: 'ACUOTH',
    MODEL_DISPLAY: 'Other Acura Models',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ACURA',
    MAKE_DISPLAY: 'Acura',
    MODEL_CODE: 'MDX',
    MODEL_DISPLAY: 'MDX',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ACURA',
    MAKE_DISPLAY: 'Acura',
    MODEL_CODE: 'RSX',
    MODEL_DISPLAY: 'RSX',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ACURA',
    MAKE_DISPLAY: 'Acura',
    MODEL_CODE: 'RLX',
    MODEL_DISPLAY: 'RLX',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ACURA',
    MAKE_DISPLAY: 'Acura',
    MODEL_CODE: 'ACUCL',
    MODEL_DISPLAY: 'CL',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ACURA',
    MAKE_DISPLAY: 'Acura',
    MODEL_CODE: 'ZDX',
    MODEL_DISPLAY: 'ZDX',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ALFA',
    MAKE_DISPLAY: 'Alfa Romeo',
    MODEL_CODE: 'ALFA164',
    MODEL_DISPLAY: '164',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ALFA',
    MAKE_DISPLAY: 'Alfa Romeo',
    MODEL_CODE: 'ALFAGT',
    MODEL_DISPLAY: 'GTV-6',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ALFA',
    MAKE_DISPLAY: 'Alfa Romeo',
    MODEL_CODE: 'MIL',
    MODEL_DISPLAY: 'Milano',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ALFA',
    MAKE_DISPLAY: 'Alfa Romeo',
    MODEL_CODE: 'SPID',
    MODEL_DISPLAY: 'Spider',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ALFA',
    MAKE_DISPLAY: 'Alfa Romeo',
    MODEL_CODE: 'ALFAOTH',
    MODEL_DISPLAY: 'Other Alfa Romeo Models',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ALFA',
    MAKE_DISPLAY: 'Alfa Romeo',
    MODEL_CODE: 'ALFA8C',
    MODEL_DISPLAY: '8C Competizione',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ALFA',
    MAKE_DISPLAY: 'Alfa Romeo',
    MODEL_CODE: 'ALFASTELV',
    MODEL_DISPLAY: 'Stelvio',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ALFA',
    MAKE_DISPLAY: 'Alfa Romeo',
    MODEL_CODE: 'ALFAGIULIA',
    MODEL_DISPLAY: 'Giulia',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ALFA',
    MAKE_DISPLAY: 'Alfa Romeo',
    MODEL_CODE: 'ALFA4C',
    MODEL_DISPLAY: '4C',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'AMC',
    MAKE_DISPLAY: 'AMC',
    MODEL_CODE: 'AMCALLIAN',
    MODEL_DISPLAY: 'Alliance',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'AMC',
    MAKE_DISPLAY: 'AMC',
    MODEL_CODE: 'AMCENC',
    MODEL_DISPLAY: 'Encore',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'AMC',
    MAKE_DISPLAY: 'AMC',
    MODEL_CODE: 'AMCSPIRIT',
    MODEL_DISPLAY: 'Spirit',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'AMC',
    MAKE_DISPLAY: 'AMC',
    MODEL_CODE: 'CON',
    MODEL_DISPLAY: 'Concord',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'AMC',
    MAKE_DISPLAY: 'AMC',
    MODEL_CODE: 'EAGLE',
    MODEL_DISPLAY: 'Eagle',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'AMC',
    MAKE_DISPLAY: 'AMC',
    MODEL_CODE: 'AMCOTH',
    MODEL_DISPLAY: 'Other AMC Models',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'AMGEN',
    MAKE_DISPLAY: 'HUMMER',
    MODEL_CODE: 'HUMMER',
    MODEL_DISPLAY: 'H1',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'AMGEN',
    MAKE_DISPLAY: 'HUMMER',
    MODEL_CODE: 'H2',
    MODEL_DISPLAY: 'H2',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'AMGEN',
    MAKE_DISPLAY: 'HUMMER',
    MODEL_CODE: 'H3',
    MODEL_DISPLAY: 'H3',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'AMGEN',
    MAKE_DISPLAY: 'HUMMER',
    MODEL_CODE: 'AMGOTH',
    MODEL_DISPLAY: 'Other Hummer Models',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'AMGEN',
    MAKE_DISPLAY: 'HUMMER',
    MODEL_CODE: 'H3T',
    MODEL_DISPLAY: 'H3T',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ASTON',
    MAKE_DISPLAY: 'Aston Martin',
    MODEL_CODE: 'DB7',
    MODEL_DISPLAY: 'DB7',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ASTON',
    MAKE_DISPLAY: 'Aston Martin',
    MODEL_CODE: 'VANQUISH',
    MODEL_DISPLAY: 'Vanquish',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ASTON',
    MAKE_DISPLAY: 'Aston Martin',
    MODEL_CODE: 'VIRAGE',
    MODEL_DISPLAY: 'Virage',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ASTON',
    MAKE_DISPLAY: 'Aston Martin',
    MODEL_CODE: 'ASTRAPIDES',
    MODEL_DISPLAY: 'Rapide S',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ASTON',
    MAKE_DISPLAY: 'Aston Martin',
    MODEL_CODE: 'DB9',
    MODEL_DISPLAY: 'DB9',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ASTON',
    MAKE_DISPLAY: 'Aston Martin',
    MODEL_CODE: 'VANTAGE',
    MODEL_DISPLAY: 'V8 Vantage',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ASTON',
    MAKE_DISPLAY: 'Aston Martin',
    MODEL_CODE: 'RAPIDE',
    MODEL_DISPLAY: 'Rapide',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ASTON',
    MAKE_DISPLAY: 'Aston Martin',
    MODEL_CODE: 'ASTOTH',
    MODEL_DISPLAY: 'Other Aston Martin Models',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ASTON',
    MAKE_DISPLAY: 'Aston Martin',
    MODEL_CODE: 'LAGONDA',
    MODEL_DISPLAY: 'Lagonda',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ASTON',
    MAKE_DISPLAY: 'Aston Martin',
    MODEL_CODE: 'ASTONDB11',
    MODEL_DISPLAY: 'DB11',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ASTON',
    MAKE_DISPLAY: 'Aston Martin',
    MODEL_CODE: 'V12VANT',
    MODEL_DISPLAY: 'V12 Vantage',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ASTON',
    MAKE_DISPLAY: 'Aston Martin',
    MODEL_CODE: 'DBS',
    MODEL_DISPLAY: 'DBS',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'AUDI',
    MAKE_DISPLAY: 'Audi',
    MODEL_CODE: '4000',
    MODEL_DISPLAY: '4000',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'AUDI',
    MAKE_DISPLAY: 'Audi',
    MODEL_CODE: '5000',
    MODEL_DISPLAY: '5000',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'AUDI',
    MAKE_DISPLAY: 'Audi',
    MODEL_CODE: '90',
    MODEL_DISPLAY: '90',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'AUDI',
    MAKE_DISPLAY: 'Audi',
    MODEL_CODE: 'A4',
    MODEL_DISPLAY: 'A4',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'AUDI',
    MAKE_DISPLAY: 'Audi',
    MODEL_CODE: 'A6',
    MODEL_DISPLAY: 'A6',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'AUDI',
    MAKE_DISPLAY: 'Audi',
    MODEL_CODE: 'AUDI200',
    MODEL_DISPLAY: '200',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'AUDI',
    MAKE_DISPLAY: 'Audi',
    MODEL_CODE: 'AUDICABRI',
    MODEL_DISPLAY: 'Cabriolet',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'AUDI',
    MAKE_DISPLAY: 'Audi',
    MODEL_CODE: 'QUATTR',
    MODEL_DISPLAY: 'Quattro',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'AUDI',
    MAKE_DISPLAY: 'Audi',
    MODEL_CODE: 'S4',
    MODEL_DISPLAY: 'S4',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'AUDI',
    MAKE_DISPLAY: 'Audi',
    MODEL_CODE: 'S6',
    MODEL_DISPLAY: 'S6',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'AUDI',
    MAKE_DISPLAY: 'Audi',
    MODEL_CODE: 'V8',
    MODEL_DISPLAY: 'V8 Quattro',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'AUDI',
    MAKE_DISPLAY: 'Audi',
    MODEL_CODE: 'A7',
    MODEL_DISPLAY: 'A7',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'AUDI',
    MAKE_DISPLAY: 'Audi',
    MODEL_CODE: 'TTRS',
    MODEL_DISPLAY: 'TT RS',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'AUDI',
    MAKE_DISPLAY: 'Audi',
    MODEL_CODE: 'S7',
    MODEL_DISPLAY: 'S7',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'AUDI',
    MAKE_DISPLAY: 'Audi',
    MODEL_CODE: 'RS6',
    MODEL_DISPLAY: 'RS 6',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'AUDI',
    MAKE_DISPLAY: 'Audi',
    MODEL_CODE: 'AUDS3',
    MODEL_DISPLAY: 'S3',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'AUDI',
    MAKE_DISPLAY: 'Audi',
    MODEL_CODE: 'A8',
    MODEL_DISPLAY: 'A8',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'AUDI',
    MAKE_DISPLAY: 'Audi',
    MODEL_CODE: 'AUDICOUPE',
    MODEL_DISPLAY: 'Coupe',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'AUDI',
    MAKE_DISPLAY: 'Audi',
    MODEL_CODE: 'A3',
    MODEL_DISPLAY: 'A3',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'AUDI',
    MAKE_DISPLAY: 'Audi',
    MODEL_CODE: 'RS4',
    MODEL_DISPLAY: 'RS 4',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'AUDI',
    MAKE_DISPLAY: 'Audi',
    MODEL_CODE: 'Q7',
    MODEL_DISPLAY: 'Q7',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'AUDI',
    MAKE_DISPLAY: 'Audi',
    MODEL_CODE: '80',
    MODEL_DISPLAY: '80',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'AUDI',
    MAKE_DISPLAY: 'Audi',
    MODEL_CODE: 'AUDI100',
    MODEL_DISPLAY: '100',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'AUDI',
    MAKE_DISPLAY: 'Audi',
    MODEL_CODE: 'TT',
    MODEL_DISPLAY: 'TT',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'AUDI',
    MAKE_DISPLAY: 'Audi',
    MODEL_CODE: 'AUDOTH',
    MODEL_DISPLAY: 'Other Audi Models',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'AUDI',
    MAKE_DISPLAY: 'Audi',
    MODEL_CODE: 'ALLRDQUA',
    MODEL_DISPLAY: 'allroad',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'AUDI',
    MAKE_DISPLAY: 'Audi',
    MODEL_CODE: 'S8',
    MODEL_DISPLAY: 'S8',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'AUDI',
    MAKE_DISPLAY: 'Audi',
    MODEL_CODE: 'Q3',
    MODEL_DISPLAY: 'Q3',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'AUDI',
    MAKE_DISPLAY: 'Audi',
    MODEL_CODE: 'RS5',
    MODEL_DISPLAY: 'RS 5',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'AUDI',
    MAKE_DISPLAY: 'Audi',
    MODEL_CODE: 'AUDIRS3',
    MODEL_DISPLAY: 'RS 3',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'AUDI',
    MAKE_DISPLAY: 'Audi',
    MODEL_CODE: 'AUDIQ8',
    MODEL_DISPLAY: 'Q8',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'AUDI',
    MAKE_DISPLAY: 'Audi',
    MODEL_CODE: 'R8',
    MODEL_DISPLAY: 'R8',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'AUDI',
    MAKE_DISPLAY: 'Audi',
    MODEL_CODE: 'TTS',
    MODEL_DISPLAY: 'TTS',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'AUDI',
    MAKE_DISPLAY: 'Audi',
    MODEL_CODE: 'Q5',
    MODEL_DISPLAY: 'Q5',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'AUDI',
    MAKE_DISPLAY: 'Audi',
    MODEL_CODE: 'AUDIRS7',
    MODEL_DISPLAY: 'RS 7',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'AUDI',
    MAKE_DISPLAY: 'Audi',
    MODEL_CODE: 'AUDISQ5',
    MODEL_DISPLAY: 'SQ5',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'AUDI',
    MAKE_DISPLAY: 'Audi',
    MODEL_CODE: 'A5',
    MODEL_DISPLAY: 'A5',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'AUDI',
    MAKE_DISPLAY: 'Audi',
    MODEL_CODE: 'S5',
    MODEL_DISPLAY: 'S5',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'BENTL',
    MAKE_DISPLAY: 'Bentley',
    MODEL_CODE: 'BROOKLANDS',
    MODEL_DISPLAY: 'Brooklands',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'BENTL',
    MAKE_DISPLAY: 'Bentley',
    MODEL_CODE: 'BENFLYSPUR',
    MODEL_DISPLAY: 'Flying Spur',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'BENTL',
    MAKE_DISPLAY: 'Bentley',
    MODEL_CODE: 'ARNAGE',
    MODEL_DISPLAY: 'Arnage',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'BENTL',
    MAKE_DISPLAY: 'Bentley',
    MODEL_CODE: 'AZURE',
    MODEL_DISPLAY: 'Azure',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'BENTL',
    MAKE_DISPLAY: 'Bentley',
    MODEL_CODE: 'BENCONT',
    MODEL_DISPLAY: 'Continental',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'BENTL',
    MAKE_DISPLAY: 'Bentley',
    MODEL_CODE: 'BENMUL',
    MODEL_DISPLAY: 'Mulsanne',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'BENTL',
    MAKE_DISPLAY: 'Bentley',
    MODEL_CODE: 'BENTURBO',
    MODEL_DISPLAY: 'Turbo R',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'BENTL',
    MAKE_DISPLAY: 'Bentley',
    MODEL_CODE: 'BENEIGHT',
    MODEL_DISPLAY: 'Eight',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'BENTL',
    MAKE_DISPLAY: 'Bentley',
    MODEL_CODE: 'BENOTH',
    MODEL_DISPLAY: 'Other Bentley Models',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'BENTL',
    MAKE_DISPLAY: 'Bentley',
    MODEL_CODE: 'BENBENTAY',
    MODEL_DISPLAY: 'Bentayga',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMWM2',
    MODEL_DISPLAY: 'M2',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMW740LDXD',
    MODEL_DISPLAY: '740Ld xDrive',
    CLASS_SERIES_CODE: '7_SERIES',
    CLASS_SERIES_DISPLAY: '7 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMW530IXD',
    MODEL_DISPLAY: '530i xDrive',
    CLASS_SERIES_CODE: '5_SERIES',
    CLASS_SERIES_DISPLAY: '5 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '1SERIESM',
    MODEL_DISPLAY: '1 Series M',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'ACTIVE5',
    MODEL_DISPLAY: 'ActiveHybrid 5',
    CLASS_SERIES_CODE: '5_SERIES',
    CLASS_SERIES_DISPLAY: '5 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '323I',
    MODEL_DISPLAY: '323i',
    CLASS_SERIES_CODE: '3_SERIES',
    CLASS_SERIES_DISPLAY: '3 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '524TD',
    MODEL_DISPLAY: '524td',
    CLASS_SERIES_CODE: '5_SERIES',
    CLASS_SERIES_DISPLAY: '5 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMW325',
    MODEL_DISPLAY: '325',
    CLASS_SERIES_CODE: '3_SERIES',
    CLASS_SERIES_DISPLAY: '3 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'L7',
    MODEL_DISPLAY: 'L7',
    CLASS_SERIES_CODE: '7_SERIES',
    CLASS_SERIES_DISPLAY: '7 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'M5',
    MODEL_DISPLAY: 'M5',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'M6',
    MODEL_DISPLAY: 'M6',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'Z3',
    MODEL_DISPLAY: 'Z3',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '325IX',
    MODEL_DISPLAY: '325iX',
    CLASS_SERIES_CODE: '3_SERIES',
    CLASS_SERIES_DISPLAY: '3 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '325XI',
    MODEL_DISPLAY: '325xi',
    CLASS_SERIES_CODE: '3_SERIES',
    CLASS_SERIES_DISPLAY: '3 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'Z4',
    MODEL_DISPLAY: 'Z4',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '745LI',
    MODEL_DISPLAY: '745Li',
    CLASS_SERIES_CODE: '7_SERIES',
    CLASS_SERIES_DISPLAY: '7 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '760LI',
    MODEL_DISPLAY: '760Li',
    CLASS_SERIES_CODE: '7_SERIES',
    CLASS_SERIES_DISPLAY: '7 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '545I',
    MODEL_DISPLAY: '545i',
    CLASS_SERIES_CODE: '5_SERIES',
    CLASS_SERIES_DISPLAY: '5 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '645CI',
    MODEL_DISPLAY: '645Ci',
    CLASS_SERIES_CODE: '6_SERIES',
    CLASS_SERIES_DISPLAY: '6 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'X3',
    MODEL_DISPLAY: 'X3',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '760I',
    MODEL_DISPLAY: '760i',
    CLASS_SERIES_CODE: '7_SERIES',
    CLASS_SERIES_DISPLAY: '7 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMW640IXD',
    MODEL_DISPLAY: '640i xDrive',
    CLASS_SERIES_CODE: '6_SERIES',
    CLASS_SERIES_DISPLAY: '6 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMW640GCXD',
    MODEL_DISPLAY: '640i Gran Coupe xDrive',
    CLASS_SERIES_CODE: '6_SERIES',
    CLASS_SERIES_DISPLAY: '6 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMW535D',
    MODEL_DISPLAY: '535d',
    CLASS_SERIES_CODE: '5_SERIES',
    CLASS_SERIES_DISPLAY: '5 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMWB6XDGC',
    MODEL_DISPLAY: 'ALPINA B6 xDrive Gran Coupe',
    CLASS_SERIES_CODE: '6_SERIES',
    CLASS_SERIES_DISPLAY: '6 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMWM4',
    MODEL_DISPLAY: 'M4',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMW228IXD',
    MODEL_DISPLAY: '228i xDrive',
    CLASS_SERIES_CODE: '2_SERIES',
    CLASS_SERIES_DISPLAY: '2 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMW535DXD',
    MODEL_DISPLAY: '535d xDrive',
    CLASS_SERIES_CODE: '5_SERIES',
    CLASS_SERIES_DISPLAY: '5 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMW328D',
    MODEL_DISPLAY: '328d',
    CLASS_SERIES_CODE: '3_SERIES',
    CLASS_SERIES_DISPLAY: '3 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMW328DXD',
    MODEL_DISPLAY: '328d xDrive',
    CLASS_SERIES_CODE: '3_SERIES',
    CLASS_SERIES_DISPLAY: '3 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMW328GTXD',
    MODEL_DISPLAY: '328i Gran Turismo xDrive',
    CLASS_SERIES_CODE: '3_SERIES',
    CLASS_SERIES_DISPLAY: '3 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMW335GTXD',
    MODEL_DISPLAY: '335i Gran Turismo xDrive',
    CLASS_SERIES_CODE: '3_SERIES',
    CLASS_SERIES_DISPLAY: '3 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMWI8',
    MODEL_DISPLAY: 'i8',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '320I',
    MODEL_DISPLAY: '320i',
    CLASS_SERIES_CODE: '3_SERIES',
    CLASS_SERIES_DISPLAY: '3 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '323IS',
    MODEL_DISPLAY: '323is',
    CLASS_SERIES_CODE: '3_SERIES',
    CLASS_SERIES_DISPLAY: '3 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '750I',
    MODEL_DISPLAY: '750i',
    CLASS_SERIES_CODE: '7_SERIES',
    CLASS_SERIES_DISPLAY: '7 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '750LI',
    MODEL_DISPLAY: '750Li',
    CLASS_SERIES_CODE: '7_SERIES',
    CLASS_SERIES_DISPLAY: '7 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '530XI',
    MODEL_DISPLAY: '530xi',
    CLASS_SERIES_CODE: '5_SERIES',
    CLASS_SERIES_DISPLAY: '5 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '525XI',
    MODEL_DISPLAY: '525xi',
    CLASS_SERIES_CODE: '5_SERIES',
    CLASS_SERIES_DISPLAY: '5 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '550I',
    MODEL_DISPLAY: '550i',
    CLASS_SERIES_CODE: '5_SERIES',
    CLASS_SERIES_DISPLAY: '5 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '335I',
    MODEL_DISPLAY: '335i',
    CLASS_SERIES_CODE: '3_SERIES',
    CLASS_SERIES_DISPLAY: '3 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'M3',
    MODEL_DISPLAY: 'M3',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMWMCOUPE',
    MODEL_DISPLAY: 'M Coupe',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '135IS',
    MODEL_DISPLAY: '135is',
    CLASS_SERIES_CODE: '1_SERIES',
    CLASS_SERIES_DISPLAY: '1 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '330CI',
    MODEL_DISPLAY: '330Ci',
    CLASS_SERIES_CODE: '3_SERIES',
    CLASS_SERIES_DISPLAY: '3 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '330I',
    MODEL_DISPLAY: '330i',
    CLASS_SERIES_CODE: '3_SERIES',
    CLASS_SERIES_DISPLAY: '3 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '330XI',
    MODEL_DISPLAY: '330xi',
    CLASS_SERIES_CODE: '3_SERIES',
    CLASS_SERIES_DISPLAY: '3 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '650IGC',
    MODEL_DISPLAY: '650i Gran Coupe',
    CLASS_SERIES_CODE: '6_SERIES',
    CLASS_SERIES_DISPLAY: '6 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'ACTIVE3',
    MODEL_DISPLAY: 'ActiveHybrid 3',
    CLASS_SERIES_CODE: '3_SERIES',
    CLASS_SERIES_DISPLAY: '3 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'L6',
    MODEL_DISPLAY: 'L6',
    CLASS_SERIES_CODE: '6_SERIES',
    CLASS_SERIES_DISPLAY: '6 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMWX4',
    MODEL_DISPLAY: 'X4',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '318I',
    MODEL_DISPLAY: '318i',
    CLASS_SERIES_CODE: '3_SERIES',
    CLASS_SERIES_DISPLAY: '3 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '318IS',
    MODEL_DISPLAY: '318iS',
    CLASS_SERIES_CODE: '3_SERIES',
    CLASS_SERIES_DISPLAY: '3 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '318TI',
    MODEL_DISPLAY: '318ti',
    CLASS_SERIES_CODE: '3_SERIES',
    CLASS_SERIES_DISPLAY: '3 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '328CI',
    MODEL_DISPLAY: '328Ci',
    CLASS_SERIES_CODE: '3_SERIES',
    CLASS_SERIES_DISPLAY: '3 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '328I',
    MODEL_DISPLAY: '328i',
    CLASS_SERIES_CODE: '3_SERIES',
    CLASS_SERIES_DISPLAY: '3 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '328IS',
    MODEL_DISPLAY: '328iS',
    CLASS_SERIES_CODE: '3_SERIES',
    CLASS_SERIES_DISPLAY: '3 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '525I',
    MODEL_DISPLAY: '525i',
    CLASS_SERIES_CODE: '5_SERIES',
    CLASS_SERIES_DISPLAY: '5 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '528E',
    MODEL_DISPLAY: '528e',
    CLASS_SERIES_CODE: '5_SERIES',
    CLASS_SERIES_DISPLAY: '5 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '528I',
    MODEL_DISPLAY: '528i',
    CLASS_SERIES_CODE: '5_SERIES',
    CLASS_SERIES_DISPLAY: '5 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '530I',
    MODEL_DISPLAY: '530i',
    CLASS_SERIES_CODE: '5_SERIES',
    CLASS_SERIES_DISPLAY: '5 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '533I',
    MODEL_DISPLAY: '533i',
    CLASS_SERIES_CODE: '5_SERIES',
    CLASS_SERIES_DISPLAY: '5 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '535I',
    MODEL_DISPLAY: '535i',
    CLASS_SERIES_CODE: '5_SERIES',
    CLASS_SERIES_DISPLAY: '5 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '540I',
    MODEL_DISPLAY: '540i',
    CLASS_SERIES_CODE: '5_SERIES',
    CLASS_SERIES_DISPLAY: '5 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '633CSI',
    MODEL_DISPLAY: '633CSi',
    CLASS_SERIES_CODE: '6_SERIES',
    CLASS_SERIES_DISPLAY: '6 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '635CSI',
    MODEL_DISPLAY: '635CSi',
    CLASS_SERIES_CODE: '6_SERIES',
    CLASS_SERIES_DISPLAY: '6 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '733I',
    MODEL_DISPLAY: '733i',
    CLASS_SERIES_CODE: '7_SERIES',
    CLASS_SERIES_DISPLAY: '7 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '735I',
    MODEL_DISPLAY: '735i',
    CLASS_SERIES_CODE: '7_SERIES',
    CLASS_SERIES_DISPLAY: '7 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '735IL',
    MODEL_DISPLAY: '735iL',
    CLASS_SERIES_CODE: '7_SERIES',
    CLASS_SERIES_DISPLAY: '7 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '740I',
    MODEL_DISPLAY: '740i',
    CLASS_SERIES_CODE: '7_SERIES',
    CLASS_SERIES_DISPLAY: '7 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '740IL',
    MODEL_DISPLAY: '740iL',
    CLASS_SERIES_CODE: '7_SERIES',
    CLASS_SERIES_DISPLAY: '7 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '745I',
    MODEL_DISPLAY: '745i',
    CLASS_SERIES_CODE: '7_SERIES',
    CLASS_SERIES_DISPLAY: '7 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '750IL',
    MODEL_DISPLAY: '750iL',
    CLASS_SERIES_CODE: '7_SERIES',
    CLASS_SERIES_DISPLAY: '7 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '840CI',
    MODEL_DISPLAY: '840Ci',
    CLASS_SERIES_CODE: '8_SERIES',
    CLASS_SERIES_DISPLAY: '8 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '850CI',
    MODEL_DISPLAY: '850Ci',
    CLASS_SERIES_CODE: '8_SERIES',
    CLASS_SERIES_DISPLAY: '8 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '850CSI',
    MODEL_DISPLAY: '850CSi',
    CLASS_SERIES_CODE: '8_SERIES',
    CLASS_SERIES_DISPLAY: '8 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '850I',
    MODEL_DISPLAY: '850i',
    CLASS_SERIES_CODE: '8_SERIES',
    CLASS_SERIES_DISPLAY: '8 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '325CI',
    MODEL_DISPLAY: '325Ci',
    CLASS_SERIES_CODE: '3_SERIES',
    CLASS_SERIES_DISPLAY: '3 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '325E',
    MODEL_DISPLAY: '325e',
    CLASS_SERIES_CODE: '3_SERIES',
    CLASS_SERIES_DISPLAY: '3 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '325I',
    MODEL_DISPLAY: '325i',
    CLASS_SERIES_CODE: '3_SERIES',
    CLASS_SERIES_DISPLAY: '3 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '325IS',
    MODEL_DISPLAY: '325is',
    CLASS_SERIES_CODE: '3_SERIES',
    CLASS_SERIES_DISPLAY: '3 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMWI3',
    MODEL_DISPLAY: 'i3',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '328XI',
    MODEL_DISPLAY: '328xi',
    CLASS_SERIES_CODE: '3_SERIES',
    CLASS_SERIES_DISPLAY: '3 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMW228I',
    MODEL_DISPLAY: '228i',
    CLASS_SERIES_CODE: '2_SERIES',
    CLASS_SERIES_DISPLAY: '2 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'X5',
    MODEL_DISPLAY: 'X5',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMWOTH',
    MODEL_DISPLAY: 'Other BMW Models',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'Z8',
    MODEL_DISPLAY: 'Z8',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMWM235I',
    MODEL_DISPLAY: 'M235i',
    CLASS_SERIES_CODE: '2_SERIES',
    CLASS_SERIES_DISPLAY: '2 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '323CI',
    MODEL_DISPLAY: '323ci',
    CLASS_SERIES_CODE: '3_SERIES',
    CLASS_SERIES_DISPLAY: '3 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '335D',
    MODEL_DISPLAY: '335d',
    CLASS_SERIES_CODE: '3_SERIES',
    CLASS_SERIES_DISPLAY: '3 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'X1',
    MODEL_DISPLAY: 'X1',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMWM6GC',
    MODEL_DISPLAY: 'M6 Gran Coupe',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMW330E',
    MODEL_DISPLAY: '330e',
    CLASS_SERIES_CODE: '3_SERIES',
    CLASS_SERIES_DISPLAY: '3 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMW740IXD',
    MODEL_DISPLAY: '740i xDrive',
    CLASS_SERIES_CODE: '7_SERIES',
    CLASS_SERIES_DISPLAY: '7 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMW330XDGT',
    MODEL_DISPLAY: '330i Gran Turismo xDrive',
    CLASS_SERIES_CODE: '3_SERIES',
    CLASS_SERIES_DISPLAY: '3 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMW340XDGT',
    MODEL_DISPLAY: '340i Gran Turismo xDrive',
    CLASS_SERIES_CODE: '3_SERIES',
    CLASS_SERIES_DISPLAY: '3 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMW440GC',
    MODEL_DISPLAY: '440i Gran Coupe',
    CLASS_SERIES_CODE: '4_SERIES',
    CLASS_SERIES_DISPLAY: '4 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '740LI',
    MODEL_DISPLAY: '740Li',
    CLASS_SERIES_CODE: '7_SERIES',
    CLASS_SERIES_DISPLAY: '7 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMW440GCXD',
    MODEL_DISPLAY: '440i Gran Coupe xDrive',
    CLASS_SERIES_CODE: '4_SERIES',
    CLASS_SERIES_DISPLAY: '4 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMWM240I',
    MODEL_DISPLAY: 'M240i',
    CLASS_SERIES_CODE: '2_SERIES',
    CLASS_SERIES_DISPLAY: '2 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMWM240IXD',
    MODEL_DISPLAY: 'M240i xDrive',
    CLASS_SERIES_CODE: '2_SERIES',
    CLASS_SERIES_DISPLAY: '2 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMW740EXD',
    MODEL_DISPLAY: '740e xDrive',
    CLASS_SERIES_CODE: '7_SERIES',
    CLASS_SERIES_DISPLAY: '7 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMWM760IXD',
    MODEL_DISPLAY: 'M760i xDrive',
    CLASS_SERIES_CODE: '7_SERIES',
    CLASS_SERIES_DISPLAY: '7 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMW530EXD',
    MODEL_DISPLAY: '530e xDrive',
    CLASS_SERIES_CODE: '5_SERIES',
    CLASS_SERIES_DISPLAY: '5 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMWX2',
    MODEL_DISPLAY: 'X2',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMW850IXD',
    MODEL_DISPLAY: 'M850i xDrive',
    CLASS_SERIES_CODE: '8_SERIES',
    CLASS_SERIES_DISPLAY: '8 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '650I',
    MODEL_DISPLAY: '650i',
    CLASS_SERIES_CODE: '6_SERIES',
    CLASS_SERIES_DISPLAY: '6 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMWM550IXD',
    MODEL_DISPLAY: 'M550i xDrive',
    CLASS_SERIES_CODE: '5_SERIES',
    CLASS_SERIES_DISPLAY: '5 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMW530E',
    MODEL_DISPLAY: '530e',
    CLASS_SERIES_CODE: '5_SERIES',
    CLASS_SERIES_DISPLAY: '5 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'X5M',
    MODEL_DISPLAY: 'X5 M',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'X6M',
    MODEL_DISPLAY: 'X6 M',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '325ES',
    MODEL_DISPLAY: '325es',
    CLASS_SERIES_CODE: '3_SERIES',
    CLASS_SERIES_DISPLAY: '3 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMW540DXD',
    MODEL_DISPLAY: '540d xDrive',
    CLASS_SERIES_CODE: '5_SERIES',
    CLASS_SERIES_DISPLAY: '5 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '535XI',
    MODEL_DISPLAY: '535xi',
    CLASS_SERIES_CODE: '5_SERIES',
    CLASS_SERIES_DISPLAY: '5 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '528XI',
    MODEL_DISPLAY: '528xi',
    CLASS_SERIES_CODE: '5_SERIES',
    CLASS_SERIES_DISPLAY: '5 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '335XI',
    MODEL_DISPLAY: '335xi',
    CLASS_SERIES_CODE: '3_SERIES',
    CLASS_SERIES_DISPLAY: '3 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMWROAD',
    MODEL_DISPLAY: 'M Roadster',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '640I',
    MODEL_DISPLAY: '640i',
    CLASS_SERIES_CODE: '6_SERIES',
    CLASS_SERIES_DISPLAY: '6 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '335IS',
    MODEL_DISPLAY: '335is',
    CLASS_SERIES_CODE: '3_SERIES',
    CLASS_SERIES_DISPLAY: '3 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMW428I',
    MODEL_DISPLAY: '428i',
    CLASS_SERIES_CODE: '4_SERIES',
    CLASS_SERIES_DISPLAY: '4 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '550IGT',
    MODEL_DISPLAY: '550i Gran Turismo',
    CLASS_SERIES_CODE: '5_SERIES',
    CLASS_SERIES_DISPLAY: '5 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMW435I',
    MODEL_DISPLAY: '435i',
    CLASS_SERIES_CODE: '4_SERIES',
    CLASS_SERIES_DISPLAY: '4 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMW428IXD',
    MODEL_DISPLAY: '428i xDrive',
    CLASS_SERIES_CODE: '4_SERIES',
    CLASS_SERIES_DISPLAY: '4 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMW435IXD',
    MODEL_DISPLAY: '435i xDrive',
    CLASS_SERIES_CODE: '4_SERIES',
    CLASS_SERIES_DISPLAY: '4 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMW428GC',
    MODEL_DISPLAY: '428i Gran Coupe',
    CLASS_SERIES_CODE: '4_SERIES',
    CLASS_SERIES_DISPLAY: '4 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMW428GCXD',
    MODEL_DISPLAY: '428i Gran Coupe xDrive',
    CLASS_SERIES_CODE: '4_SERIES',
    CLASS_SERIES_DISPLAY: '4 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMW435GC',
    MODEL_DISPLAY: '435i Gran Coupe',
    CLASS_SERIES_CODE: '4_SERIES',
    CLASS_SERIES_DISPLAY: '4 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMW435GCXD',
    MODEL_DISPLAY: '435i Gran Coupe xDrive',
    CLASS_SERIES_CODE: '4_SERIES',
    CLASS_SERIES_DISPLAY: '4 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'ALPINAB7',
    MODEL_DISPLAY: 'ALPINA B7',
    CLASS_SERIES_CODE: '7_SERIES',
    CLASS_SERIES_DISPLAY: '7 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMW340IXD',
    MODEL_DISPLAY: '340i xDrive',
    CLASS_SERIES_CODE: '3_SERIES',
    CLASS_SERIES_DISPLAY: '3 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '640IGC',
    MODEL_DISPLAY: '640i Gran Coupe',
    CLASS_SERIES_CODE: '6_SERIES',
    CLASS_SERIES_DISPLAY: '6 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMW340I',
    MODEL_DISPLAY: '340i',
    CLASS_SERIES_CODE: '3_SERIES',
    CLASS_SERIES_DISPLAY: '3 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '320IXD',
    MODEL_DISPLAY: '320i xDrive',
    CLASS_SERIES_CODE: '3_SERIES',
    CLASS_SERIES_DISPLAY: '3 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMW230I',
    MODEL_DISPLAY: '230i',
    CLASS_SERIES_CODE: '2_SERIES',
    CLASS_SERIES_DISPLAY: '2 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMW230IXD',
    MODEL_DISPLAY: '230i xDrive',
    CLASS_SERIES_CODE: '2_SERIES',
    CLASS_SERIES_DISPLAY: '2 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMW330IXD',
    MODEL_DISPLAY: '330i xDrive',
    CLASS_SERIES_CODE: '3_SERIES',
    CLASS_SERIES_DISPLAY: '3 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMW430I',
    MODEL_DISPLAY: '430i',
    CLASS_SERIES_CODE: '4_SERIES',
    CLASS_SERIES_DISPLAY: '4 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMW430IXD',
    MODEL_DISPLAY: '430i xDrive',
    CLASS_SERIES_CODE: '4_SERIES',
    CLASS_SERIES_DISPLAY: '4 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMW430GC',
    MODEL_DISPLAY: '430i Gran Coupe',
    CLASS_SERIES_CODE: '4_SERIES',
    CLASS_SERIES_DISPLAY: '4 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMW430GCXD',
    MODEL_DISPLAY: '430i Gran Coupe xDrive',
    CLASS_SERIES_CODE: '4_SERIES',
    CLASS_SERIES_DISPLAY: '4 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMW440I',
    MODEL_DISPLAY: '440i',
    CLASS_SERIES_CODE: '4_SERIES',
    CLASS_SERIES_DISPLAY: '4 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMW440IXD',
    MODEL_DISPLAY: '440i xDrive',
    CLASS_SERIES_CODE: '4_SERIES',
    CLASS_SERIES_DISPLAY: '4 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '128I',
    MODEL_DISPLAY: '128i',
    CLASS_SERIES_CODE: '1_SERIES',
    CLASS_SERIES_DISPLAY: '1 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '135I',
    MODEL_DISPLAY: '135i',
    CLASS_SERIES_CODE: '1_SERIES',
    CLASS_SERIES_DISPLAY: '1 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMW540IXD',
    MODEL_DISPLAY: '540i xDrive',
    CLASS_SERIES_CODE: '5_SERIES',
    CLASS_SERIES_DISPLAY: '5 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMW640GTXD',
    MODEL_DISPLAY: '640i Gran Turismo xDrive',
    CLASS_SERIES_CODE: '6_SERIES',
    CLASS_SERIES_DISPLAY: '6 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'X6',
    MODEL_DISPLAY: 'X6',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'BMWM235IXD',
    MODEL_DISPLAY: 'M235i xDrive',
    CLASS_SERIES_CODE: '2_SERIES',
    CLASS_SERIES_DISPLAY: '2 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'ACTIVEX6',
    MODEL_DISPLAY: 'ActiveHybrid X6',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '535IGT',
    MODEL_DISPLAY: '535i Gran Turismo',
    CLASS_SERIES_CODE: '5_SERIES',
    CLASS_SERIES_DISPLAY: '5 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'ACTIVE7',
    MODEL_DISPLAY: 'ActiveHybrid 7',
    CLASS_SERIES_CODE: '7_SERIES',
    CLASS_SERIES_DISPLAY: '7 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '328IXD',
    MODEL_DISPLAY: '328i xDrive',
    CLASS_SERIES_CODE: '3_SERIES',
    CLASS_SERIES_DISPLAY: '3 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '335IXD',
    MODEL_DISPLAY: '335i xDrive',
    CLASS_SERIES_CODE: '3_SERIES',
    CLASS_SERIES_DISPLAY: '3 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '528IXD',
    MODEL_DISPLAY: '528i xDrive',
    CLASS_SERIES_CODE: '5_SERIES',
    CLASS_SERIES_DISPLAY: '5 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '535IXD',
    MODEL_DISPLAY: '535i xDrive',
    CLASS_SERIES_CODE: '5_SERIES',
    CLASS_SERIES_DISPLAY: '5 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '535IGTXD',
    MODEL_DISPLAY: '535i Gran Turismo xDrive',
    CLASS_SERIES_CODE: '5_SERIES',
    CLASS_SERIES_DISPLAY: '5 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '550IGTXD',
    MODEL_DISPLAY: '550i Gran Turismo xDrive',
    CLASS_SERIES_CODE: '5_SERIES',
    CLASS_SERIES_DISPLAY: '5 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '650IXD',
    MODEL_DISPLAY: '650i xDrive',
    CLASS_SERIES_CODE: '6_SERIES',
    CLASS_SERIES_DISPLAY: '6 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '650IGCXD',
    MODEL_DISPLAY: '650i Gran Coupe xDrive',
    CLASS_SERIES_CODE: '6_SERIES',
    CLASS_SERIES_DISPLAY: '6 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '740LIXD',
    MODEL_DISPLAY: '740Li xDrive',
    CLASS_SERIES_CODE: '7_SERIES',
    CLASS_SERIES_DISPLAY: '7 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '750IXD',
    MODEL_DISPLAY: '750i xDrive',
    CLASS_SERIES_CODE: '7_SERIES',
    CLASS_SERIES_DISPLAY: '7 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '750LIXD',
    MODEL_DISPLAY: '750Li xDrive',
    CLASS_SERIES_CODE: '7_SERIES',
    CLASS_SERIES_DISPLAY: '7 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: 'ALPINAB7XD',
    MODEL_DISPLAY: 'ALPINA B7 xDrive',
    CLASS_SERIES_CODE: '7_SERIES',
    CLASS_SERIES_DISPLAY: '7 Series',
  },
  {
    MAKE_CODE: 'BMW',
    MAKE_DISPLAY: 'BMW',
    MODEL_CODE: '550IXD',
    MODEL_DISPLAY: '550i xDrive',
    CLASS_SERIES_CODE: '5_SERIES',
    CLASS_SERIES_DISPLAY: '5 Series',
  },
  {
    MAKE_CODE: 'BUGATTI',
    MAKE_DISPLAY: 'Bugatti',
    MODEL_CODE: 'BUGVEY',
    MODEL_DISPLAY: 'Veyron',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'BUGATTI',
    MAKE_DISPLAY: 'Bugatti',
    MODEL_CODE: 'BUGCHIRON',
    MODEL_DISPLAY: 'Chiron',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'BUICK',
    MAKE_DISPLAY: 'Buick',
    MODEL_CODE: 'LACROSSE',
    MODEL_DISPLAY: 'LaCrosse',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'BUICK',
    MAKE_DISPLAY: 'Buick',
    MODEL_CODE: 'BUICKROAD',
    MODEL_DISPLAY: 'Roadmaster',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'BUICK',
    MAKE_DISPLAY: 'Buick',
    MODEL_CODE: 'ELEC',
    MODEL_DISPLAY: 'Electra',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'BUICK',
    MAKE_DISPLAY: 'Buick',
    MODEL_CODE: 'LESA',
    MODEL_DISPLAY: 'Le Sabre',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'BUICK',
    MAKE_DISPLAY: 'Buick',
    MODEL_CODE: 'REATTA',
    MODEL_DISPLAY: 'Reatta',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'BUICK',
    MAKE_DISPLAY: 'Buick',
    MODEL_CODE: 'REG',
    MODEL_DISPLAY: 'Regal',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'BUICK',
    MAKE_DISPLAY: 'Buick',
    MODEL_CODE: 'RIV',
    MODEL_DISPLAY: 'Riviera',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'BUICK',
    MAKE_DISPLAY: 'Buick',
    MODEL_CODE: 'SKYH',
    MODEL_DISPLAY: 'Skyhawk',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'BUICK',
    MAKE_DISPLAY: 'Buick',
    MODEL_CODE: 'RAINIER',
    MODEL_DISPLAY: 'Rainier',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'BUICK',
    MAKE_DISPLAY: 'Buick',
    MODEL_CODE: 'PARK',
    MODEL_DISPLAY: 'Park Avenue',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'BUICK',
    MAKE_DISPLAY: 'Buick',
    MODEL_CODE: 'SKYL',
    MODEL_DISPLAY: 'Skylark',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'BUICK',
    MAKE_DISPLAY: 'Buick',
    MODEL_CODE: 'TERRAZA',
    MODEL_DISPLAY: 'Terraza',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'BUICK',
    MAKE_DISPLAY: 'Buick',
    MODEL_CODE: 'LUCERNE',
    MODEL_DISPLAY: 'Lucerne',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'BUICK',
    MAKE_DISPLAY: 'Buick',
    MODEL_CODE: 'CENT',
    MODEL_DISPLAY: 'Century',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'BUICK',
    MAKE_DISPLAY: 'Buick',
    MODEL_CODE: 'SOMER',
    MODEL_DISPLAY: 'Somerset',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'BUICK',
    MAKE_DISPLAY: 'Buick',
    MODEL_CODE: 'BUOTH',
    MODEL_DISPLAY: 'Other Buick Models',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'BUICK',
    MAKE_DISPLAY: 'Buick',
    MODEL_CODE: 'BUICASCADA',
    MODEL_DISPLAY: 'Cascada',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'BUICK',
    MAKE_DISPLAY: 'Buick',
    MODEL_CODE: 'RENDEZVOUS',
    MODEL_DISPLAY: 'Rendezvous',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'BUICK',
    MAKE_DISPLAY: 'Buick',
    MODEL_CODE: 'ENCLAVE',
    MODEL_DISPLAY: 'Enclave',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'BUICK',
    MAKE_DISPLAY: 'Buick',
    MODEL_CODE: 'BUIENVISI',
    MODEL_DISPLAY: 'Envision',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'BUICK',
    MAKE_DISPLAY: 'Buick',
    MODEL_CODE: 'BUIENC',
    MODEL_DISPLAY: 'Encore',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'BUICK',
    MAKE_DISPLAY: 'Buick',
    MODEL_CODE: 'BUVERANO',
    MODEL_DISPLAY: 'Verano',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CAD',
    MAKE_DISPLAY: 'Cadillac',
    MODEL_CODE: 'ALLANT',
    MODEL_DISPLAY: 'Allante',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CAD',
    MAKE_DISPLAY: 'Cadillac',
    MODEL_CODE: 'CATERA',
    MODEL_DISPLAY: 'Catera',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CAD',
    MAKE_DISPLAY: 'Cadillac',
    MODEL_CODE: 'CIMA',
    MODEL_DISPLAY: 'Cimarron',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CAD',
    MAKE_DISPLAY: 'Cadillac',
    MODEL_CODE: 'DEV',
    MODEL_DISPLAY: 'De Ville',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CAD',
    MAKE_DISPLAY: 'Cadillac',
    MODEL_CODE: 'ELDO',
    MODEL_DISPLAY: 'Eldorado',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CAD',
    MAKE_DISPLAY: 'Cadillac',
    MODEL_CODE: 'SEV',
    MODEL_DISPLAY: 'Seville',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CAD',
    MAKE_DISPLAY: 'Cadillac',
    MODEL_CODE: 'CTS',
    MODEL_DISPLAY: 'CTS',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CAD',
    MAKE_DISPLAY: 'Cadillac',
    MODEL_CODE: 'EXT',
    MODEL_DISPLAY: 'Escalade EXT',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CAD',
    MAKE_DISPLAY: 'Cadillac',
    MODEL_CODE: 'ESCALAESV',
    MODEL_DISPLAY: 'Escalade ESV',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CAD',
    MAKE_DISPLAY: 'Cadillac',
    MODEL_CODE: 'XLR',
    MODEL_DISPLAY: 'XLR',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CAD',
    MAKE_DISPLAY: 'Cadillac',
    MODEL_CODE: 'SRX',
    MODEL_DISPLAY: 'SRX',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CAD',
    MAKE_DISPLAY: 'Cadillac',
    MODEL_CODE: 'STS',
    MODEL_DISPLAY: 'STS',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CAD',
    MAKE_DISPLAY: 'Cadillac',
    MODEL_CODE: 'DTS',
    MODEL_DISPLAY: 'DTS',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CAD',
    MAKE_DISPLAY: 'Cadillac',
    MODEL_CODE: 'FLEE',
    MODEL_DISPLAY: 'Fleetwood',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CAD',
    MAKE_DISPLAY: 'Cadillac',
    MODEL_CODE: 'BROUGH',
    MODEL_DISPLAY: 'Brougham',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CAD',
    MAKE_DISPLAY: 'Cadillac',
    MODEL_CODE: 'CADELR',
    MODEL_DISPLAY: 'ELR',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CAD',
    MAKE_DISPLAY: 'Cadillac',
    MODEL_CODE: 'ESCALA',
    MODEL_DISPLAY: 'Escalade',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CAD',
    MAKE_DISPLAY: 'Cadillac',
    MODEL_CODE: 'CADOTH',
    MODEL_DISPLAY: 'Other Cadillac Models',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CAD',
    MAKE_DISPLAY: 'Cadillac',
    MODEL_CODE: 'CADXT4',
    MODEL_DISPLAY: 'XT4',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CAD',
    MAKE_DISPLAY: 'Cadillac',
    MODEL_CODE: 'CADXT5',
    MODEL_DISPLAY: 'XT5',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CAD',
    MAKE_DISPLAY: 'Cadillac',
    MODEL_CODE: 'XTS',
    MODEL_DISPLAY: 'XTS',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CAD',
    MAKE_DISPLAY: 'Cadillac',
    MODEL_CODE: 'ATS',
    MODEL_DISPLAY: 'ATS',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CAD',
    MAKE_DISPLAY: 'Cadillac',
    MODEL_CODE: 'CADCT6',
    MODEL_DISPLAY: 'CT6',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'CITATION',
    MODEL_DISPLAY: 'Citation',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'LUV',
    MODEL_DISPLAY: 'LUV',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'SONIC',
    MODEL_DISPLAY: 'Sonic',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'SPARK',
    MODEL_DISPLAY: 'Spark',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'ASTRO',
    MODEL_DISPLAY: 'Astro',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'BERETT',
    MODEL_DISPLAY: 'Beretta',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'CAM',
    MODEL_DISPLAY: 'Camaro',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'CAP',
    MODEL_DISPLAY: 'Caprice',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'CAV',
    MODEL_DISPLAY: 'Cavalier',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'CHEV150',
    MODEL_DISPLAY: 'Silverado 1500',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'CHEVIMP',
    MODEL_DISPLAY: 'Impala',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'CHEVMONT',
    MODEL_DISPLAY: 'Monte Carlo',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'CHEVSUB',
    MODEL_DISPLAY: 'Suburban',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'CHVST',
    MODEL_DISPLAY: 'S10 Blazer',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'CORSI',
    MODEL_DISPLAY: 'Corsica',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'ELCAM',
    MODEL_DISPLAY: 'El Camino',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'LUMINA',
    MODEL_DISPLAY: 'Lumina',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'MALI',
    MODEL_DISPLAY: 'Malibu',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'NOVA',
    MODEL_DISPLAY: 'Nova',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'TAHOE',
    MODEL_DISPLAY: 'Tahoe',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'TRACKE',
    MODEL_DISPLAY: 'Tracker',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'VENTUR',
    MODEL_DISPLAY: 'Venture',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'TRAILBZEXT',
    MODEL_DISPLAY: 'TrailBlazer EXT',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'SSR',
    MODEL_DISPLAY: 'SSR',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'AVEO',
    MODEL_DISPLAY: 'Aveo',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'COLORADO',
    MODEL_DISPLAY: 'Colorado',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'EQUINOX',
    MODEL_DISPLAY: 'Equinox',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'COBALT',
    MODEL_DISPLAY: 'Cobalt',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'CHETRAX',
    MODEL_DISPLAY: 'Trax',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'CHEVPRIZM',
    MODEL_DISPLAY: 'Prizm',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'CHVMETR',
    MODEL_DISPLAY: 'Metro',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'UPLANDER',
    MODEL_DISPLAY: 'Uplander',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'LAPV',
    MODEL_DISPLAY: 'Lumina APV',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'HHR',
    MODEL_DISPLAY: 'HHR',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'BLAZER',
    MODEL_DISPLAY: 'Blazer',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'CHEVC25',
    MODEL_DISPLAY: 'Silverado 2500',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'CORV',
    MODEL_DISPLAY: 'Corvette',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'CELE',
    MODEL_DISPLAY: 'Celebrity',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'CH3500PU',
    MODEL_DISPLAY: 'Silverado 3500',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'S10PICKUP',
    MODEL_DISPLAY: 'S10 Pickup',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'CHEOTH',
    MODEL_DISPLAY: 'Other Chevrolet Models',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'VOLT',
    MODEL_DISPLAY: 'Volt',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'CHEVSPEC',
    MODEL_DISPLAY: 'Spectrum',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'CHEVETTE',
    MODEL_DISPLAY: 'Chevette',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'CHSPRINT',
    MODEL_DISPLAY: 'Sprint',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'AVALNCH',
    MODEL_DISPLAY: 'Avalanche',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'TRAILBLZ',
    MODEL_DISPLAY: 'TrailBlazer',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'CHEVSS',
    MODEL_DISPLAY: 'SS',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'CHEXP4500',
    MODEL_DISPLAY: 'Express 4500',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'CHEBOLT',
    MODEL_DISPLAY: 'Bolt',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'CRUZE',
    MODEL_DISPLAY: 'Cruze',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'KODC4500',
    MODEL_DISPLAY: 'Kodiak C4500',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'CHECAPS',
    MODEL_DISPLAY: 'Captiva Sport',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'TRAVERSE',
    MODEL_DISPLAY: 'Traverse',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'AVEO5',
    MODEL_DISPLAY: 'Aveo5',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'CHECITYEXP',
    MODEL_DISPLAY: 'City Express',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'CHEG10',
    MODEL_DISPLAY: 'G10',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'CHEG20',
    MODEL_DISPLAY: 'G20',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'CHEG30',
    MODEL_DISPLAY: 'G30',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'CHEXP1500',
    MODEL_DISPLAY: 'Express 1500',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'CHEXP2500',
    MODEL_DISPLAY: 'Express 2500',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'CHEXP3500',
    MODEL_DISPLAY: 'Express 3500',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHEV',
    MAKE_DISPLAY: 'Chevrolet',
    MODEL_CODE: 'CHEVCK',
    MODEL_DISPLAY: 'C/K Truck',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHRY',
    MAKE_DISPLAY: 'Chrysler',
    MODEL_CODE: 'ECLASS',
    MODEL_DISPLAY: 'E Class',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHRY',
    MAKE_DISPLAY: 'Chrysler',
    MODEL_CODE: 'NEWPORT',
    MODEL_DISPLAY: 'Newport',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHRY',
    MAKE_DISPLAY: 'Chrysler',
    MODEL_CODE: 'CHRY300',
    MODEL_DISPLAY: '300M',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHRY',
    MAKE_DISPLAY: 'Chrysler',
    MODEL_CODE: 'CHRYCONQ',
    MODEL_DISPLAY: 'Conquest',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHRY',
    MAKE_DISPLAY: 'Chrysler',
    MODEL_CODE: 'CHRYSEB',
    MODEL_DISPLAY: 'Sebring',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHRY',
    MAKE_DISPLAY: 'Chrysler',
    MODEL_CODE: 'CIRRUS',
    MODEL_DISPLAY: 'Cirrus',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHRY',
    MAKE_DISPLAY: 'Chrysler',
    MODEL_CODE: 'CONC',
    MODEL_DISPLAY: 'Concorde',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHRY',
    MAKE_DISPLAY: 'Chrysler',
    MODEL_CODE: 'IMPE',
    MODEL_DISPLAY: 'Imperial',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHRY',
    MAKE_DISPLAY: 'Chrysler',
    MODEL_CODE: 'LEBA',
    MODEL_DISPLAY: 'LeBaron',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHRY',
    MAKE_DISPLAY: 'Chrysler',
    MODEL_CODE: 'TANDC',
    MODEL_DISPLAY: 'Town & Country',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHRY',
    MAKE_DISPLAY: 'Chrysler',
    MODEL_CODE: 'PACIFICA',
    MODEL_DISPLAY: 'Pacifica',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHRY',
    MAKE_DISPLAY: 'Chrysler',
    MODEL_CODE: 'CROSSFIRE',
    MODEL_DISPLAY: 'Crossfire',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHRY',
    MAKE_DISPLAY: 'Chrysler',
    MODEL_CODE: '300',
    MODEL_DISPLAY: '300',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHRY',
    MAKE_DISPLAY: 'Chrysler',
    MODEL_CODE: 'FIFTH',
    MODEL_DISPLAY: 'Fifth Avenue',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHRY',
    MAKE_DISPLAY: 'Chrysler',
    MODEL_CODE: 'LHS',
    MODEL_DISPLAY: 'LHS',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHRY',
    MAKE_DISPLAY: 'Chrysler',
    MODEL_CODE: 'NY',
    MODEL_DISPLAY: 'New Yorker',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHRY',
    MAKE_DISPLAY: 'Chrysler',
    MODEL_CODE: 'ASPEN',
    MODEL_DISPLAY: 'Aspen',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHRY',
    MAKE_DISPLAY: 'Chrysler',
    MODEL_CODE: 'CHRYGRANDV',
    MODEL_DISPLAY: 'Grand Voyager',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHRY',
    MAKE_DISPLAY: 'Chrysler',
    MODEL_CODE: 'CHOTH',
    MODEL_DISPLAY: 'Other Chrysler Models',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHRY',
    MAKE_DISPLAY: 'Chrysler',
    MODEL_CODE: 'VOYAGER',
    MODEL_DISPLAY: 'Voyager',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHRY',
    MAKE_DISPLAY: 'Chrysler',
    MODEL_CODE: 'PTCRUIS',
    MODEL_DISPLAY: 'PT Cruiser',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHRY',
    MAKE_DISPLAY: 'Chrysler',
    MODEL_CODE: 'CORDOBA',
    MODEL_DISPLAY: 'Cordoba',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHRY',
    MAKE_DISPLAY: 'Chrysler',
    MODEL_CODE: 'CHPROWLE',
    MODEL_DISPLAY: 'Prowler',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHRY',
    MAKE_DISPLAY: 'Chrysler',
    MODEL_CODE: 'INTREPID',
    MODEL_DISPLAY: 'Intrepid',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHRY',
    MAKE_DISPLAY: 'Chrysler',
    MODEL_CODE: 'CHRYLEBGTS',
    MODEL_DISPLAY: 'LeBaron GTS',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHRY',
    MAKE_DISPLAY: 'Chrysler',
    MODEL_CODE: 'CHRYS200',
    MODEL_DISPLAY: '200',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHRY',
    MAKE_DISPLAY: 'Chrysler',
    MODEL_CODE: 'CHRYLAS',
    MODEL_DISPLAY: 'Laser',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'CHRY',
    MAKE_DISPLAY: 'Chrysler',
    MODEL_CODE: 'CHRYTC',
    MODEL_DISPLAY: 'TC by Maserati',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DAEW',
    MAKE_DISPLAY: 'Daewoo',
    MODEL_CODE: 'LANOS',
    MODEL_DISPLAY: 'Lanos',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DAEW',
    MAKE_DISPLAY: 'Daewoo',
    MODEL_CODE: 'NUBIRA',
    MODEL_DISPLAY: 'Nubira',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DAEW',
    MAKE_DISPLAY: 'Daewoo',
    MODEL_CODE: 'LEGANZA',
    MODEL_DISPLAY: 'Leganza',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DAEW',
    MAKE_DISPLAY: 'Daewoo',
    MODEL_CODE: 'DAEOTH',
    MODEL_DISPLAY: 'Other Daewoo Models',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DATSUN',
    MAKE_DISPLAY: 'Datsun',
    MODEL_CODE: '510',
    MODEL_DISPLAY: '510',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DATSUN',
    MAKE_DISPLAY: 'Datsun',
    MODEL_CODE: '810',
    MODEL_DISPLAY: '810',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DATSUN',
    MAKE_DISPLAY: 'Datsun',
    MODEL_CODE: '310',
    MODEL_DISPLAY: '310',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DATSUN',
    MAKE_DISPLAY: 'Datsun',
    MODEL_CODE: '720',
    MODEL_DISPLAY: '720',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DATSUN',
    MAKE_DISPLAY: 'Datsun',
    MODEL_CODE: 'DAT200SX',
    MODEL_DISPLAY: '200SX',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DATSUN',
    MAKE_DISPLAY: 'Datsun',
    MODEL_CODE: 'DAT210',
    MODEL_DISPLAY: '210',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DATSUN',
    MAKE_DISPLAY: 'Datsun',
    MODEL_CODE: 'DATMAX',
    MODEL_DISPLAY: 'Maxima',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DATSUN',
    MAKE_DISPLAY: 'Datsun',
    MODEL_CODE: 'DATPU',
    MODEL_DISPLAY: 'Pickup',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DATSUN',
    MAKE_DISPLAY: 'Datsun',
    MODEL_CODE: 'DATSENT',
    MODEL_DISPLAY: 'Sentra',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DATSUN',
    MAKE_DISPLAY: 'Datsun',
    MODEL_CODE: 'PUL',
    MODEL_DISPLAY: 'Pulsar',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DATSUN',
    MAKE_DISPLAY: 'Datsun',
    MODEL_CODE: 'STAN',
    MODEL_DISPLAY: 'Stanza',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DATSUN',
    MAKE_DISPLAY: 'Datsun',
    MODEL_CODE: '300ZX',
    MODEL_DISPLAY: '300ZX',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DATSUN',
    MAKE_DISPLAY: 'Datsun',
    MODEL_CODE: '280Z',
    MODEL_DISPLAY: '280ZX',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DATSUN',
    MAKE_DISPLAY: 'Datsun',
    MODEL_CODE: 'DATOTH',
    MODEL_DISPLAY: 'Other Datsun Models',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DELOREAN',
    MAKE_DISPLAY: 'DeLorean',
    MODEL_CODE: 'DMC12',
    MODEL_DISPLAY: 'DMC-12',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DODGE',
    MAKE_DISPLAY: 'Dodge',
    MODEL_CODE: '400',
    MODEL_DISPLAY: '400',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DODGE',
    MAKE_DISPLAY: 'Dodge',
    MODEL_CODE: 'CHALLENGER',
    MODEL_DISPLAY: 'Challenger',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DODGE',
    MAKE_DISPLAY: 'Dodge',
    MODEL_CODE: 'MIRADA',
    MODEL_DISPLAY: 'Mirada',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DODGE',
    MAKE_DISPLAY: 'Dodge',
    MODEL_CODE: 'RAMPAGE',
    MODEL_DISPLAY: 'Rampage',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DODGE',
    MAKE_DISPLAY: 'Dodge',
    MODEL_CODE: 'STREGIS',
    MODEL_DISPLAY: 'St. Regis',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DODGE',
    MAKE_DISPLAY: 'Dodge',
    MODEL_CODE: 'B150',
    MODEL_DISPLAY: 'B150',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DODGE',
    MAKE_DISPLAY: 'Dodge',
    MODEL_CODE: 'B250',
    MODEL_DISPLAY: 'B250',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DODGE',
    MAKE_DISPLAY: 'Dodge',
    MODEL_CODE: 'B350',
    MODEL_DISPLAY: 'B350',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DODGE',
    MAKE_DISPLAY: 'Dodge',
    MODEL_CODE: 'B1500',
    MODEL_DISPLAY: 'B1500',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DODGE',
    MAKE_DISPLAY: 'Dodge',
    MODEL_CODE: 'B2500',
    MODEL_DISPLAY: 'B2500',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DODGE',
    MAKE_DISPLAY: 'Dodge',
    MODEL_CODE: 'B3500',
    MODEL_DISPLAY: 'B3500',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DODGE',
    MAKE_DISPLAY: 'Dodge',
    MODEL_CODE: 'ARI',
    MODEL_DISPLAY: 'Aries',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DODGE',
    MAKE_DISPLAY: 'Dodge',
    MODEL_CODE: 'AVENGR',
    MODEL_DISPLAY: 'Avenger',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DODGE',
    MAKE_DISPLAY: 'Dodge',
    MODEL_CODE: 'DAY',
    MODEL_DISPLAY: 'Daytona',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DODGE',
    MAKE_DISPLAY: 'Dodge',
    MODEL_CODE: 'DODCARA',
    MODEL_DISPLAY: 'Caravan',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DODGE',
    MAKE_DISPLAY: 'Dodge',
    MODEL_CODE: 'DODCHAR',
    MODEL_DISPLAY: 'Charger',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DODGE',
    MAKE_DISPLAY: 'Dodge',
    MODEL_CODE: 'DODCOLT',
    MODEL_DISPLAY: 'Colt',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DODGE',
    MAKE_DISPLAY: 'Dodge',
    MODEL_CODE: 'DODSHAD',
    MODEL_DISPLAY: 'Shadow',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DODGE',
    MAKE_DISPLAY: 'Dodge',
    MODEL_CODE: 'DURANG',
    MODEL_DISPLAY: 'Durango',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DODGE',
    MAKE_DISPLAY: 'Dodge',
    MODEL_CODE: 'INTRE',
    MODEL_DISPLAY: 'Intrepid',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DODGE',
    MAKE_DISPLAY: 'Dodge',
    MODEL_CODE: 'OMNI',
    MODEL_DISPLAY: 'Omni',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DODGE',
    MAKE_DISPLAY: 'Dodge',
    MODEL_CODE: 'RAIDER',
    MODEL_DISPLAY: 'Raider',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DODGE',
    MAKE_DISPLAY: 'Dodge',
    MODEL_CODE: 'STEAL',
    MODEL_DISPLAY: 'Stealth',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DODGE',
    MAKE_DISPLAY: 'Dodge',
    MODEL_CODE: 'VIPER',
    MODEL_DISPLAY: 'Viper',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DODGE',
    MAKE_DISPLAY: 'Dodge',
    MODEL_CODE: 'SPRINTER',
    MODEL_DISPLAY: 'Sprinter',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DODGE',
    MAKE_DISPLAY: 'Dodge',
    MODEL_CODE: 'MONACO',
    MODEL_DISPLAY: 'Monaco',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DODGE',
    MAKE_DISPLAY: 'Dodge',
    MODEL_CODE: 'SRT4',
    MODEL_DISPLAY: 'SRT-4',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DODGE',
    MAKE_DISPLAY: 'Dodge',
    MODEL_CODE: 'LANCERDODG',
    MODEL_DISPLAY: 'Lancer',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DODGE',
    MAKE_DISPLAY: 'Dodge',
    MODEL_CODE: 'MAGNUM',
    MODEL_DISPLAY: 'Magnum',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DODGE',
    MAKE_DISPLAY: 'Dodge',
    MODEL_CODE: 'RAMSRT10',
    MODEL_DISPLAY: 'Ram SRT-10',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DODGE',
    MAKE_DISPLAY: 'Dodge',
    MODEL_CODE: 'DAKOTA',
    MODEL_DISPLAY: 'Dakota',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DODGE',
    MAKE_DISPLAY: 'Dodge',
    MODEL_CODE: 'DODDYNA',
    MODEL_DISPLAY: 'Dynasty',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DODGE',
    MAKE_DISPLAY: 'Dodge',
    MODEL_CODE: 'CALIBER',
    MODEL_DISPLAY: 'Caliber',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DODGE',
    MAKE_DISPLAY: 'Dodge',
    MODEL_CODE: 'NITRO',
    MODEL_DISPLAY: 'Nitro',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DODGE',
    MAKE_DISPLAY: 'Dodge',
    MODEL_CODE: 'RAM1504WD',
    MODEL_DISPLAY: 'Ram 1500 Truck',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DODGE',
    MAKE_DISPLAY: 'Dodge',
    MODEL_CODE: 'RAM25002WD',
    MODEL_DISPLAY: 'Ram 2500 Truck',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DODGE',
    MAKE_DISPLAY: 'Dodge',
    MODEL_CODE: 'RAM3502WD',
    MODEL_DISPLAY: 'Ram 3500 Truck',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DODGE',
    MAKE_DISPLAY: 'Dodge',
    MODEL_CODE: 'DODNEON',
    MODEL_DISPLAY: 'Neon',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DODGE',
    MAKE_DISPLAY: 'Dodge',
    MODEL_CODE: 'STRATU',
    MODEL_DISPLAY: 'Stratus',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DODGE',
    MAKE_DISPLAY: 'Dodge',
    MODEL_CODE: 'RAMCGR',
    MODEL_DISPLAY: 'Ramcharger',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DODGE',
    MAKE_DISPLAY: 'Dodge',
    MODEL_CODE: 'DODSPIR',
    MODEL_DISPLAY: 'Spirit',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DODGE',
    MAKE_DISPLAY: 'Dodge',
    MODEL_CODE: 'DODD50',
    MODEL_DISPLAY: 'Ram 50 Truck',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DODGE',
    MAKE_DISPLAY: 'Dodge',
    MODEL_CODE: 'GRANDCARAV',
    MODEL_DISPLAY: 'Grand Caravan',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DODGE',
    MAKE_DISPLAY: 'Dodge',
    MODEL_CODE: 'RAM5500',
    MODEL_DISPLAY: 'Ram 5500 Truck',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DODGE',
    MAKE_DISPLAY: 'Dodge',
    MODEL_CODE: 'DOOTH',
    MODEL_DISPLAY: 'Other Dodge Models',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DODGE',
    MAKE_DISPLAY: 'Dodge',
    MODEL_CODE: 'DOD600',
    MODEL_DISPLAY: '600',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DODGE',
    MAKE_DISPLAY: 'Dodge',
    MODEL_CODE: 'DODCONQ',
    MODEL_DISPLAY: 'Conquest',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DODGE',
    MAKE_DISPLAY: 'Dodge',
    MODEL_CODE: 'DODDART',
    MODEL_DISPLAY: 'Dart',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DODGE',
    MAKE_DISPLAY: 'Dodge',
    MODEL_CODE: 'DIPLOMA',
    MODEL_DISPLAY: 'Diplomat',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DODGE',
    MAKE_DISPLAY: 'Dodge',
    MODEL_CODE: 'DODDW',
    MODEL_DISPLAY: 'D/W Truck',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DODGE',
    MAKE_DISPLAY: 'Dodge',
    MODEL_CODE: 'RAM4500',
    MODEL_DISPLAY: 'Ram 4500 Truck',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'DODGE',
    MAKE_DISPLAY: 'Dodge',
    MODEL_CODE: 'JOURNEY',
    MODEL_DISPLAY: 'Journey',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'EAGLE',
    MAKE_DISPLAY: 'Eagle',
    MODEL_CODE: 'EAGLEMED',
    MODEL_DISPLAY: 'Medallion',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'EAGLE',
    MAKE_DISPLAY: 'Eagle',
    MODEL_CODE: 'SUMMIT',
    MODEL_DISPLAY: 'Summit',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'EAGLE',
    MAKE_DISPLAY: 'Eagle',
    MODEL_CODE: 'VISION',
    MODEL_DISPLAY: 'Vision',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'EAGLE',
    MAKE_DISPLAY: 'Eagle',
    MODEL_CODE: 'TALON',
    MODEL_DISPLAY: 'Talon',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'EAGLE',
    MAKE_DISPLAY: 'Eagle',
    MODEL_CODE: 'EAGLEPREM',
    MODEL_DISPLAY: 'Premier',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'EAGLE',
    MAKE_DISPLAY: 'Eagle',
    MODEL_CODE: 'EAGOTH',
    MODEL_DISPLAY: 'Other Eagle Models',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FER',
    MAKE_DISPLAY: 'Ferrari',
    MODEL_CODE: 'FERSAPERTA',
    MODEL_DISPLAY: '599 SA Aperta',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FER',
    MAKE_DISPLAY: 'Ferrari',
    MODEL_CODE: '360',
    MODEL_DISPLAY: '360',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FER',
    MAKE_DISPLAY: 'Ferrari',
    MODEL_CODE: '456GT',
    MODEL_DISPLAY: '456 GT',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FER',
    MAKE_DISPLAY: 'Ferrari',
    MODEL_CODE: '512TR',
    MODEL_DISPLAY: '512TR',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FER',
    MAKE_DISPLAY: 'Ferrari',
    MODEL_CODE: 'ENZO',
    MODEL_DISPLAY: 'Enzo',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FER',
    MAKE_DISPLAY: 'Ferrari',
    MODEL_CODE: 'F355',
    MODEL_DISPLAY: 'F355',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FER',
    MAKE_DISPLAY: 'Ferrari',
    MODEL_CODE: 'F40',
    MODEL_DISPLAY: 'F40',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FER',
    MAKE_DISPLAY: 'Ferrari',
    MODEL_CODE: 'MOND',
    MODEL_DISPLAY: 'Mondial',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FER',
    MAKE_DISPLAY: 'Ferrari',
    MODEL_CODE: 'TEST',
    MODEL_DISPLAY: 'Testarossa',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FER',
    MAKE_DISPLAY: 'Ferrari',
    MODEL_CODE: 'F430',
    MODEL_DISPLAY: 'F430',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FER',
    MAKE_DISPLAY: 'Ferrari',
    MODEL_CODE: '612SCAGLIE',
    MODEL_DISPLAY: '612 Scaglietti',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FER',
    MAKE_DISPLAY: 'Ferrari',
    MODEL_CODE: 'FERF12BERL',
    MODEL_DISPLAY: 'F12 Berlinetta',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FER',
    MAKE_DISPLAY: 'Ferrari',
    MODEL_CODE: 'FERLAF',
    MODEL_DISPLAY: 'LaFerrari',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FER',
    MAKE_DISPLAY: 'Ferrari',
    MODEL_CODE: 'FEROTH',
    MODEL_DISPLAY: 'Other Ferrari Models',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FER',
    MAKE_DISPLAY: 'Ferrari',
    MODEL_CODE: 'FER488GTB',
    MODEL_DISPLAY: '488 GTB',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FER',
    MAKE_DISPLAY: 'Ferrari',
    MODEL_CODE: 'FERFF',
    MODEL_DISPLAY: 'FF',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FER',
    MAKE_DISPLAY: 'Ferrari',
    MODEL_CODE: 'FERPORTO',
    MODEL_DISPLAY: 'Portofino',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FER',
    MAKE_DISPLAY: 'Ferrari',
    MODEL_CODE: '575M',
    MODEL_DISPLAY: '575M Maranello',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FER',
    MAKE_DISPLAY: 'Ferrari',
    MODEL_CODE: '550M',
    MODEL_DISPLAY: '550 Maranello',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FER',
    MAKE_DISPLAY: 'Ferrari',
    MODEL_CODE: '308',
    MODEL_DISPLAY: '308',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FER',
    MAKE_DISPLAY: 'Ferrari',
    MODEL_CODE: '328',
    MODEL_DISPLAY: '328',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FER',
    MAKE_DISPLAY: 'Ferrari',
    MODEL_CODE: '348',
    MODEL_DISPLAY: '348',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FER',
    MAKE_DISPLAY: 'Ferrari',
    MODEL_CODE: 'FERGTC4LUS',
    MODEL_DISPLAY: 'GTC4Lusso',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FER',
    MAKE_DISPLAY: 'Ferrari',
    MODEL_CODE: '599GTO',
    MODEL_DISPLAY: '599 GTO',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FER',
    MAKE_DISPLAY: 'Ferrari',
    MODEL_CODE: 'F50',
    MODEL_DISPLAY: 'F50',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FER',
    MAKE_DISPLAY: 'Ferrari',
    MODEL_CODE: '456MGT',
    MODEL_DISPLAY: '456M GT',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FER',
    MAKE_DISPLAY: 'Ferrari',
    MODEL_CODE: 'FER812SUP',
    MODEL_DISPLAY: '812 Superfast',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FER',
    MAKE_DISPLAY: 'Ferrari',
    MODEL_CODE: '599GTB',
    MODEL_DISPLAY: '599 GTB Fiorano',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FER',
    MAKE_DISPLAY: 'Ferrari',
    MODEL_CODE: '512M',
    MODEL_DISPLAY: '512M',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FER',
    MAKE_DISPLAY: 'Ferrari',
    MODEL_CODE: 'FER488SPI',
    MODEL_DISPLAY: '488 Spider',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FER',
    MAKE_DISPLAY: 'Ferrari',
    MODEL_CODE: 'FERF12TDF',
    MODEL_DISPLAY: 'F12tdf',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FER',
    MAKE_DISPLAY: 'Ferrari',
    MODEL_CODE: 'FERCALIF',
    MODEL_DISPLAY: 'California',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FER',
    MAKE_DISPLAY: 'Ferrari',
    MODEL_CODE: '458ITALIA',
    MODEL_DISPLAY: '458 Italia',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FIAT',
    MAKE_DISPLAY: 'FIAT',
    MODEL_CODE: 'BERTON',
    MODEL_DISPLAY: 'Bertone X1/9',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FIAT',
    MAKE_DISPLAY: 'FIAT',
    MODEL_CODE: 'BRAVA',
    MODEL_DISPLAY: 'Brava',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FIAT',
    MAKE_DISPLAY: 'FIAT',
    MODEL_CODE: 'FIATX19',
    MODEL_DISPLAY: 'X1/9',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FIAT',
    MAKE_DISPLAY: 'FIAT',
    MODEL_CODE: 'PININ',
    MODEL_DISPLAY: 'Pininfarina Spider',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FIAT',
    MAKE_DISPLAY: 'FIAT',
    MODEL_CODE: 'STRADA',
    MODEL_DISPLAY: 'Strada',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FIAT',
    MAKE_DISPLAY: 'FIAT',
    MODEL_CODE: 'FIAT500L',
    MODEL_DISPLAY: '500L',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FIAT',
    MAKE_DISPLAY: 'FIAT',
    MODEL_CODE: 'FIAOTH',
    MODEL_DISPLAY: 'Other Fiat Models',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FIAT',
    MAKE_DISPLAY: 'FIAT',
    MODEL_CODE: 'FIAT500X',
    MODEL_DISPLAY: '500X',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FIAT',
    MAKE_DISPLAY: 'FIAT',
    MODEL_CODE: 'FIAT124SPI',
    MODEL_DISPLAY: '124 Spider',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FIAT',
    MAKE_DISPLAY: 'FIAT',
    MODEL_CODE: '2000',
    MODEL_DISPLAY: '2000 Spider',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FIAT',
    MAKE_DISPLAY: 'FIAT',
    MODEL_CODE: 'FIAT500',
    MODEL_DISPLAY: '500',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FISK',
    MAKE_DISPLAY: 'Fisker',
    MODEL_CODE: 'KARMA',
    MODEL_DISPLAY: 'Karma',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FORD',
    MAKE_DISPLAY: 'Ford',
    MODEL_CODE: 'COURIER',
    MODEL_DISPLAY: 'Courier',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FORD',
    MAKE_DISPLAY: 'Ford',
    MODEL_CODE: 'GRANADA',
    MODEL_DISPLAY: 'Granada',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FORD',
    MAKE_DISPLAY: 'Ford',
    MODEL_CODE: 'B2',
    MODEL_DISPLAY: 'Bronco II',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FORD',
    MAKE_DISPLAY: 'Ford',
    MODEL_CODE: 'BRON',
    MODEL_DISPLAY: 'Bronco',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FORD',
    MAKE_DISPLAY: 'Ford',
    MODEL_CODE: 'ESCO',
    MODEL_DISPLAY: 'Escort',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FORD',
    MAKE_DISPLAY: 'Ford',
    MODEL_CODE: 'EXP',
    MODEL_DISPLAY: 'EXP',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FORD',
    MAKE_DISPLAY: 'Ford',
    MODEL_CODE: 'EXPEDI',
    MODEL_DISPLAY: 'Expedition',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FORD',
    MAKE_DISPLAY: 'Ford',
    MODEL_CODE: 'EXPLOR',
    MODEL_DISPLAY: 'Explorer',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FORD',
    MAKE_DISPLAY: 'Ford',
    MODEL_CODE: 'F250',
    MODEL_DISPLAY: 'F250',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FORD',
    MAKE_DISPLAY: 'Ford',
    MODEL_CODE: 'F350',
    MODEL_DISPLAY: 'F350',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FORD',
    MAKE_DISPLAY: 'Ford',
    MODEL_CODE: 'FAIRM',
    MODEL_DISPLAY: 'Fairmont',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FORD',
    MAKE_DISPLAY: 'Ford',
    MODEL_CODE: 'FESTIV',
    MODEL_DISPLAY: 'Festiva',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FORD',
    MAKE_DISPLAY: 'Ford',
    MODEL_CODE: 'LTD',
    MODEL_DISPLAY: 'LTD',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FORD',
    MAKE_DISPLAY: 'Ford',
    MODEL_CODE: 'MUST',
    MODEL_DISPLAY: 'Mustang',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FORD',
    MAKE_DISPLAY: 'Ford',
    MODEL_CODE: 'PROBE',
    MODEL_DISPLAY: 'Probe',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FORD',
    MAKE_DISPLAY: 'Ford',
    MODEL_CODE: 'RANGER',
    MODEL_DISPLAY: 'Ranger',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FORD',
    MAKE_DISPLAY: 'Ford',
    MODEL_CODE: 'TAURUS',
    MODEL_DISPLAY: 'Taurus',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FORD',
    MAKE_DISPLAY: 'Ford',
    MODEL_CODE: 'TEMPO',
    MODEL_DISPLAY: 'Tempo',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FORD',
    MAKE_DISPLAY: 'Ford',
    MODEL_CODE: 'SPORTTRAC',
    MODEL_DISPLAY: 'Explorer Sport Trac',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FORD',
    MAKE_DISPLAY: 'Ford',
    MODEL_CODE: 'FREESTAR',
    MODEL_DISPLAY: 'Freestar',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FORD',
    MAKE_DISPLAY: 'Ford',
    MODEL_CODE: 'GT',
    MODEL_DISPLAY: 'GT',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FORD',
    MAKE_DISPLAY: 'Ford',
    MODEL_CODE: 'FIVEHUNDRE',
    MODEL_DISPLAY: 'Five Hundred',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FORD',
    MAKE_DISPLAY: 'Ford',
    MODEL_CODE: 'FREESTYLE',
    MODEL_DISPLAY: 'Freestyle',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FORD',
    MAKE_DISPLAY: 'Ford',
    MODEL_CODE: 'ASPIRE',
    MODEL_DISPLAY: 'Aspire',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FORD',
    MAKE_DISPLAY: 'Ford',
    MODEL_CODE: 'TBIRD',
    MODEL_DISPLAY: 'Thunderbird',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FORD',
    MAKE_DISPLAY: 'Ford',
    MODEL_CODE: 'WINDST',
    MODEL_DISPLAY: 'Windstar',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FORD',
    MAKE_DISPLAY: 'Ford',
    MODEL_CODE: 'FUSION',
    MODEL_DISPLAY: 'Fusion',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FORD',
    MAKE_DISPLAY: 'Ford',
    MODEL_CODE: 'EXPEDIEL',
    MODEL_DISPLAY: 'Expedition EL',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FORD',
    MAKE_DISPLAY: 'Ford',
    MODEL_CODE: 'EDGE',
    MODEL_DISPLAY: 'Edge',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FORD',
    MAKE_DISPLAY: 'Ford',
    MODEL_CODE: 'AERO',
    MODEL_DISPLAY: 'Aerostar',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FORD',
    MAKE_DISPLAY: 'Ford',
    MODEL_CODE: 'FOCMAX',
    MODEL_DISPLAY: 'C-MAX',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FORD',
    MAKE_DISPLAY: 'Ford',
    MODEL_CODE: 'FORDZX2',
    MODEL_DISPLAY: 'ZX2 Escort',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FORD',
    MAKE_DISPLAY: 'Ford',
    MODEL_CODE: 'FORDTRN150',
    MODEL_DISPLAY: 'Transit 150',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FORD',
    MAKE_DISPLAY: 'Ford',
    MODEL_CODE: 'CROWNVIC',
    MODEL_DISPLAY: 'Crown Victoria',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FORD',
    MAKE_DISPLAY: 'Ford',
    MODEL_CODE: 'EXCURSION',
    MODEL_DISPLAY: 'Excursion',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FORD',
    MAKE_DISPLAY: 'Ford',
    MODEL_CODE: 'F150PICKUP',
    MODEL_DISPLAY: 'F150',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FORD',
    MAKE_DISPLAY: 'Ford',
    MODEL_CODE: 'CONTOUR',
    MODEL_DISPLAY: 'Contour',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FORD',
    MAKE_DISPLAY: 'Ford',
    MODEL_CODE: 'FOCUS',
    MODEL_DISPLAY: 'Focus',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FORD',
    MAKE_DISPLAY: 'Ford',
    MODEL_CODE: 'FOOTH',
    MODEL_DISPLAY: 'Other Ford Models',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FORD',
    MAKE_DISPLAY: 'Ford',
    MODEL_CODE: 'F450',
    MODEL_DISPLAY: 'F450',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FORD',
    MAKE_DISPLAY: 'Ford',
    MODEL_CODE: 'FORDTRN250',
    MODEL_DISPLAY: 'Transit 250',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FORD',
    MAKE_DISPLAY: 'Ford',
    MODEL_CODE: 'FORDTRN350',
    MODEL_DISPLAY: 'Transit 350',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FORD',
    MAKE_DISPLAY: 'Ford',
    MODEL_CODE: 'ESCAPE',
    MODEL_DISPLAY: 'Escape',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FORD',
    MAKE_DISPLAY: 'Ford',
    MODEL_CODE: 'FLEX',
    MODEL_DISPLAY: 'Flex',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FORD',
    MAKE_DISPLAY: 'Ford',
    MODEL_CODE: 'FORDEXPMAX',
    MODEL_DISPLAY: 'Expedition Max',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FORD',
    MAKE_DISPLAY: 'Ford',
    MODEL_CODE: 'F100',
    MODEL_DISPLAY: 'F100',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FORD',
    MAKE_DISPLAY: 'Ford',
    MODEL_CODE: 'E150ECON',
    MODEL_DISPLAY: 'E-150 and Econoline 150',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FORD',
    MAKE_DISPLAY: 'Ford',
    MODEL_CODE: 'E250ECON',
    MODEL_DISPLAY: 'E-250 and Econoline 250',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FORD',
    MAKE_DISPLAY: 'Ford',
    MODEL_CODE: 'E350ECON',
    MODEL_DISPLAY: 'E-350 and Econoline 350',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FORD',
    MAKE_DISPLAY: 'Ford',
    MODEL_CODE: 'TRANSCONN',
    MODEL_DISPLAY: 'Transit Connect',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FORD',
    MAKE_DISPLAY: 'Ford',
    MODEL_CODE: 'E100ECON',
    MODEL_DISPLAY: 'E-100',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FORD',
    MAKE_DISPLAY: 'Ford',
    MODEL_CODE: 'TAURUSX',
    MODEL_DISPLAY: 'Taurus X',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FORD',
    MAKE_DISPLAY: 'Ford',
    MODEL_CODE: 'FIESTA',
    MODEL_DISPLAY: 'Fiesta',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FORD',
    MAKE_DISPLAY: 'Ford',
    MODEL_CODE: 'FORDECOSPT',
    MODEL_DISPLAY: 'EcoSport',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'FREIGHT',
    MAKE_DISPLAY: 'Freightliner',
    MODEL_CODE: 'FRESPRINT',
    MODEL_DISPLAY: 'Sprinter',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'GENESIS',
    MAKE_DISPLAY: 'Genesis',
    MODEL_CODE: 'GENG80',
    MODEL_DISPLAY: 'G80',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'GENESIS',
    MAKE_DISPLAY: 'Genesis',
    MODEL_CODE: 'GENG90',
    MODEL_DISPLAY: 'G90',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'GENESIS',
    MAKE_DISPLAY: 'Genesis',
    MODEL_CODE: 'GENG70',
    MODEL_DISPLAY: 'G70',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'GEO',
    MAKE_DISPLAY: 'Geo',
    MODEL_CODE: 'GEOMETRO',
    MODEL_DISPLAY: 'Metro',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'GEO',
    MAKE_DISPLAY: 'Geo',
    MODEL_CODE: 'GEOTRACK',
    MODEL_DISPLAY: 'Tracker',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'GEO',
    MAKE_DISPLAY: 'Geo',
    MODEL_CODE: 'STORM',
    MODEL_DISPLAY: 'Storm',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'GEO',
    MAKE_DISPLAY: 'Geo',
    MODEL_CODE: 'GEOPRIZM',
    MODEL_DISPLAY: 'Prizm',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'GEO',
    MAKE_DISPLAY: 'Geo',
    MODEL_CODE: 'SPECT',
    MODEL_DISPLAY: 'Spectrum',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'GEO',
    MAKE_DISPLAY: 'Geo',
    MODEL_CODE: 'GEOOTH',
    MODEL_DISPLAY: 'Other Geo Models',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'GMC',
    MAKE_DISPLAY: 'GMC',
    MODEL_CODE: 'GMC3500PU',
    MODEL_DISPLAY: 'Sierra 3500',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'GMC',
    MAKE_DISPLAY: 'GMC',
    MODEL_CODE: 'GMCC25PU',
    MODEL_DISPLAY: 'Sierra 2500',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'GMC',
    MAKE_DISPLAY: 'GMC',
    MODEL_CODE: 'JIM',
    MODEL_DISPLAY: 'Jimmy',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'GMC',
    MAKE_DISPLAY: 'GMC',
    MODEL_CODE: 'S15',
    MODEL_DISPLAY: 'S15 Pickup',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'GMC',
    MAKE_DISPLAY: 'GMC',
    MODEL_CODE: 'TYPH',
    MODEL_DISPLAY: 'Typhoon',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'GMC',
    MAKE_DISPLAY: 'GMC',
    MODEL_CODE: 'YUKON',
    MODEL_DISPLAY: 'Yukon',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'GMC',
    MAKE_DISPLAY: 'GMC',
    MODEL_CODE: 'ENVOYXL',
    MODEL_DISPLAY: 'Envoy XL',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'GMC',
    MAKE_DISPLAY: 'GMC',
    MODEL_CODE: 'CANYON',
    MODEL_DISPLAY: 'Canyon',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'GMC',
    MAKE_DISPLAY: 'GMC',
    MODEL_CODE: 'ENVOYXUV',
    MODEL_DISPLAY: 'Envoy XUV',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'GMC',
    MAKE_DISPLAY: 'GMC',
    MODEL_CODE: 'SAFARIGMC',
    MODEL_DISPLAY: 'Safari',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'GMC',
    MAKE_DISPLAY: 'GMC',
    MODEL_CODE: 'GMCSAVANA',
    MODEL_DISPLAY: 'Savana 1500',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'GMC',
    MAKE_DISPLAY: 'GMC',
    MODEL_CODE: 'GMCSYCLON',
    MODEL_DISPLAY: 'Syclone',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'GMC',
    MAKE_DISPLAY: 'GMC',
    MODEL_CODE: 'SUB',
    MODEL_DISPLAY: 'Suburban',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'GMC',
    MAKE_DISPLAY: 'GMC',
    MODEL_CODE: 'ENVOY',
    MODEL_DISPLAY: 'Envoy',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'GMC',
    MAKE_DISPLAY: 'GMC',
    MODEL_CODE: '15SIPU4WD',
    MODEL_DISPLAY: 'Sierra 1500',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'GMC',
    MAKE_DISPLAY: 'GMC',
    MODEL_CODE: 'GMCOTH',
    MODEL_DISPLAY: 'Other GMC Models',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'GMC',
    MAKE_DISPLAY: 'GMC',
    MODEL_CODE: 'ACADIA',
    MODEL_DISPLAY: 'Acadia',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'GMC',
    MAKE_DISPLAY: 'GMC',
    MODEL_CODE: 'SONOMA',
    MODEL_DISPLAY: 'Sonoma',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'GMC',
    MAKE_DISPLAY: 'GMC',
    MODEL_CODE: 'CABALLERO',
    MODEL_DISPLAY: 'Caballero',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'GMC',
    MAKE_DISPLAY: 'GMC',
    MODEL_CODE: 'YUKONXL',
    MODEL_DISPLAY: 'Yukon XL',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'GMC',
    MAKE_DISPLAY: 'GMC',
    MODEL_CODE: 'GMCSAV4500',
    MODEL_DISPLAY: 'Savana 4500',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'GMC',
    MAKE_DISPLAY: 'GMC',
    MODEL_CODE: 'TOPC4500',
    MODEL_DISPLAY: 'TopKick C4500',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'GMC',
    MAKE_DISPLAY: 'GMC',
    MODEL_CODE: 'GMCS15',
    MODEL_DISPLAY: 'S15 Jimmy',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'GMC',
    MAKE_DISPLAY: 'GMC',
    MODEL_CODE: 'TERRAIN',
    MODEL_DISPLAY: 'Terrain',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'GMC',
    MAKE_DISPLAY: 'GMC',
    MODEL_CODE: 'G1500',
    MODEL_DISPLAY: 'G1500',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'GMC',
    MAKE_DISPLAY: 'GMC',
    MODEL_CODE: 'G2500',
    MODEL_DISPLAY: 'G2500',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'GMC',
    MAKE_DISPLAY: 'GMC',
    MODEL_CODE: 'G3500',
    MODEL_DISPLAY: 'G3500',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'GMC',
    MAKE_DISPLAY: 'GMC',
    MODEL_CODE: 'GMCSAV2500',
    MODEL_DISPLAY: 'Savana 2500',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'GMC',
    MAKE_DISPLAY: 'GMC',
    MODEL_CODE: 'GMCSAV3500',
    MODEL_DISPLAY: 'Savana 3500',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'HONDA',
    MAKE_DISPLAY: 'Honda',
    MODEL_CODE: 'CRZ',
    MODEL_DISPLAY: 'CR-Z',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'HONDA',
    MAKE_DISPLAY: 'Honda',
    MODEL_CODE: 'ACCORD',
    MODEL_DISPLAY: 'Accord',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'HONDA',
    MAKE_DISPLAY: 'Honda',
    MODEL_CODE: 'CIVIC',
    MODEL_DISPLAY: 'Civic',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'HONDA',
    MAKE_DISPLAY: 'Honda',
    MODEL_CODE: 'CRX',
    MODEL_DISPLAY: 'CRX',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'HONDA',
    MAKE_DISPLAY: 'Honda',
    MODEL_CODE: 'PASSPO',
    MODEL_DISPLAY: 'Passport',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'HONDA',
    MAKE_DISPLAY: 'Honda',
    MODEL_CODE: 'PILOT',
    MODEL_DISPLAY: 'Pilot',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'HONDA',
    MAKE_DISPLAY: 'Honda',
    MODEL_CODE: 'ELEMENT',
    MODEL_DISPLAY: 'Element',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'HONDA',
    MAKE_DISPLAY: 'Honda',
    MODEL_CODE: 'RIDGELINE',
    MODEL_DISPLAY: 'Ridgeline',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'HONDA',
    MAKE_DISPLAY: 'Honda',
    MODEL_CODE: 'FIT',
    MODEL_DISPLAY: 'Fit',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'HONDA',
    MAKE_DISPLAY: 'Honda',
    MODEL_CODE: 'CRV',
    MODEL_DISPLAY: 'CR-V',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'HONDA',
    MAKE_DISPLAY: 'Honda',
    MODEL_CODE: 'PRE',
    MODEL_DISPLAY: 'Prelude',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'HONDA',
    MAKE_DISPLAY: 'Honda',
    MODEL_CODE: 'HONDELSOL',
    MODEL_DISPLAY: 'Del Sol',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'HONDA',
    MAKE_DISPLAY: 'Honda',
    MODEL_CODE: 'HONOTH',
    MODEL_DISPLAY: 'Other Honda Models',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'HONDA',
    MAKE_DISPLAY: 'Honda',
    MODEL_CODE: 'S2000',
    MODEL_DISPLAY: 'S2000',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'HONDA',
    MAKE_DISPLAY: 'Honda',
    MODEL_CODE: 'INSIGHT',
    MODEL_DISPLAY: 'Insight',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'HONDA',
    MAKE_DISPLAY: 'Honda',
    MODEL_CODE: 'HONHRV',
    MODEL_DISPLAY: 'HR-V',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'HONDA',
    MAKE_DISPLAY: 'Honda',
    MODEL_CODE: 'CROSSTOUR',
    MODEL_DISPLAY: 'Accord Crosstour',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'HONDA',
    MAKE_DISPLAY: 'Honda',
    MODEL_CODE: 'ODYSSEY',
    MODEL_DISPLAY: 'Odyssey',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'HONDA',
    MAKE_DISPLAY: 'Honda',
    MODEL_CODE: 'HONCROSS',
    MODEL_DISPLAY: 'Crosstour',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'HONDA',
    MAKE_DISPLAY: 'Honda',
    MODEL_CODE: 'HONCLARITY',
    MODEL_DISPLAY: 'Clarity',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'HYUND',
    MAKE_DISPLAY: 'Hyundai',
    MODEL_CODE: 'HYUEXCEL',
    MODEL_DISPLAY: 'Excel',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'HYUND',
    MAKE_DISPLAY: 'Hyundai',
    MODEL_CODE: 'SONATA',
    MODEL_DISPLAY: 'Sonata',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'HYUND',
    MAKE_DISPLAY: 'Hyundai',
    MODEL_CODE: 'XG350',
    MODEL_DISPLAY: 'XG350',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'HYUND',
    MAKE_DISPLAY: 'Hyundai',
    MODEL_CODE: 'TUCSON',
    MODEL_DISPLAY: 'Tucson',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'HYUND',
    MAKE_DISPLAY: 'Hyundai',
    MODEL_CODE: 'ACCENT',
    MODEL_DISPLAY: 'Accent',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'HYUND',
    MAKE_DISPLAY: 'Hyundai',
    MODEL_CODE: 'SCOUPE',
    MODEL_DISPLAY: 'Scoupe',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'HYUND',
    MAKE_DISPLAY: 'Hyundai',
    MODEL_CODE: 'TIBURO',
    MODEL_DISPLAY: 'Tiburon',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'HYUND',
    MAKE_DISPLAY: 'Hyundai',
    MODEL_CODE: 'AZERA',
    MODEL_DISPLAY: 'Azera',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'HYUND',
    MAKE_DISPLAY: 'Hyundai',
    MODEL_CODE: 'ENTOURAGE',
    MODEL_DISPLAY: 'Entourage',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'HYUND',
    MAKE_DISPLAY: 'Hyundai',
    MODEL_CODE: 'ELANTR',
    MODEL_DISPLAY: 'Elantra',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'HYUND',
    MAKE_DISPLAY: 'Hyundai',
    MODEL_CODE: 'HYUOTH',
    MODEL_DISPLAY: 'Other Hyundai Models',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'HYUND',
    MAKE_DISPLAY: 'Hyundai',
    MODEL_CODE: 'SANTAFE',
    MODEL_DISPLAY: 'Santa Fe',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'HYUND',
    MAKE_DISPLAY: 'Hyundai',
    MODEL_CODE: 'XG300',
    MODEL_DISPLAY: 'XG300',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'HYUND',
    MAKE_DISPLAY: 'Hyundai',
    MODEL_CODE: 'HYUIONIQ',
    MODEL_DISPLAY: 'Ioniq',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'HYUND',
    MAKE_DISPLAY: 'Hyundai',
    MODEL_CODE: 'HYUKONA',
    MODEL_DISPLAY: 'Kona',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'HYUND',
    MAKE_DISPLAY: 'Hyundai',
    MODEL_CODE: 'EQUUS',
    MODEL_DISPLAY: 'Equus',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'HYUND',
    MAKE_DISPLAY: 'Hyundai',
    MODEL_CODE: 'VERACRUZ',
    MODEL_DISPLAY: 'Veracruz',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'HYUND',
    MAKE_DISPLAY: 'Hyundai',
    MODEL_CODE: 'VELOSTER',
    MODEL_DISPLAY: 'Veloster',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'HYUND',
    MAKE_DISPLAY: 'Hyundai',
    MODEL_CODE: 'HYUELANCPE',
    MODEL_DISPLAY: 'Elantra Coupe',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'HYUND',
    MAKE_DISPLAY: 'Hyundai',
    MODEL_CODE: 'GENESIS',
    MODEL_DISPLAY: 'Genesis',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'HYUND',
    MAKE_DISPLAY: 'Hyundai',
    MODEL_CODE: 'GENESISCPE',
    MODEL_DISPLAY: 'Genesis Coupe',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'HYUND',
    MAKE_DISPLAY: 'Hyundai',
    MODEL_CODE: 'ELANTOUR',
    MODEL_DISPLAY: 'Elantra Touring',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'INFIN',
    MAKE_DISPLAY: 'INFINITI',
    MODEL_CODE: 'G20',
    MODEL_DISPLAY: 'G20',
    CLASS_SERIES_CODE: 'G_MODELS',
    CLASS_SERIES_DISPLAY: 'G Models',
  },
  {
    MAKE_CODE: 'INFIN',
    MAKE_DISPLAY: 'INFINITI',
    MODEL_CODE: 'I30',
    MODEL_DISPLAY: 'I30',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'INFIN',
    MAKE_DISPLAY: 'INFINITI',
    MODEL_CODE: 'QX4',
    MODEL_DISPLAY: 'QX4',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'INFIN',
    MAKE_DISPLAY: 'INFINITI',
    MODEL_CODE: 'G35',
    MODEL_DISPLAY: 'G35',
    CLASS_SERIES_CODE: 'G_MODELS',
    CLASS_SERIES_DISPLAY: 'G Models',
  },
  {
    MAKE_CODE: 'INFIN',
    MAKE_DISPLAY: 'INFINITI',
    MODEL_CODE: 'M45',
    MODEL_DISPLAY: 'M45',
    CLASS_SERIES_CODE: 'M_MODELS',
    CLASS_SERIES_DISPLAY: 'M Models',
  },
  {
    MAKE_CODE: 'INFIN',
    MAKE_DISPLAY: 'INFINITI',
    MODEL_CODE: 'FX35',
    MODEL_DISPLAY: 'FX35',
    CLASS_SERIES_CODE: 'FX_MODELS',
    CLASS_SERIES_DISPLAY: 'FX Models',
  },
  {
    MAKE_CODE: 'INFIN',
    MAKE_DISPLAY: 'INFINITI',
    MODEL_CODE: 'FX45',
    MODEL_DISPLAY: 'FX45',
    CLASS_SERIES_CODE: 'FX_MODELS',
    CLASS_SERIES_DISPLAY: 'FX Models',
  },
  {
    MAKE_CODE: 'INFIN',
    MAKE_DISPLAY: 'INFINITI',
    MODEL_CODE: 'QX56',
    MODEL_DISPLAY: 'QX56',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'INFIN',
    MAKE_DISPLAY: 'INFINITI',
    MODEL_CODE: 'M35',
    MODEL_DISPLAY: 'M35',
    CLASS_SERIES_CODE: 'M_MODELS',
    CLASS_SERIES_DISPLAY: 'M Models',
  },
  {
    MAKE_CODE: 'INFIN',
    MAKE_DISPLAY: 'INFINITI',
    MODEL_CODE: 'J30',
    MODEL_DISPLAY: 'J30',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'INFIN',
    MAKE_DISPLAY: 'INFINITI',
    MODEL_CODE: 'Q45',
    MODEL_DISPLAY: 'Q45',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'INFIN',
    MAKE_DISPLAY: 'INFINITI',
    MODEL_CODE: 'M30',
    MODEL_DISPLAY: 'M30',
    CLASS_SERIES_CODE: 'M_MODELS',
    CLASS_SERIES_DISPLAY: 'M Models',
  },
  {
    MAKE_CODE: 'INFIN',
    MAKE_DISPLAY: 'INFINITI',
    MODEL_CODE: 'M35HYBRID',
    MODEL_DISPLAY: 'M35h',
    CLASS_SERIES_CODE: 'M_MODELS',
    CLASS_SERIES_DISPLAY: 'M Models',
  },
  {
    MAKE_CODE: 'INFIN',
    MAKE_DISPLAY: 'INFINITI',
    MODEL_CODE: 'I35',
    MODEL_DISPLAY: 'I35',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'INFIN',
    MAKE_DISPLAY: 'INFINITI',
    MODEL_CODE: 'EX37',
    MODEL_DISPLAY: 'EX37',
    CLASS_SERIES_CODE: 'EX_MODELS',
    CLASS_SERIES_DISPLAY: 'EX Models',
  },
  {
    MAKE_CODE: 'INFIN',
    MAKE_DISPLAY: 'INFINITI',
    MODEL_CODE: 'FX37',
    MODEL_DISPLAY: 'FX37',
    CLASS_SERIES_CODE: 'FX_MODELS',
    CLASS_SERIES_DISPLAY: 'FX Models',
  },
  {
    MAKE_CODE: 'INFIN',
    MAKE_DISPLAY: 'INFINITI',
    MODEL_CODE: 'INFOTH',
    MODEL_DISPLAY: 'Other Infiniti Models',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'INFIN',
    MAKE_DISPLAY: 'INFINITI',
    MODEL_CODE: 'INFINQ40',
    MODEL_DISPLAY: 'Q40',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'INFIN',
    MAKE_DISPLAY: 'INFINITI',
    MODEL_CODE: 'FX50',
    MODEL_DISPLAY: 'FX50',
    CLASS_SERIES_CODE: 'FX_MODELS',
    CLASS_SERIES_DISPLAY: 'FX Models',
  },
  {
    MAKE_CODE: 'INFIN',
    MAKE_DISPLAY: 'INFINITI',
    MODEL_CODE: 'INFINQ50',
    MODEL_DISPLAY: 'Q50',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'INFIN',
    MAKE_DISPLAY: 'INFINITI',
    MODEL_CODE: 'INFINQX60',
    MODEL_DISPLAY: 'QX60',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'INFIN',
    MAKE_DISPLAY: 'INFINITI',
    MODEL_CODE: 'INFINQX30',
    MODEL_DISPLAY: 'QX30',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'INFIN',
    MAKE_DISPLAY: 'INFINITI',
    MODEL_CODE: 'G25',
    MODEL_DISPLAY: 'G25',
    CLASS_SERIES_CODE: 'G_MODELS',
    CLASS_SERIES_DISPLAY: 'G Models',
  },
  {
    MAKE_CODE: 'INFIN',
    MAKE_DISPLAY: 'INFINITI',
    MODEL_CODE: 'JX35',
    MODEL_DISPLAY: 'JX35',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'INFIN',
    MAKE_DISPLAY: 'INFINITI',
    MODEL_CODE: 'INFINQ60',
    MODEL_DISPLAY: 'Q60',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'INFIN',
    MAKE_DISPLAY: 'INFINITI',
    MODEL_CODE: 'INFINQ70',
    MODEL_DISPLAY: 'Q70',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'INFIN',
    MAKE_DISPLAY: 'INFINITI',
    MODEL_CODE: 'INFINQX50',
    MODEL_DISPLAY: 'QX50',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'INFIN',
    MAKE_DISPLAY: 'INFINITI',
    MODEL_CODE: 'INFINQX70',
    MODEL_DISPLAY: 'QX70',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'INFIN',
    MAKE_DISPLAY: 'INFINITI',
    MODEL_CODE: 'INFINQX80',
    MODEL_DISPLAY: 'QX80',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'INFIN',
    MAKE_DISPLAY: 'INFINITI',
    MODEL_CODE: 'G37',
    MODEL_DISPLAY: 'G37',
    CLASS_SERIES_CODE: 'G_MODELS',
    CLASS_SERIES_DISPLAY: 'G Models',
  },
  {
    MAKE_CODE: 'INFIN',
    MAKE_DISPLAY: 'INFINITI',
    MODEL_CODE: 'M37',
    MODEL_DISPLAY: 'M37',
    CLASS_SERIES_CODE: 'M_MODELS',
    CLASS_SERIES_DISPLAY: 'M Models',
  },
  {
    MAKE_CODE: 'INFIN',
    MAKE_DISPLAY: 'INFINITI',
    MODEL_CODE: 'M56',
    MODEL_DISPLAY: 'M56',
    CLASS_SERIES_CODE: 'M_MODELS',
    CLASS_SERIES_DISPLAY: 'M Models',
  },
  {
    MAKE_CODE: 'INFIN',
    MAKE_DISPLAY: 'INFINITI',
    MODEL_CODE: 'EX35',
    MODEL_DISPLAY: 'EX35',
    CLASS_SERIES_CODE: 'EX_MODELS',
    CLASS_SERIES_DISPLAY: 'EX Models',
  },
  {
    MAKE_CODE: 'ISU',
    MAKE_DISPLAY: 'Isuzu',
    MODEL_CODE: 'AMIGO',
    MODEL_DISPLAY: 'Amigo',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ISU',
    MAKE_DISPLAY: 'Isuzu',
    MODEL_CODE: 'HOMBRE',
    MODEL_DISPLAY: 'Hombre',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ISU',
    MAKE_DISPLAY: 'Isuzu',
    MODEL_CODE: 'ISUIMP',
    MODEL_DISPLAY: 'Impulse',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ISU',
    MAKE_DISPLAY: 'Isuzu',
    MODEL_CODE: 'ISUPU',
    MODEL_DISPLAY: 'Pickup',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ISU',
    MAKE_DISPLAY: 'Isuzu',
    MODEL_CODE: 'STYLUS',
    MODEL_DISPLAY: 'Stylus',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ISU',
    MAKE_DISPLAY: 'Isuzu',
    MODEL_CODE: 'ASCENDER',
    MODEL_DISPLAY: 'Ascender',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ISU',
    MAKE_DISPLAY: 'Isuzu',
    MODEL_CODE: 'OASIS',
    MODEL_DISPLAY: 'Oasis',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ISU',
    MAKE_DISPLAY: 'Isuzu',
    MODEL_CODE: 'RODEO',
    MODEL_DISPLAY: 'Rodeo',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ISU',
    MAKE_DISPLAY: 'Isuzu',
    MODEL_CODE: 'TRP2',
    MODEL_DISPLAY: 'Trooper II',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ISU',
    MAKE_DISPLAY: 'Isuzu',
    MODEL_CODE: 'I280',
    MODEL_DISPLAY: 'i-280',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ISU',
    MAKE_DISPLAY: 'Isuzu',
    MODEL_CODE: 'I350',
    MODEL_DISPLAY: 'i-350',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ISU',
    MAKE_DISPLAY: 'Isuzu',
    MODEL_CODE: 'I290',
    MODEL_DISPLAY: 'i-290',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ISU',
    MAKE_DISPLAY: 'Isuzu',
    MODEL_CODE: 'I370',
    MODEL_DISPLAY: 'i-370',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ISU',
    MAKE_DISPLAY: 'Isuzu',
    MODEL_CODE: 'TROOP',
    MODEL_DISPLAY: 'Trooper',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ISU',
    MAKE_DISPLAY: 'Isuzu',
    MODEL_CODE: 'ISUMARK',
    MODEL_DISPLAY: 'I-Mark',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ISU',
    MAKE_DISPLAY: 'Isuzu',
    MODEL_CODE: 'VEHICROSS',
    MODEL_DISPLAY: 'VehiCROSS',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ISU',
    MAKE_DISPLAY: 'Isuzu',
    MODEL_CODE: 'ISUOTH',
    MODEL_DISPLAY: 'Other Isuzu Models',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ISU',
    MAKE_DISPLAY: 'Isuzu',
    MODEL_CODE: 'AXIOM',
    MODEL_DISPLAY: 'Axiom',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'JAG',
    MAKE_DISPLAY: 'Jaguar',
    MODEL_CODE: 'JAGXJ12',
    MODEL_DISPLAY: 'XJ12',
    CLASS_SERIES_CODE: 'XJ_SERIES',
    CLASS_SERIES_DISPLAY: 'XJ Series',
  },
  {
    MAKE_CODE: 'JAG',
    MAKE_DISPLAY: 'Jaguar',
    MODEL_CODE: 'JAGXJR',
    MODEL_DISPLAY: 'XJR',
    CLASS_SERIES_CODE: 'XJ_SERIES',
    CLASS_SERIES_DISPLAY: 'XJ Series',
  },
  {
    MAKE_CODE: 'JAG',
    MAKE_DISPLAY: 'Jaguar',
    MODEL_CODE: 'JAGXK8',
    MODEL_DISPLAY: 'XK8',
    CLASS_SERIES_CODE: 'XK_SERIES',
    CLASS_SERIES_DISPLAY: 'XK Series',
  },
  {
    MAKE_CODE: 'JAG',
    MAKE_DISPLAY: 'Jaguar',
    MODEL_CODE: 'VANDEN',
    MODEL_DISPLAY: 'XJ Vanden Plas',
    CLASS_SERIES_CODE: 'XJ_SERIES',
    CLASS_SERIES_DISPLAY: 'XJ Series',
  },
  {
    MAKE_CODE: 'JAG',
    MAKE_DISPLAY: 'Jaguar',
    MODEL_CODE: 'XJ8',
    MODEL_DISPLAY: 'XJ8',
    CLASS_SERIES_CODE: 'XJ_SERIES',
    CLASS_SERIES_DISPLAY: 'XJ Series',
  },
  {
    MAKE_CODE: 'JAG',
    MAKE_DISPLAY: 'Jaguar',
    MODEL_CODE: 'JAGXJRS',
    MODEL_DISPLAY: 'XJR-S',
    CLASS_SERIES_CODE: 'XJ_SERIES',
    CLASS_SERIES_DISPLAY: 'XJ Series',
  },
  {
    MAKE_CODE: 'JAG',
    MAKE_DISPLAY: 'Jaguar',
    MODEL_CODE: 'STYPE',
    MODEL_DISPLAY: 'S-TYPE',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'JAG',
    MAKE_DISPLAY: 'Jaguar',
    MODEL_CODE: 'JAGOTH',
    MODEL_DISPLAY: 'Other Jaguar Models',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'JAG',
    MAKE_DISPLAY: 'Jaguar',
    MODEL_CODE: 'XKR',
    MODEL_DISPLAY: 'XKR',
    CLASS_SERIES_CODE: 'XK_SERIES',
    CLASS_SERIES_DISPLAY: 'XK Series',
  },
  {
    MAKE_CODE: 'JAG',
    MAKE_DISPLAY: 'Jaguar',
    MODEL_CODE: 'XTYPE',
    MODEL_DISPLAY: 'X-TYPE',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'JAG',
    MAKE_DISPLAY: 'Jaguar',
    MODEL_CODE: 'JAGFPACE',
    MODEL_DISPLAY: 'F-PACE',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'JAG',
    MAKE_DISPLAY: 'Jaguar',
    MODEL_CODE: 'JAGXJ6',
    MODEL_DISPLAY: 'XJ6',
    CLASS_SERIES_CODE: 'XJ_SERIES',
    CLASS_SERIES_DISPLAY: 'XJ Series',
  },
  {
    MAKE_CODE: 'JAG',
    MAKE_DISPLAY: 'Jaguar',
    MODEL_CODE: 'JAGXJS',
    MODEL_DISPLAY: 'XJS',
    CLASS_SERIES_CODE: 'XJ_SERIES',
    CLASS_SERIES_DISPLAY: 'XJ Series',
  },
  {
    MAKE_CODE: 'JAG',
    MAKE_DISPLAY: 'Jaguar',
    MODEL_CODE: 'XK',
    MODEL_DISPLAY: 'XK',
    CLASS_SERIES_CODE: 'XK_SERIES',
    CLASS_SERIES_DISPLAY: 'XK Series',
  },
  {
    MAKE_CODE: 'JAG',
    MAKE_DISPLAY: 'Jaguar',
    MODEL_CODE: 'XJ',
    MODEL_DISPLAY: 'XJ',
    CLASS_SERIES_CODE: 'XJ_SERIES',
    CLASS_SERIES_DISPLAY: 'XJ Series',
  },
  {
    MAKE_CODE: 'JAG',
    MAKE_DISPLAY: 'Jaguar',
    MODEL_CODE: 'XF',
    MODEL_DISPLAY: 'XF',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'JAG',
    MAKE_DISPLAY: 'Jaguar',
    MODEL_CODE: 'JAGFTYPE',
    MODEL_DISPLAY: 'F-TYPE',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'JAG',
    MAKE_DISPLAY: 'Jaguar',
    MODEL_CODE: 'JAGIPACE',
    MODEL_DISPLAY: 'I-PACE',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'JAG',
    MAKE_DISPLAY: 'Jaguar',
    MODEL_CODE: 'XJ8L',
    MODEL_DISPLAY: 'XJ8 L',
    CLASS_SERIES_CODE: 'XJ_SERIES',
    CLASS_SERIES_DISPLAY: 'XJ Series',
  },
  {
    MAKE_CODE: 'JAG',
    MAKE_DISPLAY: 'Jaguar',
    MODEL_CODE: 'XJSPORT',
    MODEL_DISPLAY: 'XJ Sport',
    CLASS_SERIES_CODE: 'XJ_SERIES',
    CLASS_SERIES_DISPLAY: 'XJ Series',
  },
  {
    MAKE_CODE: 'JAG',
    MAKE_DISPLAY: 'Jaguar',
    MODEL_CODE: 'JAGXE',
    MODEL_DISPLAY: 'XE',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'JAG',
    MAKE_DISPLAY: 'Jaguar',
    MODEL_CODE: 'JAGEPACE',
    MODEL_DISPLAY: 'E-PACE',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'JEEP',
    MAKE_DISPLAY: 'Jeep',
    MODEL_CODE: 'CHER',
    MODEL_DISPLAY: 'Cherokee',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'JEEP',
    MAKE_DISPLAY: 'Jeep',
    MODEL_CODE: 'COMANC',
    MODEL_DISPLAY: 'Comanche',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'JEEP',
    MAKE_DISPLAY: 'Jeep',
    MODEL_CODE: 'GRWAG',
    MODEL_DISPLAY: 'Grand Wagoneer',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'JEEP',
    MAKE_DISPLAY: 'Jeep',
    MODEL_CODE: 'JEEPCJ',
    MODEL_DISPLAY: 'CJ',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'JEEP',
    MAKE_DISPLAY: 'Jeep',
    MODEL_CODE: 'JEEPPU',
    MODEL_DISPLAY: 'Pickup',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'JEEP',
    MAKE_DISPLAY: 'Jeep',
    MODEL_CODE: 'WAGONE',
    MODEL_DISPLAY: 'Wagoneer',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'JEEP',
    MAKE_DISPLAY: 'Jeep',
    MODEL_CODE: 'COMMANDER',
    MODEL_DISPLAY: 'Commander',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'JEEP',
    MAKE_DISPLAY: 'Jeep',
    MODEL_CODE: 'COMPASS',
    MODEL_DISPLAY: 'Compass',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'JEEP',
    MAKE_DISPLAY: 'Jeep',
    MODEL_CODE: 'JEEPGRAND',
    MODEL_DISPLAY: 'Grand Cherokee',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'JEEP',
    MAKE_DISPLAY: 'Jeep',
    MODEL_CODE: 'WRANGLER',
    MODEL_DISPLAY: 'Wrangler',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'JEEP',
    MAKE_DISPLAY: 'Jeep',
    MODEL_CODE: 'JEOTH',
    MODEL_DISPLAY: 'Other Jeep Models',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'JEEP',
    MAKE_DISPLAY: 'Jeep',
    MODEL_CODE: 'PATRIOT',
    MODEL_DISPLAY: 'Patriot',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'JEEP',
    MAKE_DISPLAY: 'Jeep',
    MODEL_CODE: 'LIBERTY',
    MODEL_DISPLAY: 'Liberty',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'JEEP',
    MAKE_DISPLAY: 'Jeep',
    MODEL_CODE: 'JEEPRENEG',
    MODEL_DISPLAY: 'Renegade',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'JEEP',
    MAKE_DISPLAY: 'Jeep',
    MODEL_CODE: 'SCRAMBLE',
    MODEL_DISPLAY: 'Scrambler',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'KIA',
    MAKE_DISPLAY: 'Kia',
    MODEL_CODE: 'SEPHIA',
    MODEL_DISPLAY: 'Sephia',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'KIA',
    MAKE_DISPLAY: 'Kia',
    MODEL_CODE: 'SPORTA',
    MODEL_DISPLAY: 'Sportage',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'KIA',
    MAKE_DISPLAY: 'Kia',
    MODEL_CODE: 'SORENTO',
    MODEL_DISPLAY: 'Sorento',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'KIA',
    MAKE_DISPLAY: 'Kia',
    MODEL_CODE: 'AMANTI',
    MODEL_DISPLAY: 'Amanti',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'KIA',
    MAKE_DISPLAY: 'Kia',
    MODEL_CODE: 'SPECTRA5',
    MODEL_DISPLAY: 'Spectra5',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'KIA',
    MAKE_DISPLAY: 'Kia',
    MODEL_CODE: 'KIAOTH',
    MODEL_DISPLAY: 'Other Kia Models',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'KIA',
    MAKE_DISPLAY: 'Kia',
    MODEL_CODE: 'RONDO',
    MODEL_DISPLAY: 'Rondo',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'KIA',
    MAKE_DISPLAY: 'Kia',
    MODEL_CODE: 'SPECTRA',
    MODEL_DISPLAY: 'Spectra',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'KIA',
    MAKE_DISPLAY: 'Kia',
    MODEL_CODE: 'KIAK900',
    MODEL_DISPLAY: 'K900',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'KIA',
    MAKE_DISPLAY: 'Kia',
    MODEL_CODE: 'RIO',
    MODEL_DISPLAY: 'Rio',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'KIA',
    MAKE_DISPLAY: 'Kia',
    MODEL_CODE: 'OPTIMA',
    MODEL_DISPLAY: 'Optima',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'KIA',
    MAKE_DISPLAY: 'Kia',
    MODEL_CODE: 'SEDONA',
    MODEL_DISPLAY: 'Sedona',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'KIA',
    MAKE_DISPLAY: 'Kia',
    MODEL_CODE: 'RIO5',
    MODEL_DISPLAY: 'Rio5',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'KIA',
    MAKE_DISPLAY: 'Kia',
    MODEL_CODE: 'FORTE',
    MODEL_DISPLAY: 'Forte',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'KIA',
    MAKE_DISPLAY: 'Kia',
    MODEL_CODE: 'KIACADENZA',
    MODEL_DISPLAY: 'Cadenza',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'KIA',
    MAKE_DISPLAY: 'Kia',
    MODEL_CODE: 'KIASTING',
    MODEL_DISPLAY: 'Stinger',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'KIA',
    MAKE_DISPLAY: 'Kia',
    MODEL_CODE: 'BORREGO',
    MODEL_DISPLAY: 'Borrego',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'KIA',
    MAKE_DISPLAY: 'Kia',
    MODEL_CODE: 'FORTEKOUP',
    MODEL_DISPLAY: 'Forte Koup',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'KIA',
    MAKE_DISPLAY: 'Kia',
    MODEL_CODE: 'SOUL',
    MODEL_DISPLAY: 'Soul',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'KIA',
    MAKE_DISPLAY: 'Kia',
    MODEL_CODE: 'KIANIRO',
    MODEL_DISPLAY: 'Niro',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'LAM',
    MAKE_DISPLAY: 'Lamborghini',
    MODEL_CODE: 'COUNT',
    MODEL_DISPLAY: 'Countach',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'LAM',
    MAKE_DISPLAY: 'Lamborghini',
    MODEL_CODE: 'DIABLO',
    MODEL_DISPLAY: 'Diablo',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'LAM',
    MAKE_DISPLAY: 'Lamborghini',
    MODEL_CODE: 'GALLARDO',
    MODEL_DISPLAY: 'Gallardo',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'LAM',
    MAKE_DISPLAY: 'Lamborghini',
    MODEL_CODE: 'JALPA',
    MODEL_DISPLAY: 'Jalpa',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'LAM',
    MAKE_DISPLAY: 'Lamborghini',
    MODEL_CODE: 'MURCIELAGO',
    MODEL_DISPLAY: 'Murcielago',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'LAM',
    MAKE_DISPLAY: 'Lamborghini',
    MODEL_CODE: 'LAMHURACAN',
    MODEL_DISPLAY: 'Huracan',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'LAM',
    MAKE_DISPLAY: 'Lamborghini',
    MODEL_CODE: 'AVENT',
    MODEL_DISPLAY: 'Aventador',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'LAM',
    MAKE_DISPLAY: 'Lamborghini',
    MODEL_CODE: 'LAMOTH',
    MODEL_DISPLAY: 'Other Lamborghini Models',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'LAM',
    MAKE_DISPLAY: 'Lamborghini',
    MODEL_CODE: 'LAMURUS',
    MODEL_DISPLAY: 'Urus',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'LAM',
    MAKE_DISPLAY: 'Lamborghini',
    MODEL_CODE: 'LM002',
    MODEL_DISPLAY: 'LM002',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'LEXUS',
    MAKE_DISPLAY: 'Lexus',
    MODEL_CODE: 'ES300',
    MODEL_DISPLAY: 'ES 300',
    CLASS_SERIES_CODE: 'ES_MODELS',
    CLASS_SERIES_DISPLAY: 'ES Models',
  },
  {
    MAKE_CODE: 'LEXUS',
    MAKE_DISPLAY: 'Lexus',
    MODEL_CODE: 'GS400',
    MODEL_DISPLAY: 'GS 400',
    CLASS_SERIES_CODE: 'GS_MODELS',
    CLASS_SERIES_DISPLAY: 'GS Models',
  },
  {
    MAKE_CODE: 'LEXUS',
    MAKE_DISPLAY: 'Lexus',
    MODEL_CODE: 'LX450',
    MODEL_DISPLAY: 'LX 450',
    CLASS_SERIES_CODE: 'LX_MODELS',
    CLASS_SERIES_DISPLAY: 'LX Models',
  },
  {
    MAKE_CODE: 'LEXUS',
    MAKE_DISPLAY: 'Lexus',
    MODEL_CODE: 'LX470',
    MODEL_DISPLAY: 'LX 470',
    CLASS_SERIES_CODE: 'LX_MODELS',
    CLASS_SERIES_DISPLAY: 'LX Models',
  },
  {
    MAKE_CODE: 'LEXUS',
    MAKE_DISPLAY: 'Lexus',
    MODEL_CODE: 'RX300',
    MODEL_DISPLAY: 'RX 300',
    CLASS_SERIES_CODE: 'RX_MODELS',
    CLASS_SERIES_DISPLAY: 'RX Models',
  },
  {
    MAKE_CODE: 'LEXUS',
    MAKE_DISPLAY: 'Lexus',
    MODEL_CODE: 'SC300',
    MODEL_DISPLAY: 'SC 300',
    CLASS_SERIES_CODE: 'SC_MODELS',
    CLASS_SERIES_DISPLAY: 'SC Models',
  },
  {
    MAKE_CODE: 'LEXUS',
    MAKE_DISPLAY: 'Lexus',
    MODEL_CODE: 'SC400',
    MODEL_DISPLAY: 'SC 400',
    CLASS_SERIES_CODE: 'SC_MODELS',
    CLASS_SERIES_DISPLAY: 'SC Models',
  },
  {
    MAKE_CODE: 'LEXUS',
    MAKE_DISPLAY: 'Lexus',
    MODEL_CODE: 'GX470',
    MODEL_DISPLAY: 'GX 470',
    CLASS_SERIES_CODE: 'GX_MODELS',
    CLASS_SERIES_DISPLAY: 'GX Models',
  },
  {
    MAKE_CODE: 'LEXUS',
    MAKE_DISPLAY: 'Lexus',
    MODEL_CODE: 'RX330',
    MODEL_DISPLAY: 'RX 330',
    CLASS_SERIES_CODE: 'RX_MODELS',
    CLASS_SERIES_DISPLAY: 'RX Models',
  },
  {
    MAKE_CODE: 'LEXUS',
    MAKE_DISPLAY: 'Lexus',
    MODEL_CODE: 'ES330',
    MODEL_DISPLAY: 'ES 330',
    CLASS_SERIES_CODE: 'ES_MODELS',
    CLASS_SERIES_DISPLAY: 'ES Models',
  },
  {
    MAKE_CODE: 'LEXUS',
    MAKE_DISPLAY: 'Lexus',
    MODEL_CODE: 'RX400H',
    MODEL_DISPLAY: 'RX 400h',
    CLASS_SERIES_CODE: 'RX_MODELS',
    CLASS_SERIES_DISPLAY: 'RX Models',
  },
  {
    MAKE_CODE: 'LEXUS',
    MAKE_DISPLAY: 'Lexus',
    MODEL_CODE: 'ES250',
    MODEL_DISPLAY: 'ES 250',
    CLASS_SERIES_CODE: 'ES_MODELS',
    CLASS_SERIES_DISPLAY: 'ES Models',
  },
  {
    MAKE_CODE: 'LEXUS',
    MAKE_DISPLAY: 'Lexus',
    MODEL_CODE: 'LS400',
    MODEL_DISPLAY: 'LS 400',
    CLASS_SERIES_CODE: 'LS_MODELS',
    CLASS_SERIES_DISPLAY: 'LS Models',
  },
  {
    MAKE_CODE: 'LEXUS',
    MAKE_DISPLAY: 'Lexus',
    MODEL_CODE: 'IS350',
    MODEL_DISPLAY: 'IS 350',
    CLASS_SERIES_CODE: 'IS_MODELS',
    CLASS_SERIES_DISPLAY: 'IS Models',
  },
  {
    MAKE_CODE: 'LEXUS',
    MAKE_DISPLAY: 'Lexus',
    MODEL_CODE: 'IS250',
    MODEL_DISPLAY: 'IS 250',
    CLASS_SERIES_CODE: 'IS_MODELS',
    CLASS_SERIES_DISPLAY: 'IS Models',
  },
  {
    MAKE_CODE: 'LEXUS',
    MAKE_DISPLAY: 'Lexus',
    MODEL_CODE: 'RX350',
    MODEL_DISPLAY: 'RX 350',
    CLASS_SERIES_CODE: 'RX_MODELS',
    CLASS_SERIES_DISPLAY: 'RX Models',
  },
  {
    MAKE_CODE: 'LEXUS',
    MAKE_DISPLAY: 'Lexus',
    MODEL_CODE: 'ES350',
    MODEL_DISPLAY: 'ES 350',
    CLASS_SERIES_CODE: 'ES_MODELS',
    CLASS_SERIES_DISPLAY: 'ES Models',
  },
  {
    MAKE_CODE: 'LEXUS',
    MAKE_DISPLAY: 'Lexus',
    MODEL_CODE: 'GS450H',
    MODEL_DISPLAY: 'GS 450h',
    CLASS_SERIES_CODE: 'GS_MODELS',
    CLASS_SERIES_DISPLAY: 'GS Models',
  },
  {
    MAKE_CODE: 'LEXUS',
    MAKE_DISPLAY: 'Lexus',
    MODEL_CODE: 'LS460',
    MODEL_DISPLAY: 'LS 460',
    CLASS_SERIES_CODE: 'LS_MODELS',
    CLASS_SERIES_DISPLAY: 'LS Models',
  },
  {
    MAKE_CODE: 'LEXUS',
    MAKE_DISPLAY: 'Lexus',
    MODEL_CODE: 'GS350',
    MODEL_DISPLAY: 'GS 350',
    CLASS_SERIES_CODE: 'GS_MODELS',
    CLASS_SERIES_DISPLAY: 'GS Models',
  },
  {
    MAKE_CODE: 'LEXUS',
    MAKE_DISPLAY: 'Lexus',
    MODEL_CODE: 'GS300',
    MODEL_DISPLAY: 'GS 300',
    CLASS_SERIES_CODE: 'GS_MODELS',
    CLASS_SERIES_DISPLAY: 'GS Models',
  },
  {
    MAKE_CODE: 'LEXUS',
    MAKE_DISPLAY: 'Lexus',
    MODEL_CODE: 'LEXLFA',
    MODEL_DISPLAY: 'LFA',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'LEXUS',
    MAKE_DISPLAY: 'Lexus',
    MODEL_CODE: 'ES300H',
    MODEL_DISPLAY: 'ES 300h',
    CLASS_SERIES_CODE: 'ES_MODELS',
    CLASS_SERIES_DISPLAY: 'ES Models',
  },
  {
    MAKE_CODE: 'LEXUS',
    MAKE_DISPLAY: 'Lexus',
    MODEL_CODE: 'LEXOTH',
    MODEL_DISPLAY: 'Other Lexus Models',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'LEXUS',
    MAKE_DISPLAY: 'Lexus',
    MODEL_CODE: 'LEXGS200T',
    MODEL_DISPLAY: 'GS 200t',
    CLASS_SERIES_CODE: 'GS_MODELS',
    CLASS_SERIES_DISPLAY: 'GS Models',
  },
  {
    MAKE_CODE: 'LEXUS',
    MAKE_DISPLAY: 'Lexus',
    MODEL_CODE: 'LEXRC200T',
    MODEL_DISPLAY: 'RC 200t',
    CLASS_SERIES_CODE: 'RC_MODELS',
    CLASS_SERIES_DISPLAY: 'RC Models',
  },
  {
    MAKE_CODE: 'LEXUS',
    MAKE_DISPLAY: 'Lexus',
    MODEL_CODE: 'IS300',
    MODEL_DISPLAY: 'IS 300',
    CLASS_SERIES_CODE: 'IS_MODELS',
    CLASS_SERIES_DISPLAY: 'IS Models',
  },
  {
    MAKE_CODE: 'LEXUS',
    MAKE_DISPLAY: 'Lexus',
    MODEL_CODE: 'LS430',
    MODEL_DISPLAY: 'LS 430',
    CLASS_SERIES_CODE: 'LS_MODELS',
    CLASS_SERIES_DISPLAY: 'LS Models',
  },
  {
    MAKE_CODE: 'LEXUS',
    MAKE_DISPLAY: 'Lexus',
    MODEL_CODE: 'GS430',
    MODEL_DISPLAY: 'GS 430',
    CLASS_SERIES_CODE: 'GS_MODELS',
    CLASS_SERIES_DISPLAY: 'GS Models',
  },
  {
    MAKE_CODE: 'LEXUS',
    MAKE_DISPLAY: 'Lexus',
    MODEL_CODE: 'SC430',
    MODEL_DISPLAY: 'SC 430',
    CLASS_SERIES_CODE: 'SC_MODELS',
    CLASS_SERIES_DISPLAY: 'SC Models',
  },
  {
    MAKE_CODE: 'LEXUS',
    MAKE_DISPLAY: 'Lexus',
    MODEL_CODE: 'LEXRC350',
    MODEL_DISPLAY: 'RC 350',
    CLASS_SERIES_CODE: 'RC_MODELS',
    CLASS_SERIES_DISPLAY: 'RC Models',
  },
  {
    MAKE_CODE: 'LEXUS',
    MAKE_DISPLAY: 'Lexus',
    MODEL_CODE: 'LEXRCF',
    MODEL_DISPLAY: 'RC F',
    CLASS_SERIES_CODE: 'RC_MODELS',
    CLASS_SERIES_DISPLAY: 'RC Models',
  },
  {
    MAKE_CODE: 'LEXUS',
    MAKE_DISPLAY: 'Lexus',
    MODEL_CODE: 'LEXUX200',
    MODEL_DISPLAY: 'UX 200',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'LEXUS',
    MAKE_DISPLAY: 'Lexus',
    MODEL_CODE: 'LEXLC500H',
    MODEL_DISPLAY: 'LC 500h',
    CLASS_SERIES_CODE: 'LC_MODELS',
    CLASS_SERIES_DISPLAY: 'LC Models',
  },
  {
    MAKE_CODE: 'LEXUS',
    MAKE_DISPLAY: 'Lexus',
    MODEL_CODE: 'LS600H',
    MODEL_DISPLAY: 'LS 600h',
    CLASS_SERIES_CODE: 'LS_MODELS',
    CLASS_SERIES_DISPLAY: 'LS Models',
  },
  {
    MAKE_CODE: 'LEXUS',
    MAKE_DISPLAY: 'Lexus',
    MODEL_CODE: 'ISF',
    MODEL_DISPLAY: 'IS F',
    CLASS_SERIES_CODE: 'IS_MODELS',
    CLASS_SERIES_DISPLAY: 'IS Models',
  },
  {
    MAKE_CODE: 'LEXUS',
    MAKE_DISPLAY: 'Lexus',
    MODEL_CODE: 'LEXRC300',
    MODEL_DISPLAY: 'RC 300',
    CLASS_SERIES_CODE: 'RC_MODELS',
    CLASS_SERIES_DISPLAY: 'RC Models',
  },
  {
    MAKE_CODE: 'LEXUS',
    MAKE_DISPLAY: 'Lexus',
    MODEL_CODE: 'IS250C',
    MODEL_DISPLAY: 'IS 250C',
    CLASS_SERIES_CODE: 'IS_MODELS',
    CLASS_SERIES_DISPLAY: 'IS Models',
  },
  {
    MAKE_CODE: 'LEXUS',
    MAKE_DISPLAY: 'Lexus',
    MODEL_CODE: 'IS350C',
    MODEL_DISPLAY: 'IS 350C',
    CLASS_SERIES_CODE: 'IS_MODELS',
    CLASS_SERIES_DISPLAY: 'IS Models',
  },
  {
    MAKE_CODE: 'LEXUS',
    MAKE_DISPLAY: 'Lexus',
    MODEL_CODE: 'RX450H',
    MODEL_DISPLAY: 'RX 450h',
    CLASS_SERIES_CODE: 'RX_MODELS',
    CLASS_SERIES_DISPLAY: 'RX Models',
  },
  {
    MAKE_CODE: 'LEXUS',
    MAKE_DISPLAY: 'Lexus',
    MODEL_CODE: 'HS250H',
    MODEL_DISPLAY: 'HS 250h',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'LEXUS',
    MAKE_DISPLAY: 'Lexus',
    MODEL_CODE: 'CT200H',
    MODEL_DISPLAY: 'CT 200h',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'LEXUS',
    MAKE_DISPLAY: 'Lexus',
    MODEL_CODE: 'LEXIS200T',
    MODEL_DISPLAY: 'IS 200t',
    CLASS_SERIES_CODE: 'IS_MODELS',
    CLASS_SERIES_DISPLAY: 'IS Models',
  },
  {
    MAKE_CODE: 'LEXUS',
    MAKE_DISPLAY: 'Lexus',
    MODEL_CODE: 'LEXGSF',
    MODEL_DISPLAY: 'GS F',
    CLASS_SERIES_CODE: 'GS_MODELS',
    CLASS_SERIES_DISPLAY: 'GS Models',
  },
  {
    MAKE_CODE: 'LEXUS',
    MAKE_DISPLAY: 'Lexus',
    MODEL_CODE: 'LEXLC500',
    MODEL_DISPLAY: 'LC 500',
    CLASS_SERIES_CODE: 'LC_MODELS',
    CLASS_SERIES_DISPLAY: 'LC Models',
  },
  {
    MAKE_CODE: 'LEXUS',
    MAKE_DISPLAY: 'Lexus',
    MODEL_CODE: 'LEXLS500',
    MODEL_DISPLAY: 'LS 500',
    CLASS_SERIES_CODE: 'LS_MODELS',
    CLASS_SERIES_DISPLAY: 'LS Models',
  },
  {
    MAKE_CODE: 'LEXUS',
    MAKE_DISPLAY: 'Lexus',
    MODEL_CODE: 'LEXLS500H',
    MODEL_DISPLAY: 'LS 500h',
    CLASS_SERIES_CODE: 'LS_MODELS',
    CLASS_SERIES_DISPLAY: 'LS Models',
  },
  {
    MAKE_CODE: 'LEXUS',
    MAKE_DISPLAY: 'Lexus',
    MODEL_CODE: 'GS460',
    MODEL_DISPLAY: 'GS 460',
    CLASS_SERIES_CODE: 'GS_MODELS',
    CLASS_SERIES_DISPLAY: 'GS Models',
  },
  {
    MAKE_CODE: 'LEXUS',
    MAKE_DISPLAY: 'Lexus',
    MODEL_CODE: 'LX570',
    MODEL_DISPLAY: 'LX 570',
    CLASS_SERIES_CODE: 'LX_MODELS',
    CLASS_SERIES_DISPLAY: 'LX Models',
  },
  {
    MAKE_CODE: 'LEXUS',
    MAKE_DISPLAY: 'Lexus',
    MODEL_CODE: 'GX460',
    MODEL_DISPLAY: 'GX 460',
    CLASS_SERIES_CODE: 'GX_MODELS',
    CLASS_SERIES_DISPLAY: 'GX Models',
  },
  {
    MAKE_CODE: 'LEXUS',
    MAKE_DISPLAY: 'Lexus',
    MODEL_CODE: 'LEXNX200T',
    MODEL_DISPLAY: 'NX 200t',
    CLASS_SERIES_CODE: 'NX_MODELS',
    CLASS_SERIES_DISPLAY: 'NX Models',
  },
  {
    MAKE_CODE: 'LEXUS',
    MAKE_DISPLAY: 'Lexus',
    MODEL_CODE: 'LEXNX300H',
    MODEL_DISPLAY: 'NX 300h',
    CLASS_SERIES_CODE: 'NX_MODELS',
    CLASS_SERIES_DISPLAY: 'NX Models',
  },
  {
    MAKE_CODE: 'LEXUS',
    MAKE_DISPLAY: 'Lexus',
    MODEL_CODE: 'LEXNX300',
    MODEL_DISPLAY: 'NX 300',
    CLASS_SERIES_CODE: 'NX_MODELS',
    CLASS_SERIES_DISPLAY: 'NX Models',
  },
  {
    MAKE_CODE: 'LEXUS',
    MAKE_DISPLAY: 'Lexus',
    MODEL_CODE: 'LEXRX350L',
    MODEL_DISPLAY: 'RX 350L',
    CLASS_SERIES_CODE: 'RX_MODELS',
    CLASS_SERIES_DISPLAY: 'RX Models',
  },
  {
    MAKE_CODE: 'LEXUS',
    MAKE_DISPLAY: 'Lexus',
    MODEL_CODE: 'LEXRX450HL',
    MODEL_DISPLAY: 'RX 450hL',
    CLASS_SERIES_CODE: 'RX_MODELS',
    CLASS_SERIES_DISPLAY: 'RX Models',
  },
  {
    MAKE_CODE: 'LINC',
    MAKE_DISPLAY: 'Lincoln',
    MODEL_CODE: 'MARK6',
    MODEL_DISPLAY: 'Mark VI',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'LINC',
    MAKE_DISPLAY: 'Lincoln',
    MODEL_CODE: 'MARK8',
    MODEL_DISPLAY: 'Mark VIII',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'LINC',
    MAKE_DISPLAY: 'Lincoln',
    MODEL_CODE: 'NAVIGA',
    MODEL_DISPLAY: 'Navigator',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'LINC',
    MAKE_DISPLAY: 'Lincoln',
    MODEL_CODE: 'AVIATOR',
    MODEL_DISPLAY: 'Aviator',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'LINC',
    MAKE_DISPLAY: 'Lincoln',
    MODEL_CODE: 'LSLINCOLN',
    MODEL_DISPLAY: 'LS',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'LINC',
    MAKE_DISPLAY: 'Lincoln',
    MODEL_CODE: 'LINCMKC',
    MODEL_DISPLAY: 'MKC',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'LINC',
    MAKE_DISPLAY: 'Lincoln',
    MODEL_CODE: 'MARKLT',
    MODEL_DISPLAY: 'Mark LT',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'LINC',
    MAKE_DISPLAY: 'Lincoln',
    MODEL_CODE: 'ZEPHYR',
    MODEL_DISPLAY: 'Zephyr',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'LINC',
    MAKE_DISPLAY: 'Lincoln',
    MODEL_CODE: 'MKX',
    MODEL_DISPLAY: 'MKX',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'LINC',
    MAKE_DISPLAY: 'Lincoln',
    MODEL_CODE: 'LINCTC',
    MODEL_DISPLAY: 'Town Car',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'LINC',
    MAKE_DISPLAY: 'Lincoln',
    MODEL_CODE: 'CONT',
    MODEL_DISPLAY: 'Continental',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'LINC',
    MAKE_DISPLAY: 'Lincoln',
    MODEL_CODE: 'MARK7',
    MODEL_DISPLAY: 'Mark VII',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'LINC',
    MAKE_DISPLAY: 'Lincoln',
    MODEL_CODE: 'LINOTH',
    MODEL_DISPLAY: 'Other Lincoln Models',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'LINC',
    MAKE_DISPLAY: 'Lincoln',
    MODEL_CODE: 'MKZ',
    MODEL_DISPLAY: 'MKZ',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'LINC',
    MAKE_DISPLAY: 'Lincoln',
    MODEL_CODE: 'BLKWOOD',
    MODEL_DISPLAY: 'Blackwood',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'LINC',
    MAKE_DISPLAY: 'Lincoln',
    MODEL_CODE: 'MKS',
    MODEL_DISPLAY: 'MKS',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'LINC',
    MAKE_DISPLAY: 'Lincoln',
    MODEL_CODE: 'NAVIGAL',
    MODEL_DISPLAY: 'Navigator L',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'LINC',
    MAKE_DISPLAY: 'Lincoln',
    MODEL_CODE: 'LINCNAUT',
    MODEL_DISPLAY: 'Nautilus',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'LINC',
    MAKE_DISPLAY: 'Lincoln',
    MODEL_CODE: 'MKT',
    MODEL_DISPLAY: 'MKT',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'LOTUS',
    MAKE_DISPLAY: 'Lotus',
    MODEL_CODE: 'ESPRIT',
    MODEL_DISPLAY: 'Esprit',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'LOTUS',
    MAKE_DISPLAY: 'Lotus',
    MODEL_CODE: 'ELAN',
    MODEL_DISPLAY: 'Elan',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'LOTUS',
    MAKE_DISPLAY: 'Lotus',
    MODEL_CODE: 'LOTELISE',
    MODEL_DISPLAY: 'Elise',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'LOTUS',
    MAKE_DISPLAY: 'Lotus',
    MODEL_CODE: 'EXIGE',
    MODEL_DISPLAY: 'Exige',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'LOTUS',
    MAKE_DISPLAY: 'Lotus',
    MODEL_CODE: 'LOTOTH',
    MODEL_DISPLAY: 'Other Lotus Models',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'LOTUS',
    MAKE_DISPLAY: 'Lotus',
    MODEL_CODE: 'EVORA',
    MODEL_DISPLAY: 'Evora',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MAS',
    MAKE_DISPLAY: 'Maserati',
    MODEL_CODE: 'BITRBO',
    MODEL_DISPLAY: 'Biturbo',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MAS',
    MAKE_DISPLAY: 'Maserati',
    MODEL_CODE: 'QP',
    MODEL_DISPLAY: 'Quattroporte',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MAS',
    MAKE_DISPLAY: 'Maserati',
    MODEL_CODE: '430',
    MODEL_DISPLAY: '430',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MAS',
    MAKE_DISPLAY: 'Maserati',
    MODEL_CODE: 'COUPEMAS',
    MODEL_DISPLAY: 'Coupe',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MAS',
    MAKE_DISPLAY: 'Maserati',
    MODEL_CODE: 'SPYDER',
    MODEL_DISPLAY: 'Spyder',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MAS',
    MAKE_DISPLAY: 'Maserati',
    MODEL_CODE: 'GRANSPORT',
    MODEL_DISPLAY: 'GranSport',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MAS',
    MAKE_DISPLAY: 'Maserati',
    MODEL_CODE: 'GHIB',
    MODEL_DISPLAY: 'Ghibli',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MAS',
    MAKE_DISPLAY: 'Maserati',
    MODEL_CODE: 'MASOTH',
    MODEL_DISPLAY: 'Other Maserati Models',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MAS',
    MAKE_DISPLAY: 'Maserati',
    MODEL_CODE: 'MASLEVAN',
    MODEL_DISPLAY: 'Levante',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MAS',
    MAKE_DISPLAY: 'Maserati',
    MODEL_CODE: 'GRANTURISM',
    MODEL_DISPLAY: 'GranTurismo',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MAYBACH',
    MAKE_DISPLAY: 'Maybach',
    MODEL_CODE: '57MAYBACH',
    MODEL_DISPLAY: '57',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MAYBACH',
    MAKE_DISPLAY: 'Maybach',
    MODEL_CODE: '62MAYBACH',
    MODEL_DISPLAY: '62',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MAYBACH',
    MAKE_DISPLAY: 'Maybach',
    MODEL_CODE: 'MAYOTH',
    MODEL_DISPLAY: 'Other Maybach Models',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MAZDA',
    MAKE_DISPLAY: 'MAZDA',
    MODEL_CODE: 'GLC',
    MODEL_DISPLAY: 'GLC',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MAZDA',
    MAKE_DISPLAY: 'MAZDA',
    MODEL_CODE: 'MAZDA323',
    MODEL_DISPLAY: '323',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MAZDA',
    MAKE_DISPLAY: 'MAZDA',
    MODEL_CODE: 'MAZDA626',
    MODEL_DISPLAY: '626',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MAZDA',
    MAKE_DISPLAY: 'MAZDA',
    MODEL_CODE: 'MIATA',
    MODEL_DISPLAY: 'MX-5 Miata',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MAZDA',
    MAKE_DISPLAY: 'MAZDA',
    MODEL_CODE: 'MILL',
    MODEL_DISPLAY: 'Millenia',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MAZDA',
    MAKE_DISPLAY: 'MAZDA',
    MODEL_CODE: 'MPV',
    MODEL_DISPLAY: 'MPV',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MAZDA',
    MAKE_DISPLAY: 'MAZDA',
    MODEL_CODE: 'MX3',
    MODEL_DISPLAY: 'MX3',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MAZDA',
    MAKE_DISPLAY: 'MAZDA',
    MODEL_CODE: 'MX6',
    MODEL_DISPLAY: 'MX6',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MAZDA',
    MAKE_DISPLAY: 'MAZDA',
    MODEL_CODE: 'NAVAJO',
    MODEL_DISPLAY: 'Navajo',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MAZDA',
    MAKE_DISPLAY: 'MAZDA',
    MODEL_CODE: 'PROTE5',
    MODEL_DISPLAY: 'Protege5',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MAZDA',
    MAKE_DISPLAY: 'MAZDA',
    MODEL_CODE: 'MAZDA6',
    MODEL_DISPLAY: 'MAZDA6',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MAZDA',
    MAKE_DISPLAY: 'MAZDA',
    MODEL_CODE: 'RX8',
    MODEL_DISPLAY: 'RX-8',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MAZDA',
    MAKE_DISPLAY: 'MAZDA',
    MODEL_CODE: 'MAZDA3',
    MODEL_DISPLAY: 'MAZDA3',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MAZDA',
    MAKE_DISPLAY: 'MAZDA',
    MODEL_CODE: 'MAZDA5',
    MODEL_DISPLAY: 'MAZDA5',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MAZDA',
    MAKE_DISPLAY: 'MAZDA',
    MODEL_CODE: 'RX7',
    MODEL_DISPLAY: 'RX-7',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MAZDA',
    MAKE_DISPLAY: 'MAZDA',
    MODEL_CODE: 'CX-7',
    MODEL_DISPLAY: 'CX-7',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MAZDA',
    MAKE_DISPLAY: 'MAZDA',
    MODEL_CODE: 'B-SERIES',
    MODEL_DISPLAY: 'B-Series Pickup',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MAZDA',
    MAKE_DISPLAY: 'MAZDA',
    MODEL_CODE: '929',
    MODEL_DISPLAY: '929',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MAZDA',
    MAKE_DISPLAY: 'MAZDA',
    MODEL_CODE: 'PROTE',
    MODEL_DISPLAY: 'Protege',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MAZDA',
    MAKE_DISPLAY: 'MAZDA',
    MODEL_CODE: 'MAZOTH',
    MODEL_DISPLAY: 'Other Mazda Models',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MAZDA',
    MAKE_DISPLAY: 'MAZDA',
    MODEL_CODE: 'CX-9',
    MODEL_DISPLAY: 'CX-9',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MAZDA',
    MAKE_DISPLAY: 'MAZDA',
    MODEL_CODE: 'MAZDA2',
    MODEL_DISPLAY: 'MAZDA2',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MAZDA',
    MAKE_DISPLAY: 'MAZDA',
    MODEL_CODE: 'TRIBUTE',
    MODEL_DISPLAY: 'Tribute',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MAZDA',
    MAKE_DISPLAY: 'MAZDA',
    MODEL_CODE: 'MAZDASPD6',
    MODEL_DISPLAY: 'MAZDASPEED6',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MAZDA',
    MAKE_DISPLAY: 'MAZDA',
    MODEL_CODE: 'MAZDASPD3',
    MODEL_DISPLAY: 'MAZDASPEED3',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MAZDA',
    MAKE_DISPLAY: 'MAZDA',
    MODEL_CODE: 'CX-5',
    MODEL_DISPLAY: 'CX-5',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MAZDA',
    MAKE_DISPLAY: 'MAZDA',
    MODEL_CODE: 'MAZMIATARF',
    MODEL_DISPLAY: 'MX-5 Miata RF',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MAZDA',
    MAKE_DISPLAY: 'MAZDA',
    MODEL_CODE: 'MAZCX3',
    MODEL_DISPLAY: 'CX-3',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'MBGLS350D',
    MODEL_DISPLAY: 'GLS 350d',
    CLASS_SERIES_CODE: 'GLS_CLASS',
    CLASS_SERIES_DISPLAY: 'GLS-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'MBGLS450',
    MODEL_DISPLAY: 'GLS 450',
    CLASS_SERIES_CODE: 'GLS_CLASS',
    CLASS_SERIES_DISPLAY: 'GLS-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'MBGLS550',
    MODEL_DISPLAY: 'GLS 550',
    CLASS_SERIES_CODE: 'GLS_CLASS',
    CLASS_SERIES_DISPLAY: 'GLS-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'MBS550E',
    MODEL_DISPLAY: 'S 550e',
    CLASS_SERIES_CODE: 'S_CLASS',
    CLASS_SERIES_DISPLAY: 'S-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: '280CE',
    MODEL_DISPLAY: '280 CE',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'CL65AMG',
    MODEL_DISPLAY: 'CL 65 AMG',
    CLASS_SERIES_CODE: 'CL_CLASS',
    CLASS_SERIES_DISPLAY: 'CL-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'SLK350',
    MODEL_DISPLAY: 'SLK 350',
    CLASS_SERIES_CODE: 'SLK_CLASS',
    CLASS_SERIES_DISPLAY: 'SLK-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'SLK55AMG',
    MODEL_DISPLAY: 'SLK 55 AMG',
    CLASS_SERIES_CODE: 'SLK_CLASS',
    CLASS_SERIES_DISPLAY: 'SLK-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'SLR',
    MODEL_DISPLAY: 'SLR',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: '240D',
    MODEL_DISPLAY: '240 D',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: '260E',
    MODEL_DISPLAY: '260 E',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'CLK500',
    MODEL_DISPLAY: 'CLK 500',
    CLASS_SERIES_CODE: 'CLK_CLASS',
    CLASS_SERIES_DISPLAY: 'CLK-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'G55AMG',
    MODEL_DISPLAY: 'G 55 AMG',
    CLASS_SERIES_CODE: 'G_CLASS',
    CLASS_SERIES_DISPLAY: 'G-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'ML350',
    MODEL_DISPLAY: 'ML 350',
    CLASS_SERIES_CODE: 'M_CLASS',
    CLASS_SERIES_DISPLAY: 'M-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'C220',
    MODEL_DISPLAY: 'C 220',
    CLASS_SERIES_CODE: 'C_CLASS',
    CLASS_SERIES_DISPLAY: 'C-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'C230',
    MODEL_DISPLAY: 'C 230',
    CLASS_SERIES_CODE: 'C_CLASS',
    CLASS_SERIES_DISPLAY: 'C-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'C280',
    MODEL_DISPLAY: 'C 280',
    CLASS_SERIES_CODE: 'C_CLASS',
    CLASS_SERIES_DISPLAY: 'C-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'E320',
    MODEL_DISPLAY: 'E 320',
    CLASS_SERIES_CODE: 'E_CLASS',
    CLASS_SERIES_DISPLAY: 'E-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'E420',
    MODEL_DISPLAY: 'E 420',
    CLASS_SERIES_CODE: 'E_CLASS',
    CLASS_SERIES_DISPLAY: 'E-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'E430',
    MODEL_DISPLAY: 'E 430',
    CLASS_SERIES_CODE: 'E_CLASS',
    CLASS_SERIES_DISPLAY: 'E-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'E500',
    MODEL_DISPLAY: 'E 500',
    CLASS_SERIES_CODE: 'E_CLASS',
    CLASS_SERIES_DISPLAY: 'E-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'ML320',
    MODEL_DISPLAY: 'ML 320',
    CLASS_SERIES_CODE: 'M_CLASS',
    CLASS_SERIES_DISPLAY: 'M-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'S420',
    MODEL_DISPLAY: 'S 420',
    CLASS_SERIES_CODE: 'S_CLASS',
    CLASS_SERIES_DISPLAY: 'S-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'S500',
    MODEL_DISPLAY: 'S 500',
    CLASS_SERIES_CODE: 'S_CLASS',
    CLASS_SERIES_DISPLAY: 'S-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'SL320',
    MODEL_DISPLAY: 'SL 320',
    CLASS_SERIES_CODE: 'SL_CLASS',
    CLASS_SERIES_DISPLAY: 'SL-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'SL600',
    MODEL_DISPLAY: 'SL 600',
    CLASS_SERIES_CODE: 'SL_CLASS',
    CLASS_SERIES_DISPLAY: 'SL-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'C55AMG',
    MODEL_DISPLAY: 'C 55 AMG',
    CLASS_SERIES_CODE: 'C_CLASS',
    CLASS_SERIES_DISPLAY: 'C-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'SL65AMG',
    MODEL_DISPLAY: 'SL 65 AMG',
    CLASS_SERIES_CODE: 'SL_CLASS',
    CLASS_SERIES_DISPLAY: 'SL-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: '280E',
    MODEL_DISPLAY: '280 E',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'MBC400',
    MODEL_DISPLAY: 'C 400',
    CLASS_SERIES_CODE: 'C_CLASS',
    CLASS_SERIES_DISPLAY: 'C-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: '380SLC',
    MODEL_DISPLAY: '380 SLC',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'CLS500',
    MODEL_DISPLAY: 'CLS 500',
    CLASS_SERIES_CODE: 'CLS_CLASS',
    CLASS_SERIES_DISPLAY: 'CLS-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'CLS55AMG',
    MODEL_DISPLAY: 'CLS 55 AMG',
    CLASS_SERIES_CODE: 'CLS_CLASS',
    CLASS_SERIES_DISPLAY: 'CLS-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'E350',
    MODEL_DISPLAY: 'E 350',
    CLASS_SERIES_CODE: 'E_CLASS',
    CLASS_SERIES_DISPLAY: 'E-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'CLK350',
    MODEL_DISPLAY: 'CLK 350',
    CLASS_SERIES_CODE: 'CLK_CLASS',
    CLASS_SERIES_DISPLAY: 'CLK-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'C350',
    MODEL_DISPLAY: 'C 350',
    CLASS_SERIES_CODE: 'C_CLASS',
    CLASS_SERIES_DISPLAY: 'C-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'R350',
    MODEL_DISPLAY: 'R 350',
    CLASS_SERIES_CODE: 'R_CLASS',
    CLASS_SERIES_DISPLAY: 'R-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'S600',
    MODEL_DISPLAY: 'S 600',
    CLASS_SERIES_CODE: 'S_CLASS',
    CLASS_SERIES_DISPLAY: 'S-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'SL500',
    MODEL_DISPLAY: 'SL 500',
    CLASS_SERIES_CODE: 'SL_CLASS',
    CLASS_SERIES_DISPLAY: 'SL-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'GL450',
    MODEL_DISPLAY: 'GL 450',
    CLASS_SERIES_CODE: 'GL_CLASS',
    CLASS_SERIES_DISPLAY: 'GL-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'ML63AMG',
    MODEL_DISPLAY: 'ML 63 AMG',
    CLASS_SERIES_CODE: 'M_CLASS',
    CLASS_SERIES_DISPLAY: 'M-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'CLS550',
    MODEL_DISPLAY: 'CLS 550',
    CLASS_SERIES_CODE: 'CLS_CLASS',
    CLASS_SERIES_DISPLAY: 'CLS-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'CLS63AMG',
    MODEL_DISPLAY: 'CLS 63 AMG',
    CLASS_SERIES_CODE: 'CLS_CLASS',
    CLASS_SERIES_DISPLAY: 'CLS-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'CLK550',
    MODEL_DISPLAY: 'CLK 550',
    CLASS_SERIES_CODE: 'CLK_CLASS',
    CLASS_SERIES_DISPLAY: 'CLK-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'CLK63AMG',
    MODEL_DISPLAY: 'CLK 63 AMG',
    CLASS_SERIES_CODE: 'CLK_CLASS',
    CLASS_SERIES_DISPLAY: 'CLK-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'R63AMG',
    MODEL_DISPLAY: 'R 63 AMG',
    CLASS_SERIES_CODE: 'R_CLASS',
    CLASS_SERIES_DISPLAY: 'R-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'E63AMG',
    MODEL_DISPLAY: 'E 63 AMG',
    CLASS_SERIES_CODE: 'E_CLASS',
    CLASS_SERIES_DISPLAY: 'E-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'E550',
    MODEL_DISPLAY: 'E 550',
    CLASS_SERIES_CODE: 'E_CLASS',
    CLASS_SERIES_DISPLAY: 'E-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'CL500',
    MODEL_DISPLAY: 'CL 500',
    CLASS_SERIES_CODE: 'CL_CLASS',
    CLASS_SERIES_DISPLAY: 'CL-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'CL600',
    MODEL_DISPLAY: 'CL 600',
    CLASS_SERIES_CODE: 'CL_CLASS',
    CLASS_SERIES_DISPLAY: 'CL-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'CLK320',
    MODEL_DISPLAY: 'CLK 320',
    CLASS_SERIES_CODE: 'CLK_CLASS',
    CLASS_SERIES_DISPLAY: 'CLK-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'C32AMG',
    MODEL_DISPLAY: 'C 32 AMG',
    CLASS_SERIES_CODE: 'C_CLASS',
    CLASS_SERIES_DISPLAY: 'C-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'ML430',
    MODEL_DISPLAY: 'ML 430',
    CLASS_SERIES_CODE: 'M_CLASS',
    CLASS_SERIES_DISPLAY: 'M-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: '300CE',
    MODEL_DISPLAY: '300 CE',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: '300SD',
    MODEL_DISPLAY: '300 SD',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: '300SE',
    MODEL_DISPLAY: '300 SE',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: '300TD',
    MODEL_DISPLAY: '300 TD',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: '350SD',
    MODEL_DISPLAY: '350 SD',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: '380SE',
    MODEL_DISPLAY: '380 SE',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: '380SEC',
    MODEL_DISPLAY: '380 SEC',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: '380SL',
    MODEL_DISPLAY: '380 SL',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: '400E',
    MODEL_DISPLAY: '400 E',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: '400SE',
    MODEL_DISPLAY: '400 SE',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: '420SEL',
    MODEL_DISPLAY: '420 SEL',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: '500E',
    MODEL_DISPLAY: '500 E',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: '500SEL',
    MODEL_DISPLAY: '500 SEL',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: '560SEC',
    MODEL_DISPLAY: '560 SEC',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: '600SEC',
    MODEL_DISPLAY: '600 SEC',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: '600SL',
    MODEL_DISPLAY: '600 SL',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'MBE250BLUE',
    MODEL_DISPLAY: 'E 250',
    CLASS_SERIES_CODE: 'E_CLASS',
    CLASS_SERIES_DISPLAY: 'E-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'S430',
    MODEL_DISPLAY: 'S 430',
    CLASS_SERIES_CODE: 'S_CLASS',
    CLASS_SERIES_DISPLAY: 'S-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'MBOTH',
    MODEL_DISPLAY: 'Other Mercedes-Benz Models',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'CL550',
    MODEL_DISPLAY: 'CL 550',
    CLASS_SERIES_CODE: 'CL_CLASS',
    CLASS_SERIES_DISPLAY: 'CL-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'MBGLA250',
    MODEL_DISPLAY: 'GLA 250',
    CLASS_SERIES_CODE: 'GLA_CLASS',
    CLASS_SERIES_DISPLAY: 'GLA-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: '190D',
    MODEL_DISPLAY: '190 D',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'SLSAMG',
    MODEL_DISPLAY: 'SLS AMG',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: '190E',
    MODEL_DISPLAY: '190 E',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'SLK230',
    MODEL_DISPLAY: 'SLK 230',
    CLASS_SERIES_CODE: 'SLK_CLASS',
    CLASS_SERIES_DISPLAY: 'SLK-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'SLK320',
    MODEL_DISPLAY: 'SLK 320',
    CLASS_SERIES_CODE: 'SLK_CLASS',
    CLASS_SERIES_DISPLAY: 'SLK-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'C320',
    MODEL_DISPLAY: 'C 320',
    CLASS_SERIES_CODE: 'C_CLASS',
    CLASS_SERIES_DISPLAY: 'C-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'C240',
    MODEL_DISPLAY: 'C 240',
    CLASS_SERIES_CODE: 'C_CLASS',
    CLASS_SERIES_DISPLAY: 'C-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'MBGLA45AMG',
    MODEL_DISPLAY: 'GLA 45 AMG',
    CLASS_SERIES_CODE: 'GLA_CLASS',
    CLASS_SERIES_DISPLAY: 'GLA-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'MBML250BLU',
    MODEL_DISPLAY: 'ML 250',
    CLASS_SERIES_CODE: 'M_CLASS',
    CLASS_SERIES_DISPLAY: 'M-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'MBML400',
    MODEL_DISPLAY: 'ML 400',
    CLASS_SERIES_CODE: 'M_CLASS',
    CLASS_SERIES_DISPLAY: 'M-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'MBSL400',
    MODEL_DISPLAY: 'SL 400',
    CLASS_SERIES_CODE: 'SL_CLASS',
    CLASS_SERIES_DISPLAY: 'SL-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'G500',
    MODEL_DISPLAY: 'G 500',
    CLASS_SERIES_CODE: 'G_CLASS',
    CLASS_SERIES_DISPLAY: 'G-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'SL63AMG',
    MODEL_DISPLAY: 'SL 63 AMG',
    CLASS_SERIES_CODE: 'SL_CLASS',
    CLASS_SERIES_DISPLAY: 'SL-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'MBCLS400',
    MODEL_DISPLAY: 'CLS 400',
    CLASS_SERIES_CODE: 'CLS_CLASS',
    CLASS_SERIES_DISPLAY: 'CLS-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'MBAMGGT',
    MODEL_DISPLAY: 'AMG GT',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'MBMAYS600',
    MODEL_DISPLAY: 'Maybach S 600',
    CLASS_SERIES_CODE: 'S_CLASS',
    CLASS_SERIES_DISPLAY: 'S-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'MBGLS63AMG',
    MODEL_DISPLAY: 'GLS 63 AMG',
    CLASS_SERIES_CODE: 'GLS_CLASS',
    CLASS_SERIES_DISPLAY: 'GLS-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'S63AMG',
    MODEL_DISPLAY: 'S 63 AMG',
    CLASS_SERIES_CODE: 'S_CLASS',
    CLASS_SERIES_DISPLAY: 'S-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'CL63AMG',
    MODEL_DISPLAY: 'CL 63 AMG',
    CLASS_SERIES_CODE: 'CL_CLASS',
    CLASS_SERIES_DISPLAY: 'CL-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'G550',
    MODEL_DISPLAY: 'G 550',
    CLASS_SERIES_CODE: 'G_CLASS',
    CLASS_SERIES_DISPLAY: 'G-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'MBCLA250',
    MODEL_DISPLAY: 'CLA 250',
    CLASS_SERIES_CODE: 'CLA_CLASS',
    CLASS_SERIES_DISPLAY: 'CLA-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'MBCLA45AMG',
    MODEL_DISPLAY: 'CLA 45 AMG',
    CLASS_SERIES_CODE: 'CLA_CLASS',
    CLASS_SERIES_DISPLAY: 'CLA-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'MBB250E',
    MODEL_DISPLAY: 'B 250e',
    CLASS_SERIES_CODE: 'B_CLASS',
    CLASS_SERIES_DISPLAY: 'B-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'MBGLC43AMG',
    MODEL_DISPLAY: 'GLC 43 AMG',
    CLASS_SERIES_CODE: 'GLC_CLASS',
    CLASS_SERIES_DISPLAY: 'GLC-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'MBS450',
    MODEL_DISPLAY: 'S 450',
    CLASS_SERIES_CODE: 'S_CLASS',
    CLASS_SERIES_DISPLAY: 'S-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'MBMAYS560',
    MODEL_DISPLAY: 'Maybach S 560',
    CLASS_SERIES_CODE: 'S_CLASS',
    CLASS_SERIES_DISPLAY: 'S-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'MBS560',
    MODEL_DISPLAY: 'S 560',
    CLASS_SERIES_CODE: 'S_CLASS',
    CLASS_SERIES_DISPLAY: 'S-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'MBGLC350E',
    MODEL_DISPLAY: 'GLC 350e',
    CLASS_SERIES_CODE: 'GLC_CLASS',
    CLASS_SERIES_DISPLAY: 'GLC-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'MBGLC63AMG',
    MODEL_DISPLAY: 'GLC 63 AMG',
    CLASS_SERIES_CODE: 'GLC_CLASS',
    CLASS_SERIES_DISPLAY: 'GLC-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'MBCLS450',
    MODEL_DISPLAY: 'CLS 450',
    CLASS_SERIES_CODE: 'CLS_CLASS',
    CLASS_SERIES_DISPLAY: 'CLS-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'MBCLS53AMG',
    MODEL_DISPLAY: 'CLS 53 AMG',
    CLASS_SERIES_CODE: 'CLS_CLASS',
    CLASS_SERIES_DISPLAY: 'CLS-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'MBE53AMG',
    MODEL_DISPLAY: 'E 53 AMG',
    CLASS_SERIES_CODE: 'E_CLASS',
    CLASS_SERIES_DISPLAY: 'E-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'GL63AMG',
    MODEL_DISPLAY: 'GL 63 AMG',
    CLASS_SERIES_CODE: 'GL_CLASS',
    CLASS_SERIES_DISPLAY: 'GL-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'GLK250BLUE',
    MODEL_DISPLAY: 'GLK 250',
    CLASS_SERIES_CODE: 'GLK_CLASS',
    CLASS_SERIES_DISPLAY: 'GLK-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'MBMAYS650',
    MODEL_DISPLAY: 'Maybach S 650',
    CLASS_SERIES_CODE: 'S_CLASS',
    CLASS_SERIES_DISPLAY: 'S-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'C300',
    MODEL_DISPLAY: 'C 300',
    CLASS_SERIES_CODE: 'C_CLASS',
    CLASS_SERIES_DISPLAY: 'C-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'GL550',
    MODEL_DISPLAY: 'GL 550',
    CLASS_SERIES_CODE: 'GL_CLASS',
    CLASS_SERIES_DISPLAY: 'GL-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'ML550',
    MODEL_DISPLAY: 'ML 550',
    CLASS_SERIES_CODE: 'M_CLASS',
    CLASS_SERIES_DISPLAY: 'M-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'C250',
    MODEL_DISPLAY: 'C 250',
    CLASS_SERIES_CODE: 'C_CLASS',
    CLASS_SERIES_DISPLAY: 'C-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'SLK250',
    MODEL_DISPLAY: 'SLK 250',
    CLASS_SERIES_CODE: 'SLK_CLASS',
    CLASS_SERIES_DISPLAY: 'SLK-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: '300CD',
    MODEL_DISPLAY: '300 CD',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: '300D',
    MODEL_DISPLAY: '300 D',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: '300E',
    MODEL_DISPLAY: '300 E',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: '300TE',
    MODEL_DISPLAY: '300 TE',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'CLK430',
    MODEL_DISPLAY: 'CLK 430',
    CLASS_SERIES_CODE: 'CLK_CLASS',
    CLASS_SERIES_DISPLAY: 'CLK-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'ML500',
    MODEL_DISPLAY: 'ML 500',
    CLASS_SERIES_CODE: 'M_CLASS',
    CLASS_SERIES_DISPLAY: 'M-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'R500',
    MODEL_DISPLAY: 'R 500',
    CLASS_SERIES_CODE: 'R_CLASS',
    CLASS_SERIES_DISPLAY: 'R-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: '300SDL',
    MODEL_DISPLAY: '300 SDL',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: '300SEL',
    MODEL_DISPLAY: '300 SEL',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: '350SDL',
    MODEL_DISPLAY: '350 SDL',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: '380SEL',
    MODEL_DISPLAY: '380 SEL',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: '400SEL',
    MODEL_DISPLAY: '400 SEL',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: '500SEC',
    MODEL_DISPLAY: '500 SEC',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: '500SL',
    MODEL_DISPLAY: '500 SL',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: '560SEL',
    MODEL_DISPLAY: '560 SEL',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: '600SEL',
    MODEL_DISPLAY: '600 SEL',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'S320',
    MODEL_DISPLAY: 'S 320',
    CLASS_SERIES_CODE: 'S_CLASS',
    CLASS_SERIES_DISPLAY: 'S-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'S350',
    MODEL_DISPLAY: 'S 350',
    CLASS_SERIES_CODE: 'S_CLASS',
    CLASS_SERIES_DISPLAY: 'S-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'S550',
    MODEL_DISPLAY: 'S 550',
    CLASS_SERIES_CODE: 'S_CLASS',
    CLASS_SERIES_DISPLAY: 'S-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'S65AMG',
    MODEL_DISPLAY: 'S 65 AMG',
    CLASS_SERIES_CODE: 'S_CLASS',
    CLASS_SERIES_DISPLAY: 'S-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: '300SL',
    MODEL_DISPLAY: '300 SL',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: '560SL',
    MODEL_DISPLAY: '560 SL',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'SL550',
    MODEL_DISPLAY: 'SL 550',
    CLASS_SERIES_CODE: 'SL_CLASS',
    CLASS_SERIES_DISPLAY: 'SL-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'SL55AMG',
    MODEL_DISPLAY: 'SL 55 AMG',
    CLASS_SERIES_CODE: 'SL_CLASS',
    CLASS_SERIES_DISPLAY: 'SL-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'SLK280',
    MODEL_DISPLAY: 'SLK 280',
    CLASS_SERIES_CODE: 'SLK_CLASS',
    CLASS_SERIES_DISPLAY: 'SLK-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'SLK32AMG',
    MODEL_DISPLAY: 'SLK 32 AMG',
    CLASS_SERIES_CODE: 'SLK_CLASS',
    CLASS_SERIES_DISPLAY: 'SLK-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'SLK300',
    MODEL_DISPLAY: 'SLK 300',
    CLASS_SERIES_CODE: 'SLK_CLASS',
    CLASS_SERIES_DISPLAY: 'SLK-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'MBE450',
    MODEL_DISPLAY: 'E 450',
    CLASS_SERIES_CODE: 'E_CLASS',
    CLASS_SERIES_DISPLAY: 'E-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'MBE43AMG',
    MODEL_DISPLAY: 'E 43 AMG',
    CLASS_SERIES_CODE: 'E_CLASS',
    CLASS_SERIES_DISPLAY: 'E-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'GLK350',
    MODEL_DISPLAY: 'GLK 350',
    CLASS_SERIES_CODE: 'GLK_CLASS',
    CLASS_SERIES_DISPLAY: 'GLK-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'S400HY',
    MODEL_DISPLAY: 'S 400',
    CLASS_SERIES_CODE: 'S_CLASS',
    CLASS_SERIES_DISPLAY: 'S-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'GL350BLUE',
    MODEL_DISPLAY: 'GL 350',
    CLASS_SERIES_CODE: 'GL_CLASS',
    CLASS_SERIES_DISPLAY: 'GL-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'ML450HY',
    MODEL_DISPLAY: 'ML 450',
    CLASS_SERIES_CODE: 'M_CLASS',
    CLASS_SERIES_DISPLAY: 'M-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'C36AMG',
    MODEL_DISPLAY: 'C 36 AMG',
    CLASS_SERIES_CODE: 'C_CLASS',
    CLASS_SERIES_DISPLAY: 'C-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'C43AMG',
    MODEL_DISPLAY: 'C 43 AMG',
    CLASS_SERIES_CODE: 'C_CLASS',
    CLASS_SERIES_DISPLAY: 'C-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'CL55AMG',
    MODEL_DISPLAY: 'CL 55 AMG',
    CLASS_SERIES_CODE: 'CL_CLASS',
    CLASS_SERIES_DISPLAY: 'CL-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'CLK55AMG',
    MODEL_DISPLAY: 'CLK 55 AMG',
    CLASS_SERIES_CODE: 'CLK_CLASS',
    CLASS_SERIES_DISPLAY: 'CLK-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'E55AMG',
    MODEL_DISPLAY: 'E 55 AMG',
    CLASS_SERIES_CODE: 'E_CLASS',
    CLASS_SERIES_DISPLAY: 'E-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'ML55AMG',
    MODEL_DISPLAY: 'ML 55 AMG',
    CLASS_SERIES_CODE: 'M_CLASS',
    CLASS_SERIES_DISPLAY: 'M-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'S55AMG',
    MODEL_DISPLAY: 'S 55 AMG',
    CLASS_SERIES_CODE: 'S_CLASS',
    CLASS_SERIES_DISPLAY: 'S-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'E300',
    MODEL_DISPLAY: 'E 300',
    CLASS_SERIES_CODE: 'E_CLASS',
    CLASS_SERIES_DISPLAY: 'E-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'MBC450',
    MODEL_DISPLAY: 'C 450',
    CLASS_SERIES_CODE: 'C_CLASS',
    CLASS_SERIES_DISPLAY: 'C-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'MBMETRIS',
    MODEL_DISPLAY: 'Metris',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'MBGLC300',
    MODEL_DISPLAY: 'GLC 300',
    CLASS_SERIES_CODE: 'GLC_CLASS',
    CLASS_SERIES_DISPLAY: 'GLC-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'MBGLE300D',
    MODEL_DISPLAY: 'GLE 300d',
    CLASS_SERIES_CODE: 'GLE_CLASS',
    CLASS_SERIES_DISPLAY: 'GLE-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'MBSPRINTER',
    MODEL_DISPLAY: 'Sprinter',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'MBGLE350',
    MODEL_DISPLAY: 'GLE 350',
    CLASS_SERIES_CODE: 'GLE_CLASS',
    CLASS_SERIES_DISPLAY: 'GLE-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'MBBCLASSED',
    MODEL_DISPLAY: 'B-Class Electric Drive',
    CLASS_SERIES_CODE: 'B_CLASS',
    CLASS_SERIES_DISPLAY: 'B-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'MBGLE400',
    MODEL_DISPLAY: 'GLE 400',
    CLASS_SERIES_CODE: 'GLE_CLASS',
    CLASS_SERIES_DISPLAY: 'GLE-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'MBGLE450',
    MODEL_DISPLAY: 'GLE 450',
    CLASS_SERIES_CODE: 'GLE_CLASS',
    CLASS_SERIES_DISPLAY: 'GLE-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'MBGLE63AMG',
    MODEL_DISPLAY: 'GLE 63 AMG',
    CLASS_SERIES_CODE: 'GLE_CLASS',
    CLASS_SERIES_DISPLAY: 'GLE-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'MBGLE550E',
    MODEL_DISPLAY: 'GLE 550e',
    CLASS_SERIES_CODE: 'GLE_CLASS',
    CLASS_SERIES_DISPLAY: 'GLE-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'MBC350E',
    MODEL_DISPLAY: 'C 350e',
    CLASS_SERIES_CODE: 'C_CLASS',
    CLASS_SERIES_DISPLAY: 'C-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'MBSLC300',
    MODEL_DISPLAY: 'SLC 300',
    CLASS_SERIES_CODE: 'SLC_CLASS',
    CLASS_SERIES_DISPLAY: 'SLC-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'MBSL450',
    MODEL_DISPLAY: 'SL 450',
    CLASS_SERIES_CODE: 'SL_CLASS',
    CLASS_SERIES_DISPLAY: 'SL-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'MBSLC43AMG',
    MODEL_DISPLAY: 'SLC 43 AMG',
    CLASS_SERIES_CODE: 'SLC_CLASS',
    CLASS_SERIES_DISPLAY: 'SLC-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'MBMAYS550',
    MODEL_DISPLAY: 'Maybach S 550',
    CLASS_SERIES_CODE: 'S_CLASS',
    CLASS_SERIES_DISPLAY: 'S-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'MBGLE43AMG',
    MODEL_DISPLAY: 'GLE 43 AMG',
    CLASS_SERIES_CODE: 'GLE_CLASS',
    CLASS_SERIES_DISPLAY: 'GLE-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'C63AMG',
    MODEL_DISPLAY: 'C 63 AMG',
    CLASS_SERIES_CODE: 'C_CLASS',
    CLASS_SERIES_DISPLAY: 'C-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'GL320BLUE',
    MODEL_DISPLAY: 'GL 320',
    CLASS_SERIES_CODE: 'GL_CLASS',
    CLASS_SERIES_DISPLAY: 'GL-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'MBG65AMG',
    MODEL_DISPLAY: 'G 65 AMG',
    CLASS_SERIES_CODE: 'G_CLASS',
    CLASS_SERIES_DISPLAY: 'G-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'R320BLUE',
    MODEL_DISPLAY: 'R 320',
    CLASS_SERIES_CODE: 'R_CLASS',
    CLASS_SERIES_DISPLAY: 'R-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'G63AMG',
    MODEL_DISPLAY: 'G 63 AMG',
    CLASS_SERIES_CODE: 'G_CLASS',
    CLASS_SERIES_DISPLAY: 'G-Class',
  },
  {
    MAKE_CODE: 'MB',
    MAKE_DISPLAY: 'Mercedes-Benz',
    MODEL_CODE: 'MBE400',
    MODEL_DISPLAY: 'E 400',
    CLASS_SERIES_CODE: 'E_CLASS',
    CLASS_SERIES_DISPLAY: 'E-Class',
  },
  {
    MAKE_CODE: 'MCLAREN',
    MAKE_DISPLAY: 'McLaren',
    MODEL_CODE: 'MCL720S',
    MODEL_DISPLAY: '720S',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MCLAREN',
    MAKE_DISPLAY: 'McLaren',
    MODEL_CODE: 'MCL570GT',
    MODEL_DISPLAY: '570GT',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MCLAREN',
    MAKE_DISPLAY: 'McLaren',
    MODEL_CODE: 'MCL650S',
    MODEL_DISPLAY: '650S',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MCLAREN',
    MAKE_DISPLAY: 'McLaren',
    MODEL_CODE: 'MP4',
    MODEL_DISPLAY: 'MP4-12C',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MCLAREN',
    MAKE_DISPLAY: 'McLaren',
    MODEL_CODE: 'MCL570S',
    MODEL_DISPLAY: '570S',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MCLAREN',
    MAKE_DISPLAY: 'McLaren',
    MODEL_CODE: 'MCLP1',
    MODEL_DISPLAY: 'P1',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MCLAREN',
    MAKE_DISPLAY: 'McLaren',
    MODEL_CODE: 'MCL675LT',
    MODEL_DISPLAY: '675LT',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MERC',
    MAKE_DISPLAY: 'Mercury',
    MODEL_CODE: 'LN7',
    MODEL_DISPLAY: 'LN7',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MERC',
    MAKE_DISPLAY: 'Mercury',
    MODEL_CODE: 'MARAUDER',
    MODEL_DISPLAY: 'Marauder',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MERC',
    MAKE_DISPLAY: 'Mercury',
    MODEL_CODE: 'MONTEREY',
    MODEL_DISPLAY: 'Monterey',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MERC',
    MAKE_DISPLAY: 'Mercury',
    MODEL_CODE: 'CAPRI',
    MODEL_DISPLAY: 'Capri',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MERC',
    MAKE_DISPLAY: 'Mercury',
    MODEL_CODE: 'COUGAR',
    MODEL_DISPLAY: 'Cougar',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MERC',
    MAKE_DISPLAY: 'Mercury',
    MODEL_CODE: 'LYNX',
    MODEL_DISPLAY: 'Lynx',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MERC',
    MAKE_DISPLAY: 'Mercury',
    MODEL_CODE: 'MARINER',
    MODEL_DISPLAY: 'Mariner',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MERC',
    MAKE_DISPLAY: 'Mercury',
    MODEL_CODE: 'MONTEGO',
    MODEL_DISPLAY: 'Montego',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MERC',
    MAKE_DISPLAY: 'Mercury',
    MODEL_CODE: 'MOUNTA',
    MODEL_DISPLAY: 'Mountaineer',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MERC',
    MAKE_DISPLAY: 'Mercury',
    MODEL_CODE: 'SABLE',
    MODEL_DISPLAY: 'Sable',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MERC',
    MAKE_DISPLAY: 'Mercury',
    MODEL_CODE: 'TOPAZ',
    MODEL_DISPLAY: 'Topaz',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MERC',
    MAKE_DISPLAY: 'Mercury',
    MODEL_CODE: 'TRACER',
    MODEL_DISPLAY: 'Tracer',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MERC',
    MAKE_DISPLAY: 'Mercury',
    MODEL_CODE: 'MILAN',
    MODEL_DISPLAY: 'Milan',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MERC',
    MAKE_DISPLAY: 'Mercury',
    MODEL_CODE: 'MARQ',
    MODEL_DISPLAY: 'Marquis',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MERC',
    MAKE_DISPLAY: 'Mercury',
    MODEL_CODE: 'MERCGRAND',
    MODEL_DISPLAY: 'Grand Marquis',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MERC',
    MAKE_DISPLAY: 'Mercury',
    MODEL_CODE: 'MYSTIQ',
    MODEL_DISPLAY: 'Mystique',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MERC',
    MAKE_DISPLAY: 'Mercury',
    MODEL_CODE: 'VILLA',
    MODEL_DISPLAY: 'Villager',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MERC',
    MAKE_DISPLAY: 'Mercury',
    MODEL_CODE: 'MEOTH',
    MODEL_DISPLAY: 'Other Mercury Models',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MERC',
    MAKE_DISPLAY: 'Mercury',
    MODEL_CODE: 'MERCZEP',
    MODEL_DISPLAY: 'Zephyr',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MINI',
    MAKE_DISPLAY: 'MINI',
    MODEL_CODE: 'COOPERROAD',
    MODEL_DISPLAY: 'Cooper Roadster',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MINI',
    MAKE_DISPLAY: 'MINI',
    MODEL_CODE: 'MINIPACE',
    MODEL_DISPLAY: 'Cooper Paceman',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MINI',
    MAKE_DISPLAY: 'MINI',
    MODEL_CODE: 'COUNTRYMAN',
    MODEL_DISPLAY: 'Cooper Countryman',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MINI',
    MAKE_DISPLAY: 'MINI',
    MODEL_CODE: 'COOPERCLUB',
    MODEL_DISPLAY: 'Cooper Clubman',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MINI',
    MAKE_DISPLAY: 'MINI',
    MODEL_CODE: 'MINICOUPE',
    MODEL_DISPLAY: 'Cooper Coupe',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MINI',
    MAKE_DISPLAY: 'MINI',
    MODEL_CODE: 'COOPER',
    MODEL_DISPLAY: 'Cooper',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MIT',
    MAKE_DISPLAY: 'Mitsubishi',
    MODEL_CODE: 'OUTLANDER',
    MODEL_DISPLAY: 'Outlander',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MIT',
    MAKE_DISPLAY: 'Mitsubishi',
    MODEL_CODE: 'MONTSPORT',
    MODEL_DISPLAY: 'Montero Sport',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MIT',
    MAKE_DISPLAY: 'Mitsubishi',
    MODEL_CODE: 'ENDEAVOR',
    MODEL_DISPLAY: 'Endeavor',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MIT',
    MAKE_DISPLAY: 'Mitsubishi',
    MODEL_CODE: 'LANCERMITS',
    MODEL_DISPLAY: 'Lancer',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MIT',
    MAKE_DISPLAY: 'Mitsubishi',
    MODEL_CODE: 'CORD',
    MODEL_DISPLAY: 'Cordia',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MIT',
    MAKE_DISPLAY: 'Mitsubishi',
    MODEL_CODE: 'ECLIP',
    MODEL_DISPLAY: 'Eclipse',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MIT',
    MAKE_DISPLAY: 'Mitsubishi',
    MODEL_CODE: 'GALANT',
    MODEL_DISPLAY: 'Galant',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MIT',
    MAKE_DISPLAY: 'Mitsubishi',
    MODEL_CODE: 'MITEXP',
    MODEL_DISPLAY: 'Expo',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MIT',
    MAKE_DISPLAY: 'Mitsubishi',
    MODEL_CODE: 'MITPU',
    MODEL_DISPLAY: 'Mighty Max',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MIT',
    MAKE_DISPLAY: 'Mitsubishi',
    MODEL_CODE: 'MITSTAR',
    MODEL_DISPLAY: 'Starion',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MIT',
    MAKE_DISPLAY: 'Mitsubishi',
    MODEL_CODE: 'MONT',
    MODEL_DISPLAY: 'Montero',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MIT',
    MAKE_DISPLAY: 'Mitsubishi',
    MODEL_CODE: 'SIGMA',
    MODEL_DISPLAY: 'Sigma',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MIT',
    MAKE_DISPLAY: 'Mitsubishi',
    MODEL_CODE: 'TRED',
    MODEL_DISPLAY: 'Tredia',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MIT',
    MAKE_DISPLAY: 'Mitsubishi',
    MODEL_CODE: 'RAIDERMITS',
    MODEL_DISPLAY: 'Raider',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MIT',
    MAKE_DISPLAY: 'Mitsubishi',
    MODEL_CODE: 'PRECIS',
    MODEL_DISPLAY: 'Precis',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MIT',
    MAKE_DISPLAY: 'Mitsubishi',
    MODEL_CODE: '3000GT',
    MODEL_DISPLAY: '3000GT',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MIT',
    MAKE_DISPLAY: 'Mitsubishi',
    MODEL_CODE: 'DIAMAN',
    MODEL_DISPLAY: 'Diamante',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MIT',
    MAKE_DISPLAY: 'Mitsubishi',
    MODEL_CODE: 'MIRAGE',
    MODEL_DISPLAY: 'Mirage',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MIT',
    MAKE_DISPLAY: 'Mitsubishi',
    MODEL_CODE: 'MITOTH',
    MODEL_DISPLAY: 'Other Mitsubishi Models',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MIT',
    MAKE_DISPLAY: 'Mitsubishi',
    MODEL_CODE: 'MITVAN',
    MODEL_DISPLAY: 'Van',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MIT',
    MAKE_DISPLAY: 'Mitsubishi',
    MODEL_CODE: 'MITECLCROS',
    MODEL_DISPLAY: 'Eclipse Cross',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MIT',
    MAKE_DISPLAY: 'Mitsubishi',
    MODEL_CODE: 'OUTLANDSPT',
    MODEL_DISPLAY: 'Outlander Sport',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MIT',
    MAKE_DISPLAY: 'Mitsubishi',
    MODEL_CODE: 'MITI',
    MODEL_DISPLAY: 'i',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MIT',
    MAKE_DISPLAY: 'Mitsubishi',
    MODEL_CODE: 'MITMIRG4',
    MODEL_DISPLAY: 'Mirage G4',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'MIT',
    MAKE_DISPLAY: 'Mitsubishi',
    MODEL_CODE: 'LANCEREVO',
    MODEL_DISPLAY: 'Lancer Evolution',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'NISSAN',
    MAKE_DISPLAY: 'Nissan',
    MODEL_CODE: 'NISVERSNOT',
    MODEL_DISPLAY: 'Versa Note',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'NISSAN',
    MAKE_DISPLAY: 'Nissan',
    MODEL_CODE: 'MURANO',
    MODEL_DISPLAY: 'Murano',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'NISSAN',
    MAKE_DISPLAY: 'Nissan',
    MODEL_CODE: '350Z',
    MODEL_DISPLAY: '350Z',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'NISSAN',
    MAKE_DISPLAY: 'Nissan',
    MODEL_CODE: 'PATHARMADA',
    MODEL_DISPLAY: 'Armada',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'NISSAN',
    MAKE_DISPLAY: 'Nissan',
    MODEL_CODE: 'TITAN',
    MODEL_DISPLAY: 'Titan',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'NISSAN',
    MAKE_DISPLAY: 'Nissan',
    MODEL_CODE: 'MAX',
    MODEL_DISPLAY: 'Maxima',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'NISSAN',
    MAKE_DISPLAY: 'Nissan',
    MODEL_CODE: 'NISPU',
    MODEL_DISPLAY: 'Pickup',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'NISSAN',
    MAKE_DISPLAY: 'Nissan',
    MODEL_CODE: 'NISVAN',
    MODEL_DISPLAY: 'Van',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'NISSAN',
    MAKE_DISPLAY: 'Nissan',
    MODEL_CODE: 'PATH',
    MODEL_DISPLAY: 'Pathfinder',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'NISSAN',
    MAKE_DISPLAY: 'Nissan',
    MODEL_CODE: 'PULSAR',
    MODEL_DISPLAY: 'Pulsar',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'NISSAN',
    MAKE_DISPLAY: 'Nissan',
    MODEL_CODE: 'SENTRA',
    MODEL_DISPLAY: 'Sentra',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'NISSAN',
    MAKE_DISPLAY: 'Nissan',
    MODEL_CODE: '240SX',
    MODEL_DISPLAY: '240SX',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'NISSAN',
    MAKE_DISPLAY: 'Nissan',
    MODEL_CODE: 'ALTIMA',
    MODEL_DISPLAY: 'Altima',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'NISSAN',
    MAKE_DISPLAY: 'Nissan',
    MODEL_CODE: 'NIS200SX',
    MODEL_DISPLAY: '200SX',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'NISSAN',
    MAKE_DISPLAY: 'Nissan',
    MODEL_CODE: 'VERSA',
    MODEL_DISPLAY: 'Versa',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'NISSAN',
    MAKE_DISPLAY: 'Nissan',
    MODEL_CODE: 'QUEST',
    MODEL_DISPLAY: 'Quest',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'NISSAN',
    MAKE_DISPLAY: 'Nissan',
    MODEL_CODE: 'FRONTI',
    MODEL_DISPLAY: 'Frontier',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'NISSAN',
    MAKE_DISPLAY: 'Nissan',
    MODEL_CODE: 'STANZA',
    MODEL_DISPLAY: 'Stanza',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'NISSAN',
    MAKE_DISPLAY: 'Nissan',
    MODEL_CODE: 'NX',
    MODEL_DISPLAY: 'NX',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'NISSAN',
    MAKE_DISPLAY: 'Nissan',
    MODEL_CODE: '300ZXTURBO',
    MODEL_DISPLAY: '300ZX',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'NISSAN',
    MAKE_DISPLAY: 'Nissan',
    MODEL_CODE: 'XTERRA',
    MODEL_DISPLAY: 'Xterra',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'NISSAN',
    MAKE_DISPLAY: 'Nissan',
    MODEL_CODE: 'NISSOTH',
    MODEL_DISPLAY: 'Other Nissan Models',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'NISSAN',
    MAKE_DISPLAY: 'Nissan',
    MODEL_CODE: 'LEAF',
    MODEL_DISPLAY: 'Leaf',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'NISSAN',
    MAKE_DISPLAY: 'Nissan',
    MODEL_CODE: 'AXXESS',
    MODEL_DISPLAY: 'Axxess',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'NISSAN',
    MAKE_DISPLAY: 'Nissan',
    MODEL_CODE: 'GT-R',
    MODEL_DISPLAY: 'GT-R',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'NISSAN',
    MAKE_DISPLAY: 'Nissan',
    MODEL_CODE: '370Z',
    MODEL_DISPLAY: '370Z',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'NISSAN',
    MAKE_DISPLAY: 'Nissan',
    MODEL_CODE: 'ROGUE',
    MODEL_DISPLAY: 'Rogue',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'NISSAN',
    MAKE_DISPLAY: 'Nissan',
    MODEL_CODE: 'JUKE',
    MODEL_DISPLAY: 'Juke',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'NISSAN',
    MAKE_DISPLAY: 'Nissan',
    MODEL_CODE: 'MURANOCROS',
    MODEL_DISPLAY: 'Murano CrossCabriolet',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'NISSAN',
    MAKE_DISPLAY: 'Nissan',
    MODEL_CODE: 'NISROGSPT',
    MODEL_DISPLAY: 'Rogue Sport',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'NISSAN',
    MAKE_DISPLAY: 'Nissan',
    MODEL_CODE: 'NISKICKS',
    MODEL_DISPLAY: 'Kicks',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'NISSAN',
    MAKE_DISPLAY: 'Nissan',
    MODEL_CODE: 'NV',
    MODEL_DISPLAY: 'NV',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'NISSAN',
    MAKE_DISPLAY: 'Nissan',
    MODEL_CODE: 'NISNV200',
    MODEL_DISPLAY: 'NV200',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'NISSAN',
    MAKE_DISPLAY: 'Nissan',
    MODEL_CODE: 'CUBE',
    MODEL_DISPLAY: 'Cube',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'OLDS',
    MAKE_DISPLAY: 'Oldsmobile',
    MODEL_CODE: '88',
    MODEL_DISPLAY: '88',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'OLDS',
    MAKE_DISPLAY: 'Oldsmobile',
    MODEL_CODE: '98',
    MODEL_DISPLAY: 'Ninety-Eight',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'OLDS',
    MAKE_DISPLAY: 'Oldsmobile',
    MODEL_CODE: 'ACHIEV',
    MODEL_DISPLAY: 'Achieva',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'OLDS',
    MAKE_DISPLAY: 'Oldsmobile',
    MODEL_CODE: 'BRAV',
    MODEL_DISPLAY: 'Bravada',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'OLDS',
    MAKE_DISPLAY: 'Oldsmobile',
    MODEL_CODE: 'CIERA',
    MODEL_DISPLAY: 'Cutlass Ciera',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'OLDS',
    MAKE_DISPLAY: 'Oldsmobile',
    MODEL_CODE: 'CSUPR',
    MODEL_DISPLAY: 'Cutlass Supreme',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'OLDS',
    MAKE_DISPLAY: 'Oldsmobile',
    MODEL_CODE: 'CUCR',
    MODEL_DISPLAY: 'Custom Cruiser',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'OLDS',
    MAKE_DISPLAY: 'Oldsmobile',
    MODEL_CODE: 'OLDCALAIS',
    MODEL_DISPLAY: 'Cutlass Calais',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'OLDS',
    MAKE_DISPLAY: 'Oldsmobile',
    MODEL_CODE: 'OLDSFIR',
    MODEL_DISPLAY: 'Firenza',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'OLDS',
    MAKE_DISPLAY: 'Oldsmobile',
    MODEL_CODE: 'OMEG',
    MODEL_DISPLAY: 'Omega',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'OLDS',
    MAKE_DISPLAY: 'Oldsmobile',
    MODEL_CODE: 'SILHO',
    MODEL_DISPLAY: 'Silhouette',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'OLDS',
    MAKE_DISPLAY: 'Oldsmobile',
    MODEL_CODE: 'OLDCUS',
    MODEL_DISPLAY: 'Cutlass',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'OLDS',
    MAKE_DISPLAY: 'Oldsmobile',
    MODEL_CODE: 'ALERO',
    MODEL_DISPLAY: 'Alero',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'OLDS',
    MAKE_DISPLAY: 'Oldsmobile',
    MODEL_CODE: 'REGEN',
    MODEL_DISPLAY: 'Regency',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'OLDS',
    MAKE_DISPLAY: 'Oldsmobile',
    MODEL_CODE: 'INTRIG',
    MODEL_DISPLAY: 'Intrigue',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'OLDS',
    MAKE_DISPLAY: 'Oldsmobile',
    MODEL_CODE: 'TORO',
    MODEL_DISPLAY: 'Toronado',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'OLDS',
    MAKE_DISPLAY: 'Oldsmobile',
    MODEL_CODE: 'AURORA',
    MODEL_DISPLAY: 'Aurora',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'OLDS',
    MAKE_DISPLAY: 'Oldsmobile',
    MODEL_CODE: 'OLDOTH',
    MODEL_DISPLAY: 'Other Oldsmobile Models',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'PLYM',
    MAKE_DISPLAY: 'Plymouth',
    MODEL_CODE: 'TURISMO',
    MODEL_DISPLAY: 'Turismo',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'PLYM',
    MAKE_DISPLAY: 'Plymouth',
    MODEL_CODE: 'CHAMP',
    MODEL_DISPLAY: 'Champ',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'PLYM',
    MAKE_DISPLAY: 'Plymouth',
    MODEL_CODE: 'SCAMP',
    MODEL_DISPLAY: 'Scamp',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'PLYM',
    MAKE_DISPLAY: 'Plymouth',
    MODEL_CODE: 'TRAILDUST',
    MODEL_DISPLAY: 'Trailduster',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'PLYM',
    MAKE_DISPLAY: 'Plymouth',
    MODEL_CODE: 'ACC',
    MODEL_DISPLAY: 'Acclaim',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'PLYM',
    MAKE_DISPLAY: 'Plymouth',
    MODEL_CODE: 'BREEZE',
    MODEL_DISPLAY: 'Breeze',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'PLYM',
    MAKE_DISPLAY: 'Plymouth',
    MODEL_CODE: 'CARAVE',
    MODEL_DISPLAY: 'Caravelle',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'PLYM',
    MAKE_DISPLAY: 'Plymouth',
    MODEL_CODE: 'HORI',
    MODEL_DISPLAY: 'Horizon',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'PLYM',
    MAKE_DISPLAY: 'Plymouth',
    MODEL_CODE: 'LASER',
    MODEL_DISPLAY: 'Laser',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'PLYM',
    MAKE_DISPLAY: 'Plymouth',
    MODEL_CODE: 'NEON',
    MODEL_DISPLAY: 'Neon',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'PLYM',
    MAKE_DISPLAY: 'Plymouth',
    MODEL_CODE: 'PLYMGRANV',
    MODEL_DISPLAY: 'Grand Voyager',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'PLYM',
    MAKE_DISPLAY: 'Plymouth',
    MODEL_CODE: 'PROWLE',
    MODEL_DISPLAY: 'Prowler',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'PLYM',
    MAKE_DISPLAY: 'Plymouth',
    MODEL_CODE: 'SAPPOROPLY',
    MODEL_DISPLAY: 'Sapporo',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'PLYM',
    MAKE_DISPLAY: 'Plymouth',
    MODEL_CODE: 'RELI',
    MODEL_DISPLAY: 'Reliant',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'PLYM',
    MAKE_DISPLAY: 'Plymouth',
    MODEL_CODE: 'VOYA',
    MODEL_DISPLAY: 'Voyager',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'PLYM',
    MAKE_DISPLAY: 'Plymouth',
    MODEL_CODE: 'COLT',
    MODEL_DISPLAY: 'Colt',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'PLYM',
    MAKE_DISPLAY: 'Plymouth',
    MODEL_CODE: 'SUNDAN',
    MODEL_DISPLAY: 'Sundance',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'PLYM',
    MAKE_DISPLAY: 'Plymouth',
    MODEL_CODE: 'PLYOTH',
    MODEL_DISPLAY: 'Other Plymouth Models',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'PLYM',
    MAKE_DISPLAY: 'Plymouth',
    MODEL_CODE: 'ARROW',
    MODEL_DISPLAY: 'Arrow',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'PLYM',
    MAKE_DISPLAY: 'Plymouth',
    MODEL_CODE: 'PLYMCONQ',
    MODEL_DISPLAY: 'Conquest',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'PLYM',
    MAKE_DISPLAY: 'Plymouth',
    MODEL_CODE: 'GRANFURY',
    MODEL_DISPLAY: 'Gran Fury',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'PONT',
    MAKE_DISPLAY: 'Pontiac',
    MODEL_CODE: 'PHOENIX',
    MODEL_DISPLAY: 'Phoenix',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'PONT',
    MAKE_DISPLAY: 'Pontiac',
    MODEL_CODE: 'G6',
    MODEL_DISPLAY: 'G6',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'PONT',
    MAKE_DISPLAY: 'Pontiac',
    MODEL_CODE: 'VIBE',
    MODEL_DISPLAY: 'Vibe',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'PONT',
    MAKE_DISPLAY: 'Pontiac',
    MODEL_CODE: 'GTO',
    MODEL_DISPLAY: 'GTO',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'PONT',
    MAKE_DISPLAY: 'Pontiac',
    MODEL_CODE: 'SAFARIPONT',
    MODEL_DISPLAY: 'Safari',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'PONT',
    MAKE_DISPLAY: 'Pontiac',
    MODEL_CODE: 'FBIRD',
    MODEL_DISPLAY: 'Firebird',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'PONT',
    MAKE_DISPLAY: 'Pontiac',
    MODEL_CODE: 'FIERO',
    MODEL_DISPLAY: 'Fiero',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'PONT',
    MAKE_DISPLAY: 'Pontiac',
    MODEL_CODE: 'GP',
    MODEL_DISPLAY: 'Grand Prix',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'PONT',
    MAKE_DISPLAY: 'Pontiac',
    MODEL_CODE: 'GRNDAM',
    MODEL_DISPLAY: 'Grand Am',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'PONT',
    MAKE_DISPLAY: 'Pontiac',
    MODEL_CODE: 'LEMANS',
    MODEL_DISPLAY: 'Le Mans',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'PONT',
    MAKE_DISPLAY: 'Pontiac',
    MODEL_CODE: 'PARISI',
    MODEL_DISPLAY: 'Parisienne',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'PONT',
    MAKE_DISPLAY: 'Pontiac',
    MODEL_CODE: 'SUNFIR',
    MODEL_DISPLAY: 'Sunfire',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'PONT',
    MAKE_DISPLAY: 'Pontiac',
    MODEL_CODE: 'TS',
    MODEL_DISPLAY: 'Trans Sport',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'PONT',
    MAKE_DISPLAY: 'Pontiac',
    MODEL_CODE: 'CATALINA',
    MODEL_DISPLAY: 'Catalina',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'PONT',
    MAKE_DISPLAY: 'Pontiac',
    MODEL_CODE: 'J2000',
    MODEL_DISPLAY: 'J2000',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'PONT',
    MAKE_DISPLAY: 'Pontiac',
    MODEL_CODE: 'T-1000',
    MODEL_DISPLAY: '1000',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'PONT',
    MAKE_DISPLAY: 'Pontiac',
    MODEL_CODE: 'SOLSTICE',
    MODEL_DISPLAY: 'Solstice',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'PONT',
    MAKE_DISPLAY: 'Pontiac',
    MODEL_CODE: 'TORRENT',
    MODEL_DISPLAY: 'Torrent',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'PONT',
    MAKE_DISPLAY: 'Pontiac',
    MODEL_CODE: 'G5',
    MODEL_DISPLAY: 'G5',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'PONT',
    MAKE_DISPLAY: 'Pontiac',
    MODEL_CODE: '6000',
    MODEL_DISPLAY: '6000',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'PONT',
    MAKE_DISPLAY: 'Pontiac',
    MODEL_CODE: 'BON',
    MODEL_DISPLAY: 'Bonneville',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'PONT',
    MAKE_DISPLAY: 'Pontiac',
    MODEL_CODE: 'SUNBIR',
    MODEL_DISPLAY: 'Sunbird',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'PONT',
    MAKE_DISPLAY: 'Pontiac',
    MODEL_CODE: 'MONTANA',
    MODEL_DISPLAY: 'Montana',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'PONT',
    MAKE_DISPLAY: 'Pontiac',
    MODEL_CODE: 'PONOTH',
    MODEL_DISPLAY: 'Other Pontiac Models',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'PONT',
    MAKE_DISPLAY: 'Pontiac',
    MODEL_CODE: 'AZTEK',
    MODEL_DISPLAY: 'Aztek',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'PONT',
    MAKE_DISPLAY: 'Pontiac',
    MODEL_CODE: 'G3',
    MODEL_DISPLAY: 'G3',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'PONT',
    MAKE_DISPLAY: 'Pontiac',
    MODEL_CODE: 'G8',
    MODEL_DISPLAY: 'G8',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'POR',
    MAKE_DISPLAY: 'Porsche',
    MODEL_CODE: 'CAYENNE',
    MODEL_DISPLAY: 'Cayenne',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'POR',
    MAKE_DISPLAY: 'Porsche',
    MODEL_CODE: 'CARRERAGT',
    MODEL_DISPLAY: 'Carrera GT',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'POR',
    MAKE_DISPLAY: 'Porsche',
    MODEL_CODE: '911',
    MODEL_DISPLAY: '911',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'POR',
    MAKE_DISPLAY: 'Porsche',
    MODEL_CODE: '924',
    MODEL_DISPLAY: '924',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'POR',
    MAKE_DISPLAY: 'Porsche',
    MODEL_CODE: '928',
    MODEL_DISPLAY: '928',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'POR',
    MAKE_DISPLAY: 'Porsche',
    MODEL_CODE: '944',
    MODEL_DISPLAY: '944',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'POR',
    MAKE_DISPLAY: 'Porsche',
    MODEL_CODE: 'CAYMAN',
    MODEL_DISPLAY: 'Cayman',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'POR',
    MAKE_DISPLAY: 'Porsche',
    MODEL_CODE: 'BOXSTE',
    MODEL_DISPLAY: 'Boxster',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'POR',
    MAKE_DISPLAY: 'Porsche',
    MODEL_CODE: '968',
    MODEL_DISPLAY: '968',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'POR',
    MAKE_DISPLAY: 'Porsche',
    MODEL_CODE: 'POR918SPYD',
    MODEL_DISPLAY: '918 Spyder',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'POR',
    MAKE_DISPLAY: 'Porsche',
    MODEL_CODE: 'PORMACAN',
    MODEL_DISPLAY: 'Macan',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'POR',
    MAKE_DISPLAY: 'Porsche',
    MODEL_CODE: 'POROTH',
    MODEL_DISPLAY: 'Other Porsche Models',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'POR',
    MAKE_DISPLAY: 'Porsche',
    MODEL_CODE: 'PANAMERA',
    MODEL_DISPLAY: 'Panamera',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'POR',
    MAKE_DISPLAY: 'Porsche',
    MODEL_CODE: 'POR718BOX',
    MODEL_DISPLAY: '718 Boxster',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'POR',
    MAKE_DISPLAY: 'Porsche',
    MODEL_CODE: 'POR718CAY',
    MODEL_DISPLAY: '718 Cayman',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'RAM',
    MAKE_DISPLAY: 'RAM',
    MODEL_CODE: 'RMPROMAST',
    MODEL_DISPLAY: 'ProMaster',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'RAM',
    MAKE_DISPLAY: 'RAM',
    MODEL_CODE: 'RM5500',
    MODEL_DISPLAY: '5500',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'RAM',
    MAKE_DISPLAY: 'RAM',
    MODEL_CODE: 'RM1500',
    MODEL_DISPLAY: '1500',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'RAM',
    MAKE_DISPLAY: 'RAM',
    MODEL_CODE: 'RM2500',
    MODEL_DISPLAY: '2500',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'RAM',
    MAKE_DISPLAY: 'RAM',
    MODEL_CODE: 'RM3500',
    MODEL_DISPLAY: '3500',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'RAM',
    MAKE_DISPLAY: 'RAM',
    MODEL_CODE: 'RM4500',
    MODEL_DISPLAY: '4500',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'RAM',
    MAKE_DISPLAY: 'RAM',
    MODEL_CODE: 'RMCV',
    MODEL_DISPLAY: 'C/V',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'RAM',
    MAKE_DISPLAY: 'RAM',
    MODEL_CODE: 'RMPROCITY',
    MODEL_DISPLAY: 'ProMaster City',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ROV',
    MAKE_DISPLAY: 'Land Rover',
    MODEL_CODE: 'DEFEND',
    MODEL_DISPLAY: 'Defender',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ROV',
    MAKE_DISPLAY: 'Land Rover',
    MODEL_CODE: 'DISCOV',
    MODEL_DISPLAY: 'Discovery',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ROV',
    MAKE_DISPLAY: 'Land Rover',
    MODEL_CODE: 'RANGE',
    MODEL_DISPLAY: 'Range Rover',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ROV',
    MAKE_DISPLAY: 'Land Rover',
    MODEL_CODE: 'LR3',
    MODEL_DISPLAY: 'LR3',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ROV',
    MAKE_DISPLAY: 'Land Rover',
    MODEL_CODE: 'RANGESPORT',
    MODEL_DISPLAY: 'Range Rover Sport',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ROV',
    MAKE_DISPLAY: 'Land Rover',
    MODEL_CODE: 'FRELNDR',
    MODEL_DISPLAY: 'Freelander',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ROV',
    MAKE_DISPLAY: 'Land Rover',
    MODEL_CODE: 'ROVOTH',
    MODEL_DISPLAY: 'Other Land Rover Models',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ROV',
    MAKE_DISPLAY: 'Land Rover',
    MODEL_CODE: 'EVOQUE',
    MODEL_DISPLAY: 'Range Rover Evoque',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ROV',
    MAKE_DISPLAY: 'Land Rover',
    MODEL_CODE: 'ROVDISCSPT',
    MODEL_DISPLAY: 'Discovery Sport',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ROV',
    MAKE_DISPLAY: 'Land Rover',
    MODEL_CODE: 'ROVVELAR',
    MODEL_DISPLAY: 'Range Rover Velar',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ROV',
    MAKE_DISPLAY: 'Land Rover',
    MODEL_CODE: 'LR4',
    MODEL_DISPLAY: 'LR4',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'ROV',
    MAKE_DISPLAY: 'Land Rover',
    MODEL_CODE: 'LR2',
    MODEL_DISPLAY: 'LR2',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'RR',
    MAKE_DISPLAY: 'Rolls-Royce',
    MODEL_CODE: 'PHANT',
    MODEL_DISPLAY: 'Phantom',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'RR',
    MAKE_DISPLAY: 'Rolls-Royce',
    MODEL_CODE: 'SILSERAPH',
    MODEL_DISPLAY: 'Silver Seraph',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'RR',
    MAKE_DISPLAY: 'Rolls-Royce',
    MODEL_CODE: 'CAMAR',
    MODEL_DISPLAY: 'Camargue',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'RR',
    MAKE_DISPLAY: 'Rolls-Royce',
    MODEL_CODE: 'CORN',
    MODEL_DISPLAY: 'Corniche',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'RR',
    MAKE_DISPLAY: 'Rolls-Royce',
    MODEL_CODE: 'DAWN',
    MODEL_DISPLAY: 'Silver Dawn',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'RR',
    MAKE_DISPLAY: 'Rolls-Royce',
    MODEL_CODE: 'PARKWARD',
    MODEL_DISPLAY: 'Park Ward',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'RR',
    MAKE_DISPLAY: 'Rolls-Royce',
    MODEL_CODE: 'RRSPIR',
    MODEL_DISPLAY: 'Silver Spirit',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'RR',
    MAKE_DISPLAY: 'Rolls-Royce',
    MODEL_CODE: 'SPUR',
    MODEL_DISPLAY: 'Silver Spur',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'RR',
    MAKE_DISPLAY: 'Rolls-Royce',
    MODEL_CODE: 'WRAI',
    MODEL_DISPLAY: 'Wraith',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'RR',
    MAKE_DISPLAY: 'Rolls-Royce',
    MODEL_CODE: 'RROTH',
    MODEL_DISPLAY: 'Other Rolls-Royce Models',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'RR',
    MAKE_DISPLAY: 'Rolls-Royce',
    MODEL_CODE: 'RRDAWN',
    MODEL_DISPLAY: 'Dawn',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'RR',
    MAKE_DISPLAY: 'Rolls-Royce',
    MODEL_CODE: 'RRCULLINAN',
    MODEL_DISPLAY: 'Cullinan',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'RR',
    MAKE_DISPLAY: 'Rolls-Royce',
    MODEL_CODE: 'GHOST',
    MODEL_DISPLAY: 'Ghost',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SAAB',
    MAKE_DISPLAY: 'Saab',
    MODEL_CODE: '9-2X',
    MODEL_DISPLAY: '9-2X',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SAAB',
    MAKE_DISPLAY: 'Saab',
    MODEL_CODE: '900',
    MODEL_DISPLAY: '900',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SAAB',
    MAKE_DISPLAY: 'Saab',
    MODEL_CODE: '97X',
    MODEL_DISPLAY: '9-7X',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SAAB',
    MAKE_DISPLAY: 'Saab',
    MODEL_CODE: '9-5',
    MODEL_DISPLAY: '9-5',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SAAB',
    MAKE_DISPLAY: 'Saab',
    MODEL_CODE: '9-3',
    MODEL_DISPLAY: '9-3',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SAAB',
    MAKE_DISPLAY: 'Saab',
    MODEL_CODE: '9000',
    MODEL_DISPLAY: '9000',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SAAB',
    MAKE_DISPLAY: 'Saab',
    MODEL_CODE: 'SAOTH',
    MODEL_DISPLAY: 'Other Saab Models',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SAAB',
    MAKE_DISPLAY: 'Saab',
    MODEL_CODE: '9-4X',
    MODEL_DISPLAY: '9-4X',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SATURN',
    MAKE_DISPLAY: 'Saturn',
    MODEL_CODE: 'RELAY',
    MODEL_DISPLAY: 'Relay',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SATURN',
    MAKE_DISPLAY: 'Saturn',
    MODEL_CODE: 'ION',
    MODEL_DISPLAY: 'ION',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SATURN',
    MAKE_DISPLAY: 'Saturn',
    MODEL_CODE: 'SKY',
    MODEL_DISPLAY: 'Sky',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SATURN',
    MAKE_DISPLAY: 'Saturn',
    MODEL_CODE: 'AURA',
    MODEL_DISPLAY: 'Aura',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SATURN',
    MAKE_DISPLAY: 'Saturn',
    MODEL_CODE: 'SATLSE',
    MODEL_DISPLAY: 'L-Series',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SATURN',
    MAKE_DISPLAY: 'Saturn',
    MODEL_CODE: 'SATSSE',
    MODEL_DISPLAY: 'S-Series',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SATURN',
    MAKE_DISPLAY: 'Saturn',
    MODEL_CODE: 'OUTLOOK',
    MODEL_DISPLAY: 'Outlook',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SATURN',
    MAKE_DISPLAY: 'Saturn',
    MODEL_CODE: 'SATOTH',
    MODEL_DISPLAY: 'Other Saturn Models',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SATURN',
    MAKE_DISPLAY: 'Saturn',
    MODEL_CODE: 'VUE',
    MODEL_DISPLAY: 'Vue',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SATURN',
    MAKE_DISPLAY: 'Saturn',
    MODEL_CODE: 'ASTRA',
    MODEL_DISPLAY: 'Astra',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SCION',
    MAKE_DISPLAY: 'Scion',
    MODEL_CODE: 'XA',
    MODEL_DISPLAY: 'xA',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SCION',
    MAKE_DISPLAY: 'Scion',
    MODEL_CODE: 'XB',
    MODEL_DISPLAY: 'xB',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SCION',
    MAKE_DISPLAY: 'Scion',
    MODEL_CODE: 'TC',
    MODEL_DISPLAY: 'tC',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SCION',
    MAKE_DISPLAY: 'Scion',
    MODEL_CODE: 'IQ',
    MODEL_DISPLAY: 'iQ',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SCION',
    MAKE_DISPLAY: 'Scion',
    MODEL_CODE: 'SCIFRS',
    MODEL_DISPLAY: 'FR-S',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SCION',
    MAKE_DISPLAY: 'Scion',
    MODEL_CODE: 'XD',
    MODEL_DISPLAY: 'xD',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SCION',
    MAKE_DISPLAY: 'Scion',
    MODEL_CODE: 'SCIIA',
    MODEL_DISPLAY: 'iA',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SCION',
    MAKE_DISPLAY: 'Scion',
    MODEL_CODE: 'SCIIM',
    MODEL_DISPLAY: 'iM',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SMART',
    MAKE_DISPLAY: 'smart',
    MODEL_CODE: 'SMOTH',
    MODEL_DISPLAY: 'Other smart Models',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SMART',
    MAKE_DISPLAY: 'smart',
    MODEL_CODE: 'FORTWO',
    MODEL_DISPLAY: 'fortwo',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SRT',
    MAKE_DISPLAY: 'SRT',
    MODEL_CODE: 'SRTVIPER',
    MODEL_DISPLAY: 'Viper',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SUB',
    MAKE_DISPLAY: 'Subaru',
    MODEL_CODE: 'SUBWRX',
    MODEL_DISPLAY: 'WRX',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SUB',
    MAKE_DISPLAY: 'Subaru',
    MODEL_CODE: 'BAJA',
    MODEL_DISPLAY: 'Baja',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SUB',
    MAKE_DISPLAY: 'Subaru',
    MODEL_CODE: 'IMPREZ',
    MODEL_DISPLAY: 'Impreza',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SUB',
    MAKE_DISPLAY: 'Subaru',
    MODEL_CODE: 'SUBOUTBK',
    MODEL_DISPLAY: 'Outback',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SUB',
    MAKE_DISPLAY: 'Subaru',
    MODEL_CODE: 'SVX',
    MODEL_DISPLAY: 'SVX',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SUB',
    MAKE_DISPLAY: 'Subaru',
    MODEL_CODE: 'XT',
    MODEL_DISPLAY: 'XT',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SUB',
    MAKE_DISPLAY: 'Subaru',
    MODEL_CODE: 'BRAT',
    MODEL_DISPLAY: 'Brat',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SUB',
    MAKE_DISPLAY: 'Subaru',
    MODEL_CODE: 'FOREST',
    MODEL_DISPLAY: 'Forester',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SUB',
    MAKE_DISPLAY: 'Subaru',
    MODEL_CODE: 'JUSTY',
    MODEL_DISPLAY: 'Justy',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SUB',
    MAKE_DISPLAY: 'Subaru',
    MODEL_CODE: 'LEGACY',
    MODEL_DISPLAY: 'Legacy',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SUB',
    MAKE_DISPLAY: 'Subaru',
    MODEL_CODE: 'LOYALE',
    MODEL_DISPLAY: 'Loyale',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SUB',
    MAKE_DISPLAY: 'Subaru',
    MODEL_CODE: 'SUBL',
    MODEL_DISPLAY: 'L Series',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SUB',
    MAKE_DISPLAY: 'Subaru',
    MODEL_CODE: 'SUBOTH',
    MODEL_DISPLAY: 'Other Subaru Models',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SUB',
    MAKE_DISPLAY: 'Subaru',
    MODEL_CODE: 'SUBBRZ',
    MODEL_DISPLAY: 'BRZ',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SUB',
    MAKE_DISPLAY: 'Subaru',
    MODEL_CODE: 'SUBASCENT',
    MODEL_DISPLAY: 'Ascent',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SUB',
    MAKE_DISPLAY: 'Subaru',
    MODEL_CODE: 'B9TRIBECA',
    MODEL_DISPLAY: 'Tribeca',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SUB',
    MAKE_DISPLAY: 'Subaru',
    MODEL_CODE: 'SUBCRSSTRK',
    MODEL_DISPLAY: 'Crosstrek',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SUB',
    MAKE_DISPLAY: 'Subaru',
    MODEL_CODE: 'IMPWRX',
    MODEL_DISPLAY: 'Impreza WRX',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SUB',
    MAKE_DISPLAY: 'Subaru',
    MODEL_CODE: 'XVCRSSTREK',
    MODEL_DISPLAY: 'XV Crosstrek',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SUZUKI',
    MAKE_DISPLAY: 'Suzuki',
    MODEL_CODE: 'XL7',
    MODEL_DISPLAY: 'XL7',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SUZUKI',
    MAKE_DISPLAY: 'Suzuki',
    MODEL_CODE: 'AERIO',
    MODEL_DISPLAY: 'Aerio',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SUZUKI',
    MAKE_DISPLAY: 'Suzuki',
    MODEL_CODE: 'VERONA',
    MODEL_DISPLAY: 'Verona',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SUZUKI',
    MAKE_DISPLAY: 'Suzuki',
    MODEL_CODE: 'FORENZA',
    MODEL_DISPLAY: 'Forenza',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SUZUKI',
    MAKE_DISPLAY: 'Suzuki',
    MODEL_CODE: 'ESTEEM',
    MODEL_DISPLAY: 'Esteem',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SUZUKI',
    MAKE_DISPLAY: 'Suzuki',
    MODEL_CODE: 'SAMUR',
    MODEL_DISPLAY: 'Samurai',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SUZUKI',
    MAKE_DISPLAY: 'Suzuki',
    MODEL_CODE: 'SIDE',
    MODEL_DISPLAY: 'Sidekick',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SUZUKI',
    MAKE_DISPLAY: 'Suzuki',
    MODEL_CODE: 'SWIFT',
    MODEL_DISPLAY: 'Swift',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SUZUKI',
    MAKE_DISPLAY: 'Suzuki',
    MODEL_CODE: 'RENO',
    MODEL_DISPLAY: 'Reno',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SUZUKI',
    MAKE_DISPLAY: 'Suzuki',
    MODEL_CODE: 'SX4',
    MODEL_DISPLAY: 'SX4',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SUZUKI',
    MAKE_DISPLAY: 'Suzuki',
    MODEL_CODE: 'X90',
    MODEL_DISPLAY: 'X-90',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SUZUKI',
    MAKE_DISPLAY: 'Suzuki',
    MODEL_CODE: 'VITARA',
    MODEL_DISPLAY: 'Vitara',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SUZUKI',
    MAKE_DISPLAY: 'Suzuki',
    MODEL_CODE: 'GRANDV',
    MODEL_DISPLAY: 'Grand Vitara',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SUZUKI',
    MAKE_DISPLAY: 'Suzuki',
    MODEL_CODE: 'SUZOTH',
    MODEL_DISPLAY: 'Other Suzuki Models',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SUZUKI',
    MAKE_DISPLAY: 'Suzuki',
    MODEL_CODE: 'KIZASHI',
    MODEL_DISPLAY: 'Kizashi',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'SUZUKI',
    MAKE_DISPLAY: 'Suzuki',
    MODEL_CODE: 'EQUATOR',
    MODEL_DISPLAY: 'Equator',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'TESLA',
    MAKE_DISPLAY: 'Tesla',
    MODEL_CODE: 'TESMODS',
    MODEL_DISPLAY: 'Model S',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'TESLA',
    MAKE_DISPLAY: 'Tesla',
    MODEL_CODE: 'TESMODX',
    MODEL_DISPLAY: 'Model X',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'TESLA',
    MAKE_DISPLAY: 'Tesla',
    MODEL_CODE: 'TESMOD3',
    MODEL_DISPLAY: 'Model 3',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'TESLA',
    MAKE_DISPLAY: 'Tesla',
    MODEL_CODE: 'ROADSTER',
    MODEL_DISPLAY: 'Roadster',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'TOYOTA',
    MAKE_DISPLAY: 'Toyota',
    MODEL_CODE: 'CORONA',
    MODEL_DISPLAY: 'Corona',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'TOYOTA',
    MAKE_DISPLAY: 'Toyota',
    MODEL_CODE: 'MATRIX',
    MODEL_DISPLAY: 'Matrix',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'TOYOTA',
    MAKE_DISPLAY: 'Toyota',
    MODEL_CODE: '4RUN',
    MODEL_DISPLAY: '4Runner',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'TOYOTA',
    MAKE_DISPLAY: 'Toyota',
    MODEL_CODE: 'AVALON',
    MODEL_DISPLAY: 'Avalon',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'TOYOTA',
    MAKE_DISPLAY: 'Toyota',
    MODEL_CODE: 'CELICA',
    MODEL_DISPLAY: 'Celica',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'TOYOTA',
    MAKE_DISPLAY: 'Toyota',
    MODEL_CODE: 'COROL',
    MODEL_DISPLAY: 'Corolla',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'TOYOTA',
    MAKE_DISPLAY: 'Toyota',
    MODEL_CODE: 'LC',
    MODEL_DISPLAY: 'Land Cruiser',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'TOYOTA',
    MAKE_DISPLAY: 'Toyota',
    MODEL_CODE: 'PREVIA',
    MODEL_DISPLAY: 'Previa',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'TOYOTA',
    MAKE_DISPLAY: 'Toyota',
    MODEL_CODE: 'RAV4',
    MODEL_DISPLAY: 'RAV4',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'TOYOTA',
    MAKE_DISPLAY: 'Toyota',
    MODEL_CODE: 'SIENNA',
    MODEL_DISPLAY: 'Sienna',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'TOYOTA',
    MAKE_DISPLAY: 'Toyota',
    MODEL_CODE: 'T100',
    MODEL_DISPLAY: 'T100',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'TOYOTA',
    MAKE_DISPLAY: 'Toyota',
    MODEL_CODE: 'TERCEL',
    MODEL_DISPLAY: 'Tercel',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'TOYOTA',
    MAKE_DISPLAY: 'Toyota',
    MODEL_CODE: 'STARLET',
    MODEL_DISPLAY: 'Starlet',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'TOYOTA',
    MAKE_DISPLAY: 'Toyota',
    MODEL_CODE: 'FJCRUIS',
    MODEL_DISPLAY: 'FJ Cruiser',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'TOYOTA',
    MAKE_DISPLAY: 'Toyota',
    MODEL_CODE: 'YARIS',
    MODEL_DISPLAY: 'Yaris',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'TOYOTA',
    MAKE_DISPLAY: 'Toyota',
    MODEL_CODE: 'MR2',
    MODEL_DISPLAY: 'MR2',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'TOYOTA',
    MAKE_DISPLAY: 'Toyota',
    MODEL_CODE: 'SUPRA',
    MODEL_DISPLAY: 'Supra',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'TOYOTA',
    MAKE_DISPLAY: 'Toyota',
    MODEL_CODE: 'TOYVAN',
    MODEL_DISPLAY: 'Van',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'TOYOTA',
    MAKE_DISPLAY: 'Toyota',
    MODEL_CODE: 'CAMRY',
    MODEL_DISPLAY: 'Camry',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'TOYOTA',
    MAKE_DISPLAY: 'Toyota',
    MODEL_CODE: 'PASEO',
    MODEL_DISPLAY: 'Paseo',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'TOYOTA',
    MAKE_DISPLAY: 'Toyota',
    MODEL_CODE: 'TACOMA',
    MODEL_DISPLAY: 'Tacoma',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'TOYOTA',
    MAKE_DISPLAY: 'Toyota',
    MODEL_CODE: 'CRESS',
    MODEL_DISPLAY: 'Cressida',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'TOYOTA',
    MAKE_DISPLAY: 'Toyota',
    MODEL_CODE: 'TUNDRA',
    MODEL_DISPLAY: 'Tundra',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'TOYOTA',
    MAKE_DISPLAY: 'Toyota',
    MODEL_CODE: 'SOLARA',
    MODEL_DISPLAY: 'Solara',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'TOYOTA',
    MAKE_DISPLAY: 'Toyota',
    MODEL_CODE: 'TOYMIRAI',
    MODEL_DISPLAY: 'Mirai',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'TOYOTA',
    MAKE_DISPLAY: 'Toyota',
    MODEL_CODE: 'TOYOTH',
    MODEL_DISPLAY: 'Other Toyota Models',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'TOYOTA',
    MAKE_DISPLAY: 'Toyota',
    MODEL_CODE: 'PICKUP',
    MODEL_DISPLAY: 'Pickup',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'TOYOTA',
    MAKE_DISPLAY: 'Toyota',
    MODEL_CODE: 'ECHO',
    MODEL_DISPLAY: 'Echo',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'TOYOTA',
    MAKE_DISPLAY: 'Toyota',
    MODEL_CODE: 'MR2SPYDR',
    MODEL_DISPLAY: 'MR2 Spyder',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'TOYOTA',
    MAKE_DISPLAY: 'Toyota',
    MODEL_CODE: 'PRIUS',
    MODEL_DISPLAY: 'Prius',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'TOYOTA',
    MAKE_DISPLAY: 'Toyota',
    MODEL_CODE: 'SEQUOIA',
    MODEL_DISPLAY: 'Sequoia',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'TOYOTA',
    MAKE_DISPLAY: 'Toyota',
    MODEL_CODE: 'HIGHLANDER',
    MODEL_DISPLAY: 'Highlander',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'TOYOTA',
    MAKE_DISPLAY: 'Toyota',
    MODEL_CODE: 'PRIUSV',
    MODEL_DISPLAY: 'Prius V',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'TOYOTA',
    MAKE_DISPLAY: 'Toyota',
    MODEL_CODE: 'TOY86',
    MODEL_DISPLAY: '86',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'TOYOTA',
    MAKE_DISPLAY: 'Toyota',
    MODEL_CODE: 'TOYPRIPRM',
    MODEL_DISPLAY: 'Prius Prime',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'TOYOTA',
    MAKE_DISPLAY: 'Toyota',
    MODEL_CODE: 'TOYCHR',
    MODEL_DISPLAY: 'C-HR',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'TOYOTA',
    MAKE_DISPLAY: 'Toyota',
    MODEL_CODE: 'PRIUSC',
    MODEL_DISPLAY: 'Prius C',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'TOYOTA',
    MAKE_DISPLAY: 'Toyota',
    MODEL_CODE: 'VENZA',
    MODEL_DISPLAY: 'Venza',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'VOLKS',
    MAKE_DISPLAY: 'Volkswagen',
    MODEL_CODE: 'TOUAREG',
    MODEL_DISPLAY: 'Touareg',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'VOLKS',
    MAKE_DISPLAY: 'Volkswagen',
    MODEL_CODE: 'PHAETON',
    MODEL_DISPLAY: 'Phaeton',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'VOLKS',
    MAKE_DISPLAY: 'Volkswagen',
    MODEL_CODE: 'R32',
    MODEL_DISPLAY: 'R32',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'VOLKS',
    MAKE_DISPLAY: 'Volkswagen',
    MODEL_CODE: 'BEETLE',
    MODEL_DISPLAY: 'Beetle',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'VOLKS',
    MAKE_DISPLAY: 'Volkswagen',
    MODEL_CODE: 'CAB',
    MODEL_DISPLAY: 'Cabriolet',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'VOLKS',
    MAKE_DISPLAY: 'Volkswagen',
    MODEL_CODE: 'CORR',
    MODEL_DISPLAY: 'Corrado',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'VOLKS',
    MAKE_DISPLAY: 'Volkswagen',
    MODEL_CODE: 'GOLF',
    MODEL_DISPLAY: 'Golf',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'VOLKS',
    MAKE_DISPLAY: 'Volkswagen',
    MODEL_CODE: 'GTI',
    MODEL_DISPLAY: 'GTI',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'VOLKS',
    MAKE_DISPLAY: 'Volkswagen',
    MODEL_CODE: 'JET',
    MODEL_DISPLAY: 'Jetta',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'VOLKS',
    MAKE_DISPLAY: 'Volkswagen',
    MODEL_CODE: 'PASS',
    MODEL_DISPLAY: 'Passat',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'VOLKS',
    MAKE_DISPLAY: 'Volkswagen',
    MODEL_CODE: 'QUAN',
    MODEL_DISPLAY: 'Quantum',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'VOLKS',
    MAKE_DISPLAY: 'Volkswagen',
    MODEL_CODE: 'RABBIT',
    MODEL_DISPLAY: 'Rabbit',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'VOLKS',
    MAKE_DISPLAY: 'Volkswagen',
    MODEL_CODE: 'SCIR',
    MODEL_DISPLAY: 'Scirocco',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'VOLKS',
    MAKE_DISPLAY: 'Volkswagen',
    MODEL_CODE: 'VANAG',
    MODEL_DISPLAY: 'Vanagon',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'VOLKS',
    MAKE_DISPLAY: 'Volkswagen',
    MODEL_CODE: 'VOLKSCAB',
    MODEL_DISPLAY: 'Cabrio',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'VOLKS',
    MAKE_DISPLAY: 'Volkswagen',
    MODEL_CODE: 'VOLKSFOX',
    MODEL_DISPLAY: 'Fox',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'VOLKS',
    MAKE_DISPLAY: 'Volkswagen',
    MODEL_CODE: 'DASHER',
    MODEL_DISPLAY: 'Dasher',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'VOLKS',
    MAKE_DISPLAY: 'Volkswagen',
    MODEL_CODE: 'EOS',
    MODEL_DISPLAY: 'Eos',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'VOLKS',
    MAKE_DISPLAY: 'Volkswagen',
    MODEL_CODE: 'RABBITPU',
    MODEL_DISPLAY: 'Pickup',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'VOLKS',
    MAKE_DISPLAY: 'Volkswagen',
    MODEL_CODE: 'EUROVAN',
    MODEL_DISPLAY: 'Eurovan',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'VOLKS',
    MAKE_DISPLAY: 'Volkswagen',
    MODEL_CODE: 'VWOTH',
    MODEL_DISPLAY: 'Other Volkswagen Models',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'VOLKS',
    MAKE_DISPLAY: 'Volkswagen',
    MODEL_CODE: 'TIGUAN',
    MODEL_DISPLAY: 'Tiguan',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'VOLKS',
    MAKE_DISPLAY: 'Volkswagen',
    MODEL_CODE: 'VOLKSATL',
    MODEL_DISPLAY: 'Atlas',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'VOLKS',
    MAKE_DISPLAY: 'Volkswagen',
    MODEL_CODE: 'GOLFR',
    MODEL_DISPLAY: 'Golf R',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'VOLKS',
    MAKE_DISPLAY: 'Volkswagen',
    MODEL_CODE: 'ROUTAN',
    MODEL_DISPLAY: 'Routan',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'VOLKS',
    MAKE_DISPLAY: 'Volkswagen',
    MODEL_CODE: 'CC',
    MODEL_DISPLAY: 'CC',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'VOLKS',
    MAKE_DISPLAY: 'Volkswagen',
    MODEL_CODE: 'VOLKSEGOLF',
    MODEL_DISPLAY: 'e-Golf',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'VOLVO',
    MAKE_DISPLAY: 'Volvo',
    MODEL_CODE: 'VOLVOXC40',
    MODEL_DISPLAY: 'XC40',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'VOLVO',
    MAKE_DISPLAY: 'Volvo',
    MODEL_CODE: 'XC',
    MODEL_DISPLAY: 'XC70',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'VOLVO',
    MAKE_DISPLAY: 'Volvo',
    MODEL_CODE: 'V50',
    MODEL_DISPLAY: 'V50',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'VOLVO',
    MAKE_DISPLAY: 'Volvo',
    MODEL_CODE: 'VOLVOV60',
    MODEL_DISPLAY: 'V60',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'VOLVO',
    MAKE_DISPLAY: 'Volvo',
    MODEL_CODE: '740',
    MODEL_DISPLAY: '740',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'VOLVO',
    MAKE_DISPLAY: 'Volvo',
    MODEL_CODE: '760',
    MODEL_DISPLAY: '760',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'VOLVO',
    MAKE_DISPLAY: 'Volvo',
    MODEL_CODE: '780',
    MODEL_DISPLAY: '780',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'VOLVO',
    MAKE_DISPLAY: 'Volvo',
    MODEL_CODE: '940',
    MODEL_DISPLAY: '940',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'VOLVO',
    MAKE_DISPLAY: 'Volvo',
    MODEL_CODE: '960',
    MODEL_DISPLAY: '960',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'VOLVO',
    MAKE_DISPLAY: 'Volvo',
    MODEL_CODE: 'S70',
    MODEL_DISPLAY: 'S70',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'VOLVO',
    MAKE_DISPLAY: 'Volvo',
    MODEL_CODE: 'V90',
    MODEL_DISPLAY: 'V90',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'VOLVO',
    MAKE_DISPLAY: 'Volvo',
    MODEL_CODE: 'V70',
    MODEL_DISPLAY: 'V70',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'VOLVO',
    MAKE_DISPLAY: 'Volvo',
    MODEL_CODE: 'S80',
    MODEL_DISPLAY: 'S80',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'VOLVO',
    MAKE_DISPLAY: 'Volvo',
    MODEL_CODE: 'C70',
    MODEL_DISPLAY: 'C70',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'VOLVO',
    MAKE_DISPLAY: 'Volvo',
    MODEL_CODE: '240',
    MODEL_DISPLAY: '240',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'VOLVO',
    MAKE_DISPLAY: 'Volvo',
    MODEL_CODE: '850',
    MODEL_DISPLAY: '850',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'VOLVO',
    MAKE_DISPLAY: 'Volvo',
    MODEL_CODE: 'VOLOTH',
    MODEL_DISPLAY: 'Other Volvo Models',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'VOLVO',
    MAKE_DISPLAY: 'Volvo',
    MODEL_CODE: 'V40',
    MODEL_DISPLAY: 'V40',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'VOLVO',
    MAKE_DISPLAY: 'Volvo',
    MODEL_CODE: 'S40',
    MODEL_DISPLAY: 'S40',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'VOLVO',
    MAKE_DISPLAY: 'Volvo',
    MODEL_CODE: '260',
    MODEL_DISPLAY: '260',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'VOLVO',
    MAKE_DISPLAY: 'Volvo',
    MODEL_CODE: 'S60',
    MODEL_DISPLAY: 'S60',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'VOLVO',
    MAKE_DISPLAY: 'Volvo',
    MODEL_CODE: 'C30',
    MODEL_DISPLAY: 'C30',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'VOLVO',
    MAKE_DISPLAY: 'Volvo',
    MODEL_CODE: 'S90',
    MODEL_DISPLAY: 'S90',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'VOLVO',
    MAKE_DISPLAY: 'Volvo',
    MODEL_CODE: 'XC90',
    MODEL_DISPLAY: 'XC90',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'VOLVO',
    MAKE_DISPLAY: 'Volvo',
    MODEL_CODE: 'XC60',
    MODEL_DISPLAY: 'XC60',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'YUGO',
    MAKE_DISPLAY: 'Yugo',
    MODEL_CODE: 'GV',
    MODEL_DISPLAY: 'GV',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'YUGO',
    MAKE_DISPLAY: 'Yugo',
    MODEL_CODE: 'GVL',
    MODEL_DISPLAY: 'GVL',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'YUGO',
    MAKE_DISPLAY: 'Yugo',
    MODEL_CODE: 'GVX',
    MODEL_DISPLAY: 'GVX',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: 'YUGO',
    MAKE_DISPLAY: 'Yugo',
    MODEL_CODE: 'YUOTH',
    MODEL_DISPLAY: 'Other Yugo Models',
    CLASS_SERIES_CODE: '',
    CLASS_SERIES_DISPLAY: '',
  },
  {
    MAKE_CODE: '',
  },
]
